/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Agroevidence API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface InternalCenterCreateTo {
  key: string;
  name: string;
}

export interface InternalCenterTo {
  id: string;
  key: string;
  name: string;
}

export interface SeedApplicationV2UpdateTo {
  seedId?: string;
  dateStart?: string;
  dateEnd?: string;
  /** @maximum 100000 */
  areaHa?: number;
  cropUseTypeId?: string;
  isCatchCrop?: boolean;
  mainHarvestableProduct?: string;
}

export type CatalogueRole = typeof CatalogueRole[keyof typeof CatalogueRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CatalogueRole = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
} as const;

export interface CatalogueTo {
  id: string;
  type: CatalogueType;
  role: CatalogueRole;
  canUpdate: boolean;
}

export type CatalogueType = typeof CatalogueType[keyof typeof CatalogueType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CatalogueType = {
  EAGRI: 'EAGRI',
  PPA_SK: 'PPA_SK',
  PRIVATE: 'PRIVATE',
} as const;

export interface ColorTo {
  red: number;
  green: number;
  blue: number;
  asDecimal: number;
}

export interface CropGroupTo {
  /** Crop group legislative id / external id */
  id: string;
  externalId: string;
  name?: string;
  legislativeCode: string;
}

export type CropLifespan = typeof CropLifespan[keyof typeof CropLifespan];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CropLifespan = {
  ANNUAL: 'ANNUAL',
  PERENNIAL: 'PERENNIAL',
} as const;

export interface CropProductTo {
  id: string;
  description: string;
}

export interface CropSeedTo {
  id: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  varietyName?: string;
  crop: CropTo;
  name: string;
}

export interface CropTo {
  id: string;
  name: string;
  externalId: number;
  catalogueType: CatalogueType;
  group?: CropGroupTo;
  validFrom?: string;
  validTo?: string;
  color: ColorTo;
  textColor: ColorTo;
  isNoCrop: boolean;
  isWinterCrop?: boolean;
  isSpringCrop?: boolean;
  lifespan?: CropLifespan;
}

export interface CropUseTypeTo {
  id: string;
  description: string;
}

export type SeedApplicationType = typeof SeedApplicationType[keyof typeof SeedApplicationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SeedApplicationType = {
  CATCH_CROP: 'CATCH_CROP',
  MAIN_CROP: 'MAIN_CROP',
} as const;

export type SeedApplicationV2ToAllOf = {
  id?: string;
  sownArea?: number;
  parcelId?: string;
  groupId?: string;
};

export type SeedApplicationV2To = SeedApplicationV2ResultTo & SeedApplicationV2ToAllOf & Required<Pick<SeedApplicationV2ResultTo & SeedApplicationV2ToAllOf, 'id' | 'parcelId' | 'sownArea'>>;

export interface SeedApplicationV2GroupUpdateTo {
  seedId?: string;
  cropUseTypeId?: string;
  isCatchCrop?: boolean;
  mainHarvestableProduct?: string;
  seedApplications?: SeedApplicationV2MemberUpdateTo[];
}

export interface SeedApplicationV2MemberUpdateTo {
  id: string;
  dateStart?: string;
  dateEnd?: string;
  areaHa?: number;
  groupId?: string;
  deleted: boolean;
}

export type SeedApplicationV2GroupToV2AllOf = {
  groupId?: string;
  seedApplications?: SeedApplicationV2To[];
  parcelIds?: string[];
};

export type SeedApplicationV2GroupToV2 = SeedApplicationV2ResultTo & SeedApplicationV2GroupToV2AllOf & Required<Pick<SeedApplicationV2ResultTo & SeedApplicationV2GroupToV2AllOf, 'groupId' | 'parcelIds' | 'seedApplications'>>;

export interface BatchCropSowingPlanCreate {
  parcelId: string;
  cropId?: string;
  seasonId: string;
}

export interface BulkSowingPlanParcelCropBody {
  parcelCrops: BatchCropSowingPlanCreate[];
}

export interface SowingPlanParcelCropBody {
  cropId?: string;
  seasonId: string;
}

export interface EagriAuthDataValidationRequestTo {
  login: string;
  secret: string;
  szrid: string;
  environment?: EagriServiceEnvironment;
}

export type EagriServiceEnvironment = typeof EagriServiceEnvironment[keyof typeof EagriServiceEnvironment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriServiceEnvironment = {
  PRODUCTION: 'PRODUCTION',
  TEST: 'TEST',
} as const;

export interface EagriAuthDataValidationResponseTo {
  login?: string;
  szrid?: string;
  environment?: EagriServiceEnvironment;
  validation: EagriAuthValidationResultTo;
}

export interface EagriAuthValidationResultTo {
  farmName?: string;
  status: HttpStatus;
  errorCode?: EagriUpdateErrorType;
  eagriCode?: string;
  eagriMessage?: string;
  success: boolean;
}

export type EagriUpdateErrorType = typeof EagriUpdateErrorType[keyof typeof EagriUpdateErrorType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriUpdateErrorType = {
  EAGRI_AUTH_NOT_FOUND: 'EAGRI_AUTH_NOT_FOUND',
  SERVICE_BLOCKED: 'SERVICE_BLOCKED',
  SERVICE_WRONG_ACCESS_KEY_HASH: 'SERVICE_WRONG_ACCESS_KEY_HASH',
  TOO_MANY_UPDATES: 'TOO_MANY_UPDATES',
  TOO_MANY_SEARCHES: 'TOO_MANY_SEARCHES',
  UPDATE_ALREADY_IN_PROGRESS: 'UPDATE_ALREADY_IN_PROGRESS',
  UNEXPECTED_EAGRI_ERROR_WITHOUT_CODE: 'UNEXPECTED_EAGRI_ERROR_WITHOUT_CODE',
  UNEXPECTED_EAGRI_ERROR_WITH_CODE: 'UNEXPECTED_EAGRI_ERROR_WITH_CODE',
  NONPERMISSIBLE_DATE: 'NONPERMISSIBLE_DATE',
  NONEAGRI_FARM: 'NONEAGRI_FARM',
} as const;

export type HttpStatus = typeof HttpStatus[keyof typeof HttpStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HttpStatus = {
  '100_CONTINUE': '100 CONTINUE',
  '101_SWITCHING_PROTOCOLS': '101 SWITCHING_PROTOCOLS',
  '102_PROCESSING': '102 PROCESSING',
  '103_EARLY_HINTS': '103 EARLY_HINTS',
  '103_CHECKPOINT': '103 CHECKPOINT',
  '200_OK': '200 OK',
  '201_CREATED': '201 CREATED',
  '202_ACCEPTED': '202 ACCEPTED',
  '203_NON_AUTHORITATIVE_INFORMATION': '203 NON_AUTHORITATIVE_INFORMATION',
  '204_NO_CONTENT': '204 NO_CONTENT',
  '205_RESET_CONTENT': '205 RESET_CONTENT',
  '206_PARTIAL_CONTENT': '206 PARTIAL_CONTENT',
  '207_MULTI_STATUS': '207 MULTI_STATUS',
  '208_ALREADY_REPORTED': '208 ALREADY_REPORTED',
  '226_IM_USED': '226 IM_USED',
  '300_MULTIPLE_CHOICES': '300 MULTIPLE_CHOICES',
  '301_MOVED_PERMANENTLY': '301 MOVED_PERMANENTLY',
  '302_FOUND': '302 FOUND',
  '302_MOVED_TEMPORARILY': '302 MOVED_TEMPORARILY',
  '303_SEE_OTHER': '303 SEE_OTHER',
  '304_NOT_MODIFIED': '304 NOT_MODIFIED',
  '305_USE_PROXY': '305 USE_PROXY',
  '307_TEMPORARY_REDIRECT': '307 TEMPORARY_REDIRECT',
  '308_PERMANENT_REDIRECT': '308 PERMANENT_REDIRECT',
  '400_BAD_REQUEST': '400 BAD_REQUEST',
  '401_UNAUTHORIZED': '401 UNAUTHORIZED',
  '402_PAYMENT_REQUIRED': '402 PAYMENT_REQUIRED',
  '403_FORBIDDEN': '403 FORBIDDEN',
  '404_NOT_FOUND': '404 NOT_FOUND',
  '405_METHOD_NOT_ALLOWED': '405 METHOD_NOT_ALLOWED',
  '406_NOT_ACCEPTABLE': '406 NOT_ACCEPTABLE',
  '407_PROXY_AUTHENTICATION_REQUIRED': '407 PROXY_AUTHENTICATION_REQUIRED',
  '408_REQUEST_TIMEOUT': '408 REQUEST_TIMEOUT',
  '409_CONFLICT': '409 CONFLICT',
  '410_GONE': '410 GONE',
  '411_LENGTH_REQUIRED': '411 LENGTH_REQUIRED',
  '412_PRECONDITION_FAILED': '412 PRECONDITION_FAILED',
  '413_PAYLOAD_TOO_LARGE': '413 PAYLOAD_TOO_LARGE',
  '413_REQUEST_ENTITY_TOO_LARGE': '413 REQUEST_ENTITY_TOO_LARGE',
  '414_URI_TOO_LONG': '414 URI_TOO_LONG',
  '414_REQUEST_URI_TOO_LONG': '414 REQUEST_URI_TOO_LONG',
  '415_UNSUPPORTED_MEDIA_TYPE': '415 UNSUPPORTED_MEDIA_TYPE',
  '416_REQUESTED_RANGE_NOT_SATISFIABLE': '416 REQUESTED_RANGE_NOT_SATISFIABLE',
  '417_EXPECTATION_FAILED': '417 EXPECTATION_FAILED',
  '418_I_AM_A_TEAPOT': '418 I_AM_A_TEAPOT',
  '419_INSUFFICIENT_SPACE_ON_RESOURCE': '419 INSUFFICIENT_SPACE_ON_RESOURCE',
  '420_METHOD_FAILURE': '420 METHOD_FAILURE',
  '421_DESTINATION_LOCKED': '421 DESTINATION_LOCKED',
  '422_UNPROCESSABLE_ENTITY': '422 UNPROCESSABLE_ENTITY',
  '423_LOCKED': '423 LOCKED',
  '424_FAILED_DEPENDENCY': '424 FAILED_DEPENDENCY',
  '425_TOO_EARLY': '425 TOO_EARLY',
  '426_UPGRADE_REQUIRED': '426 UPGRADE_REQUIRED',
  '428_PRECONDITION_REQUIRED': '428 PRECONDITION_REQUIRED',
  '429_TOO_MANY_REQUESTS': '429 TOO_MANY_REQUESTS',
  '431_REQUEST_HEADER_FIELDS_TOO_LARGE': '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
  '451_UNAVAILABLE_FOR_LEGAL_REASONS': '451 UNAVAILABLE_FOR_LEGAL_REASONS',
  '500_INTERNAL_SERVER_ERROR': '500 INTERNAL_SERVER_ERROR',
  '501_NOT_IMPLEMENTED': '501 NOT_IMPLEMENTED',
  '502_BAD_GATEWAY': '502 BAD_GATEWAY',
  '503_SERVICE_UNAVAILABLE': '503 SERVICE_UNAVAILABLE',
  '504_GATEWAY_TIMEOUT': '504 GATEWAY_TIMEOUT',
  '505_HTTP_VERSION_NOT_SUPPORTED': '505 HTTP_VERSION_NOT_SUPPORTED',
  '506_VARIANT_ALSO_NEGOTIATES': '506 VARIANT_ALSO_NEGOTIATES',
  '507_INSUFFICIENT_STORAGE': '507 INSUFFICIENT_STORAGE',
  '508_LOOP_DETECTED': '508 LOOP_DETECTED',
  '509_BANDWIDTH_LIMIT_EXCEEDED': '509 BANDWIDTH_LIMIT_EXCEEDED',
  '510_NOT_EXTENDED': '510 NOT_EXTENDED',
  '511_NETWORK_AUTHENTICATION_REQUIRED': '511 NETWORK_AUTHENTICATION_REQUIRED',
} as const;

export type EagriFullFarmUpdateMode = typeof EagriFullFarmUpdateMode[keyof typeof EagriFullFarmUpdateMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriFullFarmUpdateMode = {
  DRY: 'DRY',
  BLOCKS: 'BLOCKS',
  BLOCKS_AND_PARCELS: 'BLOCKS_AND_PARCELS',
  ALL: 'ALL',
  SEED_APPS_V2: 'SEED_APPS_V2',
  BLOCKS_AND_PARCELS_V2: 'BLOCKS_AND_PARCELS_V2',
} as const;

export interface PlantProtectionActiveSubstanceCreateTo {
  activeSubstanceId: string;
  amountPerArea?: string;
  unit?: string;
}

export interface PlantProtectionCreateUpdateTo {
  name: string;
  usableUntil?: string;
  bioFunction?: string;
  isEco: boolean;
  activeSubstances?: PlantProtectionActiveSubstanceCreateTo[];
  notes?: string;
  isFavorite: boolean;
  externalId?: string;
}

export interface ActiveSubstanceTo {
  id: string;
  externalId?: string;
  name: string;
  nameEn?: string;
  catalogue: CatalogueTo;
  isIntegratedProductionVineyard: boolean;
  isIntegratedProductionOrchard: boolean;
  isIntegratedProductionVegetable: boolean;
}

export interface PlantProtectionDetailTo {
  id: string;
  name: string;
  isEco: boolean;
  externalId?: string;
  usableUntil?: string;
  note?: string;
  catalogue: CatalogueTo;
  bioFunction?: string;
  registrations?: PlantProtectionRegistrationDataTo[];
  activeSubstances?: ActiveSubstanceTo[];
  isFavorite: boolean;
}

export interface PlantProtectionRegistrationDataTo {
  id: string;
  externalId?: string;
  registrationHolder?: string;
}

export type ApplicationBufferType = typeof ApplicationBufferType[keyof typeof ApplicationBufferType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationBufferType = {
  Boundary: 'Boundary',
  BoundarySpring: 'BoundarySpring',
  BoundaryAutumn: 'BoundaryAutumn',
  BoundaryPreEmergent: 'BoundaryPreEmergent',
  BoundaryPostEmergent: 'BoundaryPostEmergent',
  Water: 'Water',
  WaterSpring: 'WaterSpring',
  WaterAutumn: 'WaterAutumn',
  WaterPreEmergent: 'WaterPreEmergent',
  WaterPostEmergent: 'WaterPostEmergent',
  SlopeWater: 'SlopeWater',
  SlopeVegetationStrip: 'SlopeVegetationStrip',
  Other: 'Other',
  SurfaceWaterProtectionZones: 'SurfaceWaterProtectionZones',
  GroundWaterProtectionZones: 'GroundWaterProtectionZones',
  PopulationProtectionZones: 'PopulationProtectionZones',
  Landscape: 'Landscape',
} as const;

export interface PlantProtectionApplicationCreateTo {
  id?: string;
  maxDose?: number;
  minDose?: number;
  unit?: string;
  maxDoseWater?: number;
  minDoseWater?: number;
  unitWater?: string;
  minBbch?: number;
  maxBbch?: number;
  allowedApplications?: number;
  minInterval?: number;
  maxInterval?: number;
  protectionPeriod?: number;
  isAerialApplication?: boolean;
  isSeedTreatment?: boolean;
  cropId?: string;
  cropGroupId?: string;
  organismId?: string;
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  notes?: string;
}

export interface PlantProtectionRegistrationApplicationBufferTo {
  type: ApplicationBufferType;
  driftReduction?: number;
  isAllowed: boolean;
  buffer?: number;
  protectionLevel?: number;
}

export interface EagriFertilizerKindTo {
  id: number;
  name?: string;
}

export type EagriFertilizerNitrogenCategory = typeof EagriFertilizerNitrogenCategory[keyof typeof EagriFertilizerNitrogenCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriFertilizerNitrogenCategory = {
  NON_NITROUS: 'NON_NITROUS',
  MINERAL: 'MINERAL',
  QUICK_RELEASE: 'QUICK_RELEASE',
  SLOW_RELEASE: 'SLOW_RELEASE',
  SLUDGE: 'SLUDGE',
  PLANT_RESIDUES: 'PLANT_RESIDUES',
  SEDIMENTS: 'SEDIMENTS',
  EXCIPIENTS: 'EXCIPIENTS',
} as const;

export interface EagriFertilizerNitrogenCategoryTo {
  code: EagriFertilizerNitrogenCategory;
  name?: string;
}

export interface EagriFertilizerPropertiesCreateTo {
  eagriId?: number;
  registrationNumber: string;
  evidenceNumber: string;
  applicantTradeName?: string;
  isExcrement: boolean;
  nitrogenCategory: EagriFertilizerNitrogenCategoryTo;
  nitrogenCoefficient: number;
  sort?: string;
  registrationType: EagriFertilizerRegistrationTypeTo;
  price?: number;
  fertilizerKind: EagriFertilizerKindTo;
  isEco: boolean;
  validFrom?: string;
  validTo?: string;
  ordinance?: string;
}

export interface EagriFertilizerRegistrationTypeTo {
  code: string;
  name?: string;
}

export interface FertilizerCreateTo {
  name: string;
  description?: string;
  producerTradeName?: string;
  isHidden: boolean;
  isOrganic: boolean;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  na2o: number;
  s: number;
  chlorides: number;
  combustibleContent: number;
  zn: number;
  cu: number;
  fe: number;
  b: number;
  mn: number;
  mo: number;
  se: number;
  phFrom: number;
  phTo: number;
  electricConductivity: number;
  unitType: UnitType;
  /** Volume to mass conversion coefficient, used only when unit is in volume units (m3, l) */
  unitConversionCoefficient: number;
  eagriProperties?: EagriFertilizerPropertiesCreateTo;
}

export type UnitType = typeof UnitType[keyof typeof UnitType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnitType = {
  WEIGHT: 'WEIGHT',
  VOLUME: 'VOLUME',
} as const;

export interface EagriFertilizerPropertiesDetailTo {
  eagriId?: number;
  registrationNumber?: string;
  evidenceNumber?: string;
  applicantTradeName?: string;
  isExcrement: boolean;
  nitrogenCategory: EagriFertilizerNitrogenCategoryTo;
  nitrogenCoefficient: number;
  sort?: string;
  isValid: boolean;
  registrationType?: EagriFertilizerRegistrationTypeTo;
  price?: number;
  fertilizerType?: string;
  fertilizerKind?: EagriFertilizerKindTo;
  isEco: boolean;
  validFrom?: string;
  validTo?: string;
  ordinance?: string;
}

export interface FertilizerDetailTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  producerTradeName?: string;
  description?: string;
  isOrganic: boolean;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  na2o: number;
  s: number;
  chlorides: number;
  combustibleContent: number;
  zn: number;
  cu: number;
  fe: number;
  b: number;
  mn: number;
  mo: number;
  se: number;
  phFrom: number;
  phTo: number;
  electricConductivity: number;
  unitType: UnitType;
  unitConversionCoefficient: number;
  eagriProperties?: EagriFertilizerPropertiesDetailTo;
}

export interface CropProductUseTypeUpdateTo {
  productId: string;
  isMainProduct?: boolean;
  cropUseTypeId?: string;
  dryMatter?: number;
  nutrientConsumption?: NutrientConsumptionTo[];
  secondaryProductRatio?: number;
}

export interface NutrientConsumptionTo {
  type: NutrientType;
  value: number;
}

export type NutrientType = typeof NutrientType[keyof typeof NutrientType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NutrientType = {
  NITROGEN: 'NITROGEN',
  PHOSPHORUS: 'PHOSPHORUS',
  POTASSIUM: 'POTASSIUM',
} as const;

export interface CropProductUpdateTo {
  externalId?: string;
  name: string;
  isMain: boolean;
  validFrom?: string;
  validTo?: string;
  secondaryProductId?: string;
}

export interface CropUseTypeUpdateTo {
  externalId?: string;
  name: string;
  validFrom?: string;
  validTo?: string;
}

export interface SkeagisFarmUpdateResult {
  farmId: string;
  parcelUpdateResult: SkeagisParcelUpdateResult;
}

export interface SkeagisParcelUpdateResult {
  retiredParcels: string[];
  newParcels: string[];
  changedParcels: string[];
}

export interface ParcelGeometryOverwrite {
  parcelId: string;
  oldGeometryWkt: string;
  newGeometryWkt: string;
  differenceHa: number;
  validity: string;
}

export interface ParcelGeometryOverwriteResult {
  changes: ParcelGeometryOverwrite[];
}

export type AdminFarmUpdateToSettings = {[key: string]: boolean};

export interface AdminFarmUpdateTo {
  name?: string;
  isVisibleInPublicLayers?: boolean;
  settings?: AdminFarmUpdateToSettings;
}

export interface AdminFarmSettingsTo {
  eagriSettingsEnabled: boolean;
  shpSettingsEnabled: boolean;
  seedApplicationsV2Enabled: boolean;
}

export interface AdminFarmTo {
  id: string;
  name?: string;
  countryCode?: string;
  source: InternalFarmImportSource;
  integrationSource?: FarmIntegrationSource;
  isVisibleInPublicLayers: boolean;
  settings: AdminFarmSettingsTo;
}

export type FarmIntegrationSource = typeof FarmIntegrationSource[keyof typeof FarmIntegrationSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmIntegrationSource = {
  EAGRI: 'EAGRI',
  SKEAGIS: 'SKEAGIS',
} as const;

export type InternalFarmImportSource = typeof InternalFarmImportSource[keyof typeof InternalFarmImportSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalFarmImportSource = {
  EMPTY_FARM: 'EMPTY_FARM',
  EAGRI: 'EAGRI',
  SHP: 'SHP',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface FarmSkeagisUpdateRequest {
  skeagisUserId?: string;
  state: IntegrationState;
  validFrom: string;
}

export type IntegrationState = typeof IntegrationState[keyof typeof IntegrationState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntegrationState = {
  DISABLED: 'DISABLED',
  ACTIVE: 'ACTIVE',
} as const;

export interface FarmIntegrationResponse {
  state: string;
  validFrom: string;
  source: FarmManagementIntegrationSource;
}

export type FarmManagementIntegrationSource = typeof FarmManagementIntegrationSource[keyof typeof FarmManagementIntegrationSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmManagementIntegrationSource = {
  SKEAGIS: 'SKEAGIS',
} as const;

export interface ActionExpenseTo {
  id?: string;
  amount: number;
  unit: string;
  dosePerHa: number;
  notes?: string;
  cropGrowthStage?: CropGrowthStage;
}

export interface ActionParcelCreateTo {
  parcelId: string;
  restrictions?: RestrictionTo[];
}

export type ActionSource = typeof ActionSource[keyof typeof ActionSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionSource = {
  TELEMATICS: 'TELEMATICS',
  MANUAL: 'MANUAL',
  EAGRI: 'EAGRI',
  SKEAGIS: 'SKEAGIS',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface ActionSowingCreateV2To {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  seedExpense: Seed;
  seedApplicationType: SeedApplicationType;
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
  cropUseId?: string;
  cropProductId?: string;
}

export type CropGrowthStage = typeof CropGrowthStage[keyof typeof CropGrowthStage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CropGrowthStage = {
  PREEMERGENT: 'PREEMERGENT',
  POSTEMERGENT: 'POSTEMERGENT',
  SPRING: 'SPRING',
  AUTUMN: 'AUTUMN',
} as const;

export interface RestrictionTo {
  type: RestrictionType;
  value?: number;
  /** Protection level for ground water or surface water */
  protectionLevel?: number;
  isIgnored?: boolean;
}

export type RestrictionType = typeof RestrictionType[keyof typeof RestrictionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RestrictionType = {
  Absolute: 'Absolute',
  Boundary: 'Boundary',
  BoundarySpring: 'BoundarySpring',
  BoundaryAutumn: 'BoundaryAutumn',
  BoundaryPreEmergent: 'BoundaryPreEmergent',
  BoundaryPostEmergent: 'BoundaryPostEmergent',
  Water: 'Water',
  WaterSpring: 'WaterSpring',
  WaterAutumn: 'WaterAutumn',
  WaterPreEmergent: 'WaterPreEmergent',
  WaterPostEmergent: 'WaterPostEmergent',
  SlopeVegetationStrip: 'SlopeVegetationStrip',
  GroundWaterProtectionZones: 'GroundWaterProtectionZones',
  SurfaceWaterProtectionZones: 'SurfaceWaterProtectionZones',
  PopulationProtectionZones: 'PopulationProtectionZones',
  Landscape: 'Landscape',
  SlopeWater: 'SlopeWater',
} as const;

export interface Seed {
  actionMaterial: SeedMat;
  actionExpense?: ActionExpenseTo;
  materialId?: string;
}

export interface SeedMat {
  id?: string;
  materialId: string;
}

export interface ActionIdTo {
  actionId: string;
}

export interface ActionMowingCreateV2To {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  revenue: RevenueCreateTo;
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export interface RevenueCreateTo {
  amount: number;
  isMainProduct: boolean;
  cropProductId?: string;
}

export interface ActionHarvestCreateV2To {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  revenues: RevenueCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export interface ActionEPHCreateV2To {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  /**
   * Deprecated. Target crop is determined automatically from seed application. Will be removed in a future version.
   * @deprecated
   */
  targetCropId?: string;
  isStrawDecay: boolean;
  fertilizers: Eph[];
  plantProtections: ExpensePlantProtectionCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export type DriftClass = typeof DriftClass[keyof typeof DriftClass];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriftClass = {
  DRIFT_90: 'DRIFT_90',
  DRIFT_75: 'DRIFT_75',
  DRIFT_50: 'DRIFT_50',
  DRIFT_NONE: 'DRIFT_NONE',
} as const;

export interface Eph {
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
  materialId?: string;
}

export interface EPHMat {
  id?: string;
  materialId: string;
  dateSoilIncorporation?: string;
  driftClass?: DriftClass;
}

export interface ExpensePlantProtectionCreateTo {
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
  targetOrganismsIds?: string[];
  parcelPlantProtectionEffectiveness: ParcelPlantProtectionEffectivenessTo[];
}

export interface ParcelPlantProtectionEffectivenessTo {
  parcelId: string;
  effectiveness: PlantProtectionEffectiveness;
}

export type PlantProtectionEffectiveness = typeof PlantProtectionEffectiveness[keyof typeof PlantProtectionEffectiveness];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlantProtectionEffectiveness = {
  YES: 'YES',
  NO: 'NO',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
} as const;

export interface ActionSowingCreateTo {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  seedExpense: Seed;
  seedApplicationType: SeedApplicationType;
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
  cropUseId?: string;
  cropProductId?: string;
}

export interface InternalActionIdResponse {
  id: string;
}

export interface ActionOtherCreateTo {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  actionType: ActionType;
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export type ActionType = typeof ActionType[keyof typeof ActionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionType = {
  PLOW: 'PLOW',
  TILLAGE: 'TILLAGE',
  SOWING: 'SOWING',
  SOWING_PERENNIAL: 'SOWING_PERENNIAL',
  MOWING: 'MOWING',
  HARVEST: 'HARVEST',
  SPRAY: 'SPRAY',
  SPREADING_PEST: 'SPREADING_PEST',
  FERT: 'FERT',
  LIMING: 'LIMING',
  FERT_ORG: 'FERT_ORG',
  FERT_IND: 'FERT_IND',
  TANKMIX: 'TANKMIX',
  HOE: 'HOE',
  TRANSPORT: 'TRANSPORT',
  PREP: 'PREP',
  PASTURE: 'PASTURE',
  DISK: 'DISK',
  HARROW: 'HARROW',
  ROLL: 'ROLL',
  IRRIG: 'IRRIG',
  HILL: 'HILL',
  CULTIV: 'CULTIV',
  FOLIAR: 'FOLIAR',
  MULCHING: 'MULCHING',
  SUBSOILING: 'SUBSOILING',
  RAKING: 'RAKING',
  REVERSAL: 'REVERSAL',
  CRUSHING: 'CRUSHING',
  SKIDDING: 'SKIDDING',
  SUB_PLOWING: 'SUB_PLOWING',
  PLOUGHING: 'PLOUGHING',
  COMPACTING: 'COMPACTING',
} as const;

export interface ActionMowingCreateTo {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  revenue: RevenueCreateTo;
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export interface ActionHarvestCreateTo {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  revenues: RevenueCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export interface ActionEPHCreateTo {
  id?: string;
  note?: string;
  date: string;
  parcels: ActionParcelCreateTo[];
  targetCropId: string;
  isStrawDecay: boolean;
  fertilizers: Eph[];
  plantProtections: ExpensePlantProtectionCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /** Time of the action in ISO-8601 format */
  time?: string;
}

export interface GetInternalPlantProtectionMaterialBody {
  ids?: string[];
  name?: string;
}

export type InternalFertilizerToAllOf = {
  volumeToWeightCoefficient?: number;
  n?: number;
  p2o5?: number;
  k2o?: number;
  mgo?: number;
  cao?: number;
  s?: number;
};

export type InternalFertilizerTo = InternalMaterialTo & InternalFertilizerToAllOf & Required<Pick<InternalMaterialTo & InternalFertilizerToAllOf, 'cao' | 'k2o' | 'mgo' | 'n' | 'p2o5' | 's' | 'volumeToWeightCoefficient'>>;

export interface InternalMaterialTo {
  name?: string;
  id: string;
  type: MaterialType;
  validFrom?: string;
  externalId?: number;
  validTo?: string;
  isFavourite: boolean;
}

export type InternalMaterialToBase = InternalMaterialTo;

export type MaterialType = typeof MaterialType[keyof typeof MaterialType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaterialType = {
  FERTILIZER: 'FERTILIZER',
  PLANT_PROTECTION: 'PLANT_PROTECTION',
  SEED: 'SEED',
} as const;

export type ParcelStatus = typeof ParcelStatus[keyof typeof ParcelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParcelStatus = {
  OPEN: 'OPEN',
  RETIRED: 'RETIRED',
} as const;

export interface GeoJsonMultiPoint {
  coordinates: number[][];
  type: GeoJsonType;
}

export type GeoJsonType = typeof GeoJsonType[keyof typeof GeoJsonType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GeoJsonType = {
  Point: 'Point',
  PointZ: 'PointZ',
  MultiPoint: 'MultiPoint',
  LinearRing: 'LinearRing',
  LineString: 'LineString',
  MultiLineString: 'MultiLineString',
  Polygon: 'Polygon',
  MultiPolygon: 'MultiPolygon',
  GeometryCollection: 'GeometryCollection',
} as const;

export interface GeoJsonMultiPolygon {
  coordinates: number[][][][];
  type: GeoJsonType;
  isEmpty: boolean;
}

export interface InternalCropProductTo {
  id: string;
  externalId: number;
  description: string;
}

export type InternalLandUse = typeof InternalLandUse[keyof typeof InternalLandUse];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalLandUse = {
  ARABLE: 'ARABLE',
  HOPFIELD: 'HOPFIELD',
  VINEYARD: 'VINEYARD',
  OTHER_PERMANENT: 'OTHER_PERMANENT',
  ORCHARD: 'ORCHARD',
  GRASS: 'GRASS',
  OTHER: 'OTHER',
  SET_ASIDE: 'SET_ASIDE',
  FODDER: 'FODDER',
  UNPRODUCTIVE: 'UNPRODUCTIVE',
  MULTIPLE_CROPS: 'MULTIPLE_CROPS',
  TRUFFLES: 'TRUFFLES',
  CONTAINERS: 'CONTAINERS',
  NURSERY: 'NURSERY',
  VEGETABLES: 'VEGETABLES',
  POND: 'POND',
  FAST_GROW: 'FAST_GROW',
  WOODED: 'WOODED',
} as const;

export interface InternalParcelTo {
  id: string;
  name: string;
  blockNumber: string;
  square?: string;
  geometry?: GeoJsonMultiPolygon;
  area?: number;
  countyUnitId?: number;
  countyName?: string;
  cropLegislativeCode?: number;
  cropInternalId?: string;
  cropName?: string;
  cropSeedAppType: InternalSeedApplicationType;
  harvestProduct?: InternalCropProductTo;
  centerKey?: string;
  validFrom?: string;
  validTo?: string;
  landUse: InternalLandUse;
}

export type InternalSeedApplicationType = typeof InternalSeedApplicationType[keyof typeof InternalSeedApplicationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalSeedApplicationType = {
  CATCH_CROP: 'CATCH_CROP',
  MAIN_CROP: 'MAIN_CROP',
} as const;

export interface InternalIntersectionParcelTo {
  parcelId: string;
  farmId: string;
  name: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
}

export interface InternalActionInfoRequestBodyTo {
  actionMaterials: InternalActionInfoRequestTo[];
}

export interface InternalActionInfoRequestTo {
  actionId: string;
  materialId: string;
}

export type LocalLanguage = typeof LocalLanguage[keyof typeof LocalLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalLanguage = {
  EN: 'EN',
  CZ: 'CZ',
  SRB: 'SRB',
  ES: 'ES',
  RU: 'RU',
  GR: 'GR',
  RO: 'RO',
  HU: 'HU',
  PL: 'PL',
  LT: 'LT',
  SK: 'SK',
} as const;

export interface InternalActionInfo {
  actionId: string;
  materialId: string;
  note: string;
  unitId: string;
  dosePerHa: number;
}

export interface InternalActionParcelCreate {
  parcelId: string;
  subtractionAreaHa?: number;
}

export type InternalActionType = typeof InternalActionType[keyof typeof InternalActionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalActionType = {
  PLOW: 'PLOW',
  TILLAGE: 'TILLAGE',
  SOWING: 'SOWING',
  SOWING_PERENNIAL: 'SOWING_PERENNIAL',
  MOWING: 'MOWING',
  HARVEST: 'HARVEST',
  SPRAY: 'SPRAY',
  SPREADING_PEST: 'SPREADING_PEST',
  FERT: 'FERT',
  LIMING: 'LIMING',
  FERT_ORG: 'FERT_ORG',
  FERT_IND: 'FERT_IND',
  TANKMIX: 'TANKMIX',
  HOE: 'HOE',
  TRANSPORT: 'TRANSPORT',
  PREP: 'PREP',
  PASTURE: 'PASTURE',
  DISK: 'DISK',
  HARROW: 'HARROW',
  ROLL: 'ROLL',
  IRRIG: 'IRRIG',
  HILL: 'HILL',
  CULTIV: 'CULTIV',
  FOLIAR: 'FOLIAR',
  MULCHING: 'MULCHING',
  SUBSOILING: 'SUBSOILING',
  RAKING: 'RAKING',
  REVERSAL: 'REVERSAL',
  CRUSHING: 'CRUSHING',
  SKIDDING: 'SKIDDING',
  SUB_PLOWING: 'SUB_PLOWING',
  PLOUGHING: 'PLOUGHING',
  COMPACTING: 'COMPACTING',
} as const;

export interface InternalTelematicsActionCreate {
  date: string;
  /** Time in ISO-8601 format */
  time?: string;
  parcels: InternalActionParcelCreate[];
  actionType: InternalActionType;
  targetCropExternalId?: string;
}

export interface SeedApplicationV2CreateTo {
  parcelId: string;
  seedId?: string;
  dateStart: string;
  dateEnd?: string;
  /** @maximum 100000 */
  areaHa: number;
  cropUseTypeId?: string;
  isCatchCrop: boolean;
  mainHarvestableProduct?: string;
  groupId?: string;
}

export interface SeedApplicationV2GroupCreateTo {
  seedId?: string;
  cropUseTypeId?: string;
  isCatchCrop?: boolean;
  mainHarvestableProduct?: string;
  seedApplications: SeedApplicationV2GroupMemberCreateTo[];
}

export interface SeedApplicationV2GroupMemberCreateTo {
  id: string;
  dateStart?: string;
  dateEnd?: string;
  areaHa?: number;
  groupId?: string;
}

export interface Aplikace {
  typ: string;
  idPestovani?: string;
  nazevObjekt?: string;
  datAplikace: string;
  idPlodina?: number;
  rozsahAplikace: number;
  mernaJednotkaObjekt: string;
  idPor?: number;
  nazevPor?: string;
  davka: number;
  mernaJednotkaPor: string;
  idSkodlivyOrganismus?: number;
  idSkodlivyOrganismusPPP?: number;
  nazevSkodlivyOrganismus?: string;
  tankmix?: boolean;
  ucinnostAplikace?: boolean;
}

export interface Applications {
  aplikace: Aplikace[];
}

export interface Osev {
  zkod: string;
  ctverec: string;
  idPozemek: string;
  nazevPozemek?: string;
  platnostOd: string;
  platnostDo?: string;
  vymery: Vymery[];
  pestovani: Pestovani[];
}

export interface Osevy {
  osev: Osev[];
}

export interface Pestovani {
  idPestovani: string;
  idPlodina?: number;
  viceleta?: boolean;
  hospRok?: number;
  typPlodiny?: string;
  zahajeniPestovani: string;
  ukonceniPestovani?: string;
  platnostOd: string;
  platnostDo?: string;
}

export interface PorUseBody {
  obdobiOd: string;
  obdobiDo: string;
  osevy: Osevy;
  aplikace?: Applications;
}

export interface Vymery {
  vymera: number;
  platnostOd: string;
  platnostDo?: string;
}

export type EagriFertilizerUseReportCallMode = typeof EagriFertilizerUseReportCallMode[keyof typeof EagriFertilizerUseReportCallMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriFertilizerUseReportCallMode = {
  PRODUCTION: 'PRODUCTION',
  TEST: 'TEST',
} as const;

export type EagriFertilizerUseReportType = typeof EagriFertilizerUseReportType[keyof typeof EagriFertilizerUseReportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriFertilizerUseReportType = {
  STATISTICS: 'STATISTICS',
  CHECK: 'CHECK',
  BALANCE: 'BALANCE',
} as const;

export interface EagriReportBody {
  from: string;
  to: string;
  type: EagriFertilizerUseReportType;
  callMode?: EagriFertilizerUseReportCallMode;
}

export interface FertilizerUseReportMissingDataBodyV2 {
  seedApplicationIdsMissingUsage: string[];
}

export interface MissingDataV2 {
  detailedMessage: FertilizerUseReportMissingDataBodyV2;
  status: number;
  error: string;
  detail: string;
  trace?: string;
}

export type InvalidDateRangeDetailedMessage = { [key: string]: unknown };

export interface InvalidDateRange {
  status: number;
  error: string;
  detail: string;
  trace?: string;
  detailedMessage?: InvalidDateRangeDetailedMessage;
}

export interface EagriReportResponse {
  guid: string;
}

export interface Applcations {
  aplikace: Aplikace[];
}

export interface FertiliserUseBody {
  typ: string;
  obdobiOd?: string;
  obdobiDo?: string;
  hospRok?: number;
  rezimVolani?: string;
  rozsahDat?: RozsahDats;
  osevy: Osevy;
  aplikace?: Applcations;
  sklizne?: Sklizne;
  pastvy?: Pastvy;
}

export interface Pastva {
  idPozemek: string;
  idDruhZvirat: string;
  idKategorieZvirat?: number;
  vlastniKategorieZvirat?: string;
  pocetKs: number;
  pocetDJ: number;
  pastvaOd: string;
  pastvaDo: string;
  pocetHodPastva?: number;
  vymeraPastvy?: number;
  mnozstviHa?: number;
  mernaJednotka?: string;
  idHnojivo?: number;
  nazevHnojivo?: string;
  metodaZivin?: string;
  privodN?: number;
  privodP?: number;
  privodK?: number;
}

export interface Pastvy {
  pastva: Pastva[];
}

export interface RozsahDat {
  kod: string;
}

export interface RozsahDats {
  rozsahDat: RozsahDat[];
}

export interface Sklizen {
  idPestovani: string;
  idProdukt?: number;
  typProduktu?: string;
  hospRok?: number;
  vymeraSklizne: number;
  mnozstviCelkem?: number;
  mnozstviHa?: number;
  mernaJednotka: string;
  susina?: number;
}

export interface Sklizne {
  sklizen: Sklizen[];
}

export interface SowingPlanSeasonTo {
  id: string;
  startYear: number;
  endYear: number;
}

export interface ActionTypeTo {
  code: ActionType;
  name: string;
}

export interface ParcelNameResponse {
  id: string;
  name: string;
}

export interface PorUseReportMissingDataBody {
  actionIdsMissingTargetCrop: PorValidationErrorActionResponse[];
  actionsWithInvalidUnit: PorValidationErrorActionResponse[];
  actionsWithInvalidOrganisms: PorValidationErrorActionResponse[];
  actionsWithInvalidEffectiveness: PorValidationErrorActionResponse[];
}

export interface PorValidationErrorActionResponse {
  actionId: string;
  date: string;
  actionType: ActionTypeTo;
  targetCrop?: CropTo;
  materials: PorValidationErrorMaterialResponse[];
}

export interface PorValidationErrorMaterialResponse {
  materialId: string;
  name: string;
  unit: string;
  totalDose: number;
  dosePerHa: number;
  parcels?: ParcelNameResponse[];
}

export interface ValidationError {
  detailedMessage: PorUseReportMissingDataBody;
  status: number;
  error: string;
  detail: string;
  trace?: string;
}

export type ReportIsAlreadyRunningDetailedMessage = { [key: string]: unknown };

export interface ReportIsAlreadyRunning {
  farmId?: string;
  type?: ReportType;
  status: number;
  error: string;
  detail: string;
  trace?: string;
  detailedMessage?: ReportIsAlreadyRunningDetailedMessage;
}

export type ReportType = typeof ReportType[keyof typeof ReportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportType = {
  POR_USE: 'POR_USE',
  FERTILIZER_USE: 'FERTILIZER_USE',
} as const;

export type EagriReportErrorDetailedMessage = { [key: string]: unknown };

export interface EagriReportError {
  status: number;
  error: string;
  detail: string;
  trace?: string;
  detailedMessage?: EagriReportErrorDetailedMessage;
}

export interface FlatPlantProtectionMinimalTo {
  actionId: string;
  parcelId: string;
  materialName: string;
  date: string;
  targetCropName: string;
  actionType: ActionType;
}

export interface PairedPlantProtectionTo {
  plantProtection: FlatPlantProtectionMinimalTo;
  seedApplication: SeedApplicationMinimalTo;
}

export type PlantProtectionPairingResultToAllItem = { [key: string]: unknown };

export interface PlantProtectionPairingResultTo {
  paired: PairedPlantProtectionTo[];
  pairedOnFollowing: PairedPlantProtectionTo[];
  notPaired: FlatPlantProtectionMinimalTo[];
  sendedSeedApplications: SeedApplicationMinimalTo[];
  all: PlantProtectionPairingResultToAllItem[];
}

export interface SeedApplicationMinimalTo {
  seedAppStart: string;
  seedAppEnd?: string;
  parcelId: string;
  startSeedAppId: string;
  seedExternalId?: string;
  endActionId?: string;
  seedName: string;
  seedId: string;
  parcelName?: string;
  parcelExternalId?: string;
}

export interface FertilizerUseReportMissingDataBody {
  actionIdsMissingUsage: string[];
}

export interface MissingData {
  detailedMessage: FertilizerUseReportMissingDataBody;
  status: number;
  error: string;
  detail: string;
  trace?: string;
}

export interface FarmTo {
  id: string;
  code: string;
  name?: string;
  countryCode: string;
  timeZone: string;
  createdOn?: string;
  createdBy?: string;
  boundingBox?: GeoJsonPolygon;
}

export interface GeoJsonPolygon {
  coordinates: number[][][];
  type: GeoJsonType;
  isEmpty: boolean;
}

export type EagriImportMode = typeof EagriImportMode[keyof typeof EagriImportMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriImportMode = {
  BLOCKS: 'BLOCKS',
  BLOCKS_AND_PARCELS: 'BLOCKS_AND_PARCELS',
  ALL: 'ALL',
  SEED_APPS_V2: 'SEED_APPS_V2',
  BLOCKS_AND_PARCELS_V2: 'BLOCKS_AND_PARCELS_V2',
} as const;

export interface SubtractionTo {
  type: RestrictionType;
  value?: number;
  protectionLevel?: number;
  area: number;
  isIgnored?: boolean;
}

export interface ZoneCreateTo {
  name: string;
}

export interface ZoneDetailTo {
  id: string;
  name: string;
  parcelCount: number;
  totalArea: number;
}

export interface ParcelVegetationStripRequest {
  parcelId: string;
  requiredWaterDistance: number;
}

export interface ParcelVegetationStripResponse {
  parcelId: string;
  requiredWaterDistance: number;
  isSufficient: boolean;
}

export interface MaterialApplicationRestrictionTo {
  plantProtectionId: string;
  targetOrganismIds: string[];
  targetCropId: string;
  driftClass: DriftClass;
}

/**
 * All parcels for action have to be sent. Even if there is no restriction for them.
 */
export interface ParcelRecountSubtractionTo {
  parcelId: string;
  restrictions: RecountSubtractionTo[];
}

export interface RecountSubtractionRequest {
  /** All parcels for action have to be sent. Even if there is no restriction for them. */
  restrictions: ParcelRecountSubtractionTo[];
  materials: MaterialApplicationRestrictionTo[];
}

export interface RecountSubtractionTo {
  type: RestrictionType;
  value?: number;
  protectionLevel?: number;
  isMaterial: boolean;
  isUsed: boolean;
  isIgnored?: boolean;
}

export interface ParcelSubtractionResponse {
  parcelId: string;
  subtractions: SubtractionResponse[];
}

export interface SubtractionResponse {
  type: RestrictionType;
  value?: number;
  protectionLevel?: number;
  area: number;
  isMaterial: boolean;
  isUsed: boolean;
  isIgnored?: boolean;
}

export interface ParcelRestrictionTo {
  parcelId: string;
  restrictions: RestrictionTo[];
}

export type GeoJsonCoordinatesItem = { [key: string]: unknown };

export interface GeoJson {
  type: GeoJsonType;
  geometries: GeoJson[];
  coordinates: GeoJsonCoordinatesItem[];
}

export interface ParcelGeometryResponse {
  parcelId: string;
  geometry: GeoJson;
}

export interface ParcelRestrictionRequestBody {
  parcelRestrictions: ParcelRestrictionTo[];
}

export interface ParcelAreaTo {
  parcelId: string;
  area: number;
}

export interface CustomParcelCreateRequest {
  landUseId: number;
  localName: string;
  geometry: GeoJsonMultiPolygon;
  validFrom: string;
}

export interface CustomParcelCreateResult {
  landUseId: number;
  area: number;
  localName: string;
  geometry: GeoJsonMultiPolygon;
  parcelId?: string;
}

export interface CropSeedCreateTo {
  cropId: string;
  varietyName?: string;
  varietyId?: string;
  note?: string;
}

export interface CreateOrganismRequestTo {
  name: string;
}

export interface OrganismTo {
  id: string;
  name: string;
  externalId?: string;
  catalogue: CatalogueTo;
}

export interface ActiveSubstanceCreateTo {
  name: string;
  isIntegratedProductionVineyard?: boolean;
  isIntegratedProductionOrchard?: boolean;
  isIntegratedProductionVegetable?: boolean;
}

export interface CropCreateTo {
  name: string;
  color?: ColorTo;
  textColor?: ColorTo;
}

export interface CropProductCreateTo {
  cropId: string;
  externalId?: string;
  name: string;
  isMain: boolean;
  validFrom?: string;
  validTo?: string;
  secondaryProductId?: string;
}

export interface CropUseTypeCreateTo {
  cropId: string;
  externalId?: string;
  name: string;
  validFrom?: string;
  validTo?: string;
}

export interface RegroupingResult {
  totalSeedApplications: number;
  groupsCreated: number;
  seedApplicationsGrouped: number;
  seedApplicationsUngrouped: number;
}

export interface SeedApplicationV2ReimportResult {
  deleted: number;
  inserted: number;
  insertedFromSowingPlans: number;
  closedForSowingPlans: number;
  regrouping: RegroupingResult;
}

export type AdminFarmManagementToResponse = { [key: string]: unknown };

export interface AdminFarmManagementTo {
  farmId: string;
  farmName?: string;
  response: AdminFarmManagementToResponse;
}

export interface AdminNitrateVulnerableZoneTo {
  lpisBlockId: string;
  parcelId: string;
  parcelName?: string;
  isNitrateVulnerable: boolean;
}

export interface ActionInheritanceDto {
  actionId: string;
  actionType: ActionType;
  retiredParcelId: string;
  newParcelId: string;
}

export interface ActionInheritanceResult {
  movedActions: ActionInheritanceDto[];
  notMovedActionsLowRank: ActionInheritanceDto[];
  notMovedActionsOther: ActionInheritanceDto[];
  notMovedActionDuplicated: ActionInheritanceDto[];
}

export interface AdminParcelValidityMoveItem {
  parcelId: string;
  newDate: string;
}

export interface AdminParcelValidityMoveResult {
  noop: string[];
  changed: AdminParcelValidityMoveItem[];
  actionMovesResult: ActionInheritanceResult[];
}

export interface AdminActionMoveResult {
  okFarms: string[];
  nokFarms: string[];
}

export interface AdminEagriTestFarmCreateRequest {
  userId: string;
  eagriLogin: string;
  eagriWsKey: string;
  eagriSzrid: string;
  customerName: string;
  validityDate: string;
  farmName: string;
  srid: number;
  language: string;
  importMode: EagriImportMode;
}

export interface SyncStats {
  totalFetched: number;
  totalUpserted: number;
  deletedCount: number;
}

export interface FarmSkeagisCreateRequest {
  skeagisUserId: string;
  state: IntegrationState;
  validFrom: string;
}

export interface SplitActionRequest {
  actionId: string;
  parcelsToSplit: string[];
}

export interface SplitActionResponse {
  originalActionId: string;
  splitActionId: string;
}

export interface EvaluationConditionTo {
  description: string;
  expected?: string;
  actual?: string;
  check: boolean;
}

export interface EvaluationStepTo {
  description: string;
  severity: ViolationSeverity;
  conditions: EvaluationConditionTo[];
  check: boolean;
}

export type NitrateDirectiveVersion = typeof NitrateDirectiveVersion[keyof typeof NitrateDirectiveVersion];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NitrateDirectiveVersion = {
  NITRATE_DIRECTIVE_2015: 'NITRATE_DIRECTIVE_2015',
  NITRATE_DIRECTIVE_2016: 'NITRATE_DIRECTIVE_2016',
  NITRATE_DIRECTIVE_2020: 'NITRATE_DIRECTIVE_2020',
  NITRATE_DIRECTIVE_ALL: 'NITRATE_DIRECTIVE_ALL',
} as const;

export type RestrictionCode = typeof RestrictionCode[keyof typeof RestrictionCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RestrictionCode = {
  EagriCodeRestrictions: 'EagriCodeRestrictions',
  GrasslandsFertilizationRestriction: 'GrasslandsFertilizationRestriction',
  SlopeWaterFertilizationRestriction: 'SlopeWaterFertilizationRestriction',
  SlopeWaterSowingRestriction: 'SlopeWaterSowingRestriction',
  StrawDecayOrCatchCropRestriction: 'StrawDecayOrCatchCropRestriction',
} as const;

export interface ValidationResponseTo {
  valid: boolean;
  restrictions: ValidationResultTo[];
  refId: string;
}

export interface ValidationResultTo {
  description: string;
  code: RestrictionCode;
  version: NitrateDirectiveVersion;
  violated: boolean;
  violations: ViolationTo[];
}

export interface ViolationParcelCropTo {
  eagriId: number;
  cropName: string;
  seasonStartYear?: number;
  cropStartDate?: string;
  cropEndDate?: string;
  isCatchCrop: boolean;
  /** ID of the parcel that violates the restriction. It may be historic parcel ID. */
  parcelId?: string;
}

export interface ViolationParcelTo {
  id: string;
  name: string;
  eagriCodes: string[];
  crops?: ViolationParcelCropTo[];
  violatedCrops?: ViolationParcelCropTo[];
  requiredWaterBuffer?: number;
}

export type ViolationSeverity = typeof ViolationSeverity[keyof typeof ViolationSeverity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ViolationSeverity = {
  OK: 'OK',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
} as const;

export interface ViolationTo {
  code: string;
  message: string;
  text: string;
  parcelId?: string;
  severity: ViolationSeverity;
  parcel?: ViolationParcelTo;
  steps?: EvaluationStepTo[];
}

export interface FertilizerExpenseRequestTo {
  dosePerHa: number;
  unit: string;
  fertilizerId: string;
}

export interface SeedApplicationFertilizationRequestTo {
  parcelId: string;
  actionArea: number;
  targetSeedAppSownArea: number;
  isStrawDecay: boolean;
  fertilizerExpenses: FertilizerExpenseRequestTo[];
}

export interface TargetSeedApplicationFertilizationRequestTo {
  parcelFertilizerExpenses: SeedApplicationFertilizationRequestTo[];
}

export interface ParcelAccountableNitrogenTo {
  parcelId: string;
  accountableNitrogen: number;
}

export interface CenterAssignTo {
  centerId?: string;
}

export interface ParcelUpdateTo {
  name?: string;
  userYieldGrade?: YieldGrade;
  zoneIds?: string[];
  center?: CenterAssignTo;
  notes?: string;
}

export type YieldGrade = typeof YieldGrade[keyof typeof YieldGrade];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const YieldGrade = {
  I: 'I',
  II: 'II',
  III: 'III',
} as const;

export interface CropSeedPatchTo {
  varietyName?: string;
  isFavorite?: boolean;
  isHidden?: boolean;
}

export interface PlantProtectionPatchTo {
  isFavorite: boolean;
}

export interface FertilizerPatchTo {
  isFavorite?: boolean;
  isHidden?: boolean;
}

export interface CropUpdateTo {
  name?: string;
  color?: ColorTo;
  textColor?: ColorTo;
}

export interface PublicCropTo {
  id: string;
  name: string;
  variety?: string;
}

export interface PublicParcelTo {
  id: string;
  blockNumber: string;
  name: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
  currentCrop?: PublicCropTo;
}

export interface InternalSeasonTo {
  startYear: number;
  cropId: string;
  cropLegislativeCode?: number;
  cropName: string;
}

export interface InternalSeedApplicationTo {
  dateStart: string;
  dateEnd?: string;
  seedTo: CropSeedTo;
  seedApplicationType: InternalSeedApplicationType;
  harvestProduct?: InternalCropProductTo;
}

export interface InternalSeedApplicationByParcelTo {
  parcelId: string;
  seedApplication?: InternalSeedApplicationTo;
}

export interface InternalFertilizerMineralIntakeResponse {
  nitrogen: number;
  accountableNitrogen: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  sulfur: number;
}

export interface InternalFarmResponse {
  id: string;
  name: string;
  countryCode?: string;
  source: InternalFarmImportSource;
  isVisibleInPublicLayers: boolean;
  integrationSource?: FarmIntegrationSource;
}

export interface InternalCropProductUseTypeTo {
  productId: string;
  productName?: string;
  isMainProduct?: boolean;
  cropUseTypeId?: string;
  cropUseTypeName?: string;
  dryMatter?: number;
  nutrientConsumption: InternalNutrientConsumptionTo[];
  secondaryProductRatio?: number;
}

export interface InternalCropTo {
  id: string;
  externalId: string;
  name: string;
  isNoCrop: boolean;
  products: InternalCropProductUseTypeTo[];
}

export interface InternalNutrientConsumptionTo {
  type: NutrientType;
  value: number;
}

export interface SeedApplicationV2ResultTo {
  type: SeedApplicationType;
  seed?: CropSeedTo;
  startDate: string;
  endDate?: string;
  cropUse?: CropUseTypeTo;
  cropProduct?: CropProductTo;
  isHarvestable: boolean;
  totalArea: number;
  resultType: string;
}

export type ConnectableSeedApplicationV2GroupToAllOf = {
  groupId?: string;
  totalSownAreaHa?: number;
  seedApplications?: ConnectableSeedApplicationV2To[];
};

export type ConnectableSeedApplicationV2GroupTo = ConnectableSeedApplicationV2ResultTo & ConnectableSeedApplicationV2GroupToAllOf & Required<Pick<ConnectableSeedApplicationV2ResultTo & ConnectableSeedApplicationV2GroupToAllOf, 'groupId' | 'seedApplications' | 'totalSownAreaHa'>>;

export interface ConnectableSeedApplicationV2ResultTo {
  type: SeedApplicationType;
  seed?: CropSeedTo;
  startDate: string;
  endDate?: string;
  cropUse?: CropUseTypeTo;
  cropProduct?: CropProductTo;
  resultType: string;
}

export type ConnectableSeedApplicationV2ToAllOf = {
  id?: string;
  groupId?: string;
  sownAreaHa?: number;
  parcelId?: string;
  parcelName?: string;
  parcelNumber?: string;
  parcelAreaHa?: number;
  parcelValidFrom?: string;
  parcelValidTo?: string;
};

export type ConnectableSeedApplicationV2To = ConnectableSeedApplicationV2ResultTo & ConnectableSeedApplicationV2ToAllOf & Required<Pick<ConnectableSeedApplicationV2ResultTo & ConnectableSeedApplicationV2ToAllOf, 'id' | 'parcelAreaHa' | 'parcelId' | 'parcelName' | 'sownAreaHa'>>;

export interface Chyba {
  kod?: number;
  zavaznost: string;
  popis: string;
}

export interface RozsahDatValidation {
  rozsahDat: RozsahDat[];
}

export interface TChyby {
  chyba: Chyba[];
}

export interface TResponse {
  datPrijeti: string;
  idPodani: string;
  stavPodani: string;
  typ: string;
  obdobiOd?: string;
  obdobiDo?: string;
  hospRok?: number;
  rezimVolani?: string;
  potvrzeni?: string;
  chybnik?: string;
  chyby?: TChyby;
  rozsahDat?: RozsahDatValidation;
  osevy: Osevy;
  aplikace?: Applications;
  sklizne?: Sklizne;
  pastvy?: Pastvy;
}

export interface SowingPlanCropStatisticsOverview {
  parcelsCount: number;
  crop?: CropTo;
  area: number;
}

export interface SowingPlanOverviewParcelTo {
  seasonId: string;
  parcelId: string;
  area: number;
  crop?: CropTo;
}

export interface SowingPlanSeasonStatisticsTo {
  parcels: SowingPlanOverviewParcelTo[];
  statistics: SowingPlanCropStatisticsOverview[];
}

export type LandUse = typeof LandUse[keyof typeof LandUse];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LandUse = {
  ARABLE: 'ARABLE',
  HOPFIELD: 'HOPFIELD',
  VINEYARD: 'VINEYARD',
  OTHER_PERMANENT: 'OTHER_PERMANENT',
  ORCHARD: 'ORCHARD',
  GRASS: 'GRASS',
  OTHER: 'OTHER',
  SET_ASIDE: 'SET_ASIDE',
  FODDER: 'FODDER',
  UNPRODUCTIVE: 'UNPRODUCTIVE',
  MULTIPLE_CROPS: 'MULTIPLE_CROPS',
  TRUFFLES: 'TRUFFLES',
  CONTAINERS: 'CONTAINERS',
  NURSERY: 'NURSERY',
  VEGETABLES: 'VEGETABLES',
  POND: 'POND',
  FAST_GROW: 'FAST_GROW',
  WOODED: 'WOODED',
} as const;

export interface ParcelWithSowingPlansTo {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  lpisBlockArea: number;
  seedApplication?: SeedApplicationTo;
  zones?: ZoneTo[];
  seasons: SowingPlanSeasonCropTo[];
}

export interface SeedApplicationTo {
  id: string;
  seedingActionId: string;
  seed: CropSeedTo;
  type: SeedApplicationType;
  startDate: string;
  endDate?: string;
  sownArea: number;
  parcelId: string;
  terminalActionId?: string;
  isHarvestable: boolean;
  cropProduct?: CropProductTo;
  cropUse?: CropUseTypeTo;
}

export interface SowingPlanSeasonCropTo {
  season: SowingPlanSeasonTo;
  crop?: CropTo;
}

export interface ZoneTo {
  id: string;
  name: string;
}

export interface GeometryWithAreaTo {
  geometry: GeoJsonMultiPolygon;
  area: number;
}

export interface SeedApplicationIntervalsByGeometryTo {
  geometryWithAreaTo: GeometryWithAreaTo;
  seedApplications: SeedApplicationTo[];
}

export type FileType = typeof FileType[keyof typeof FileType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileType = {
  PDF: 'PDF',
  XLSX: 'XLSX',
  CSV: 'CSV',
} as const;

export type EagriReportStatusType = typeof EagriReportStatusType[keyof typeof EagriReportStatusType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EagriReportStatusType = {
  OK: 'OK',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
} as const;

export type ReportErrorBody = PorUseReportMissingDataBody | FertilizerUseReportMissingDataBody;

export interface ReportHistoryTo {
  id: string;
  type: ReportType;
  started: string;
  finished?: string;
  success?: boolean;
  periodFrom: string;
  periodTo: string;
  note?: string;
  jsonNote?: ReportErrorBody;
  eagriGuid?: string;
  eagriStatus?: EagriReportStatusType;
}

export type HttpServletResponseTrailerFields = { [key: string]: unknown };

export type HttpServletResponseLocale = {
  language?: string;
  displayName?: string;
  script?: string;
  variant?: string;
  unicodeLocaleAttributes?: string[];
  unicodeLocaleKeys?: string[];
  displayLanguage?: string;
  displayScript?: string;
  displayCountry?: string;
  displayVariant?: string;
  country?: string;
  extensionKeys?: string[];
  iso3Language?: string;
  iso3Country?: string;
};

export type HttpServletResponseWriter = { [key: string]: unknown };

export interface HttpServletResponse {
  status?: number;
  headerNames?: string[];
  trailerFields?: HttpServletResponseTrailerFields;
  contentType?: string;
  outputStream?: ServletOutputStream;
  contentLength?: number;
  locale?: HttpServletResponseLocale;
  bufferSize?: number;
  characterEncoding?: string;
  writer?: HttpServletResponseWriter;
  contentLengthLong?: string;
  committed?: boolean;
}

export interface ServletOutputStream {
  ready?: boolean;
  writeListener?: WriteListener;
}

export interface WriteListener { [key: string]: unknown }

export interface CenterTo {
  id: string;
  key: string;
  name: string;
}

export type ParcelSource = typeof ParcelSource[keyof typeof ParcelSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParcelSource = {
  MANUAL: 'MANUAL',
  SHP: 'SHP',
  AGROEVIDENCE_EAGRI: 'AGROEVIDENCE_EAGRI',
  AGROEVIDENCE_EAGRI_AUTOMATIC: 'AGROEVIDENCE_EAGRI_AUTOMATIC',
  SKEAGIS: 'SKEAGIS',
  CORE: 'CORE',
} as const;

/**
 * Parcel list item
 */
export interface ParcelTo {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  lpisBlockArea: number;
  nitrateVulnerable: boolean;
  validFrom: string;
  validTo?: string;
  status: ParcelStatus;
  zones?: ZoneTo[];
  center?: CenterTo;
  landUseName: string;
  seedApplication?: SeedApplicationTo;
  source: ParcelSource;
  slope?: number;
  zone?: ZoneTo;
}

/**
 * Parcel application zone from LPIS
 */
export type ApplicationZone = typeof ApplicationZone[keyof typeof ApplicationZone];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationZone = {
  I: 'I',
  II: 'II',
  IIIa: 'IIIa',
  IIIb: 'IIIb',
} as const;

export interface EagriParcelAttributesTo {
  lpisBlockArea: number;
  landUse: LandUse;
  /** Designated parcel land use localized name */
  landUseName: string;
  yieldGrade?: YieldGrade;
  userYieldGrade?: YieldGrade;
  applicationZone?: ApplicationZone;
  /** Bonitiated soil ecological unit = BPEJ */
  soilEcologicalUnit?: string;
  /**
   * Average parcel altitude
   * @minimum 0
   */
  altitude?: number;
  /**
   * Average parcel slope
   * @minimum 0
   */
  slope?: number;
  /**
   * Minimal parcel water distance
   * @minimum 0
   */
  waterDistance?: number;
}

/**
 * Parcel detail
 */
export interface ParcelDetailTo {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
  status: ParcelStatus;
  nitrateVulnerable: boolean;
  validFrom: string;
  validTo?: string;
  notes?: string;
  zones?: ZoneTo[];
  center?: CenterTo;
  eagri: EagriParcelAttributesTo;
  seedApplication?: SeedApplicationTo;
  eagriRestrictions: string[];
  parcelSource: ParcelSource;
  zone?: ZoneTo;
}

export interface FertilizationTo {
  /** Kilos of nitrogen per ha that will be absorbed by soil. Used for nitrate restrictions. */
  accountableNitrogen: number;
  /** Kilos of nitrogen per ha */
  nitrogen: number;
  /** Kilos of p2o5 per ha */
  p2o5: number;
  /** Kilos of k2o per ha */
  k2o: number;
  mgo: number;
  cao: number;
  sulfur: number;
}

export interface ParcelSeedApplicationTo {
  id: string;
  seedingActionId: string;
  seed: CropSeedTo;
  type: SeedApplicationType;
  startDate: string;
  endDate?: string;
  sownArea: number;
  terminalActionId?: string;
  fertilization: FertilizationTo;
  primaryRevenueHa?: number;
  secondaryRevenueHa?: number;
  isHarvestable: boolean;
  parcelId: string;
  cropProduct?: CropProductTo;
  cropUse?: CropUseTypeTo;
}

export interface ParcelSeedApplicationWithPlanTo {
  actualNoCropSeed?: ParcelSeedApplicationTo;
  planned?: SowingPlanSeasonCropTo;
}

export interface ParcelPredecessorTo {
  id: string;
  localName: string;
  blockNumber?: string;
}

export type ParcelToV2SeedApplication = SeedApplicationV2GroupToV2 | SeedApplicationV2To;

/**
 * Parcel list item with V2 seed application
 */
export interface ParcelToV2 {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  lpisBlockArea: number;
  nitrateVulnerable: boolean;
  validFrom: string;
  validTo?: string;
  status: ParcelStatus;
  zones?: ZoneTo[];
  center?: CenterTo;
  landUseName: string;
  seedApplication?: ParcelToV2SeedApplication;
  source: ParcelSource;
  slope?: number;
  zone?: ZoneTo;
}

export interface EagriNitrateRestrictionByYearTo {
  year?: number;
  isOldNitrate: boolean;
  nitrateRestrictions: EagriNitrateRestrictionWithDescriptionTo[];
}

export interface EagriNitrateRestrictionWithDescriptionTo {
  code: string;
  description: string;
  validFrom?: string;
  validTo?: string;
  source: NitrateRestrictionSource;
}

export interface EagriSubsidyTo {
  square: string;
  blockNr: string;
  declaredArea: number;
  subsidyTypeId: number;
  from: string;
  to?: string;
  subsidyTitleId: number;
  cropId?: number;
  code: string;
  description: string;
}

export type NitrateRestrictionSource = typeof NitrateRestrictionSource[keyof typeof NitrateRestrictionSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NitrateRestrictionSource = {
  EAGRI: 'EAGRI',
  LAND_USE: 'LAND_USE',
  YIELD_GRADE: 'YIELD_GRADE',
  CLEVERFARM: 'CLEVERFARM',
} as const;

export interface ParcelEagriInfoTo {
  aekoYear?: number;
  aeko: EagriSubsidyTo[];
  nitrate: EagriNitrateRestrictionByYearTo[];
}

export interface ParcelWaterDistanceTo {
  parcelId: string;
  landWaterBoundaryDistanceM: number;
}

export type ParcelV2SortColumn = typeof ParcelV2SortColumn[keyof typeof ParcelV2SortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParcelV2SortColumn = {
  LOCAL_NAME: 'LOCAL_NAME',
  BLOCK_NUMBER: 'BLOCK_NUMBER',
  AREA: 'AREA',
  VALID_FROM: 'VALID_FROM',
  CENTER: 'CENTER',
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

/**
 * Parcel detail V2 with SeedApplicationV2To
 */
export interface ParcelDetailV2To {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
  status: ParcelStatus;
  nitrateVulnerable: boolean;
  validFrom: string;
  validTo?: string;
  notes?: string;
  zones?: ZoneTo[];
  center?: CenterTo;
  eagri: EagriParcelAttributesTo;
  seedApplication?: SeedApplicationV2To;
  eagriRestrictions: string[];
  parcelSource: ParcelSource;
  zone?: ZoneTo;
}

export interface GroupMemberParcelSeedApplicationToV2 {
  parcelId: string;
  parcelName: string;
  parcelArea: number;
  blockNumber?: string;
  validFrom: string;
  validTo?: string;
  parcelStatus: ParcelStatus;
  seedApplication: SeedApplicationV2To;
  fertilization: FertilizationTo;
  primaryRevenueHa?: number;
  secondaryRevenueHa?: number;
}

export type ParcelSeedApplicationGroupToV2AllOf = {
  id?: string;
  groupId?: string;
  seed?: CropSeedTo;
  type?: SeedApplicationType;
  startDate?: string;
  endDate?: string;
  cropUse?: CropUseTypeTo;
  sowingMainProduct?: CropProductTo;
  isHarvestable?: boolean;
  totalArea?: number;
  parcelIds?: string[];
  totalFertilization?: FertilizationTo;
  totalPrimaryRevenue?: number;
  totalSecondaryRevenue?: number;
  parcelSeedApplications?: GroupMemberParcelSeedApplicationToV2[];
};

export type ParcelSeedApplicationGroupToV2 = ParcelSeedApplicationResultToV2 & ParcelSeedApplicationGroupToV2AllOf & Required<Pick<ParcelSeedApplicationResultToV2 & ParcelSeedApplicationGroupToV2AllOf, 'groupId' | 'id' | 'isHarvestable' | 'parcelIds' | 'parcelSeedApplications' | 'startDate' | 'totalArea' | 'totalFertilization' | 'type'>>;

export interface ParcelSeedApplicationResultToV2 {
  resultType: string;
}

export type ParcelSeedApplicationToV2AllOf = {
  seedApplication?: SeedApplicationV2To;
  fertilization?: FertilizationTo;
  primaryRevenueHa?: number;
  secondaryRevenueHa?: number;
};

export type ParcelSeedApplicationToV2 = ParcelSeedApplicationResultToV2 & ParcelSeedApplicationToV2AllOf & Required<Pick<ParcelSeedApplicationResultToV2 & ParcelSeedApplicationToV2AllOf, 'fertilization' | 'seedApplication'>>;

export interface ActionExpenseOverviewTo {
  materialId: string;
  materialType: MaterialType;
  materialName: string;
  materialLegislativeCode?: number;
  amount?: number;
  unit?: string;
  dosePerHa?: number;
  nitrogen?: number;
  p2o5?: number;
  k2o?: number;
  mgo?: number;
  cao?: number;
  s?: number;
}

export interface ActionOverviewV2To {
  id: string;
  date: string;
  isDraft: boolean;
  actionType: ActionTypeTo;
  crops: CropTo[];
  parcels: ActionParcelMinimalV2To[];
  expenses: ActionExpenseOverviewTo[];
  source: ActionSource;
  seedApplicationType: SeedApplicationType;
  seedApplicationNitrogen?: number;
  isStrawDecay?: boolean;
  /** Time in ISO-8601 format */
  time?: string;
}

export interface ActionParcelMinimalV2To {
  id: string;
  actionParcelId: string;
  name?: string;
  blockNumber?: string;
  region?: string;
  landUse: LandUse;
  landUseLocalised?: string;
  parcelArea: number;
  actionArea: number;
  restrictedArea: number;
  seedApplicationV2Id?: string;
  seedAppSownArea?: number;
  seedAppIsCatchCrop?: boolean;
  isNitrateVulnerable: boolean;
  status: ParcelStatus;
  validFrom: string;
  validTo?: string;
  isOutsideValidity: boolean;
}

export interface CropStatisticTo {
  externalId?: number;
  name: string;
  count: number;
  totalArea: number;
  color: ColorTo;
  textColor: ColorTo;
  cropId: string;
  isNoCrop: boolean;
}

export interface FarmStatisticsTo {
  crops: CropStatisticTo[];
  parcels: ParcelStatisticsTo;
}

export interface ParcelStatisticsTo {
  count: number;
  totalArea: number;
}

export interface GeoJsonPoint {
  coordinates: number[];
  type: GeoJsonType;
}

export interface ParcelMapToV2 {
  parcelId: string;
  parcelName: string;
  blockNr?: string;
  currentCropName?: string;
  cropId?: string;
  cropColor?: string;
  area: number;
  parcelValidFrom?: string;
  altitude?: number;
  slope?: number;
  isNitrateVulnerable: boolean;
  landUseName?: string;
  landUseColor?: string;
  zones: ZoneTo[];
  centroid?: GeoJsonPoint;
}

/**
 * Parcel suggestions list item
 */
export interface ParcelSuggestionTo {
  id: string;
  blockNumber: string;
  localName: string;
  status: ParcelStatus;
  validFrom: string;
  validTo?: string;
}

export interface ParcelMapTo {
  parcelId: string;
  parcelName: string;
  blockNr?: string;
  currentCropName?: string;
  cropId?: string;
  cropColor?: string;
  area: number;
  parcelValidFrom?: string;
  altitude?: number;
  slope?: number;
  isNitrateVulnerable: boolean;
  landUseName?: string;
  landUseColor?: string;
  zones: ZoneTo[];
  centroid?: GeoJsonPoint;
}

export interface LandUseResponse {
  key: LandUse;
  name: string;
}

export interface ActionGeomOverviewTo {
  id: string;
  date: string;
  isDraft: boolean;
  actionType: ActionTypeTo;
  expenses: ActionExpenseOverviewTo[];
  source: ActionSource;
  seedApplicationNitrogen?: number;
  isStrawDecay?: boolean;
  actionParcelIntersections: ParcelIntersectionTo[];
  targetCrop?: CropTo;
  /** Time in ISO-8601 format */
  time?: string;
}

export interface ParcelIntersectionTo {
  parcelId: string;
  intersectionArea: number;
  intersectionGeometry: GeoJsonMultiPolygon;
}

export interface FarmUpdateErrorFlatResponse {
  block?: string;
  parcelId?: string;
  geometryToRepair?: GeoJson;
  conflictingGeometry?: GeoJson;
  changeGeometry?: GeoJson;
}

export interface FarmUpdateFlatResponse {
  farmUpdateId: string;
  source: FarmUpdateSource;
  state: FarmUpdateState;
  startedAt: string;
  updatedAt?: string;
  lastSuccessUpdateDate?: string;
  errorMessage?: string;
  code?: string;
  shortCode?: string;
  conflictingBlocks?: string[];
  ambiguousParcels?: string[];
  newAutomaticParcels?: FarmUpdateNewParcels[];
  farmUpdateErrorFlatResponse: FarmUpdateErrorFlatResponse[];
}

export interface FarmUpdateNewParcels {
  parcelId?: string;
  block?: string;
}

export type FarmUpdateSource = typeof FarmUpdateSource[keyof typeof FarmUpdateSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmUpdateSource = {
  EMPTY_FARM: 'EMPTY_FARM',
  EAGRI: 'EAGRI',
  SKEAGIS: 'SKEAGIS',
  SHP: 'SHP',
} as const;

export type FarmUpdateState = typeof FarmUpdateState[keyof typeof FarmUpdateState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmUpdateState = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
} as const;

export interface FarmSettingsTo {
  eagriSettingsEnabled: boolean;
  shpSettingsEnabled: boolean;
  seedApplicationsV2Enabled: boolean;
}

export interface AekoUdajeType {
  aekokod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface AplPasmoType {
  aplpaskod?: number;
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface AzzpType {
  kod?: number;
  souradnicex: string;
  souradnicey: string;
}

export interface BpejType {
  bpejkod: string;
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface ChybaType {
  kodchyby: string;
  popis: string;
}

export interface ChybyType {
  chyba: ChybaType[];
}

export interface DpbType {
  chyba?: string;
  chyby?: ChybyType;
  iddpb?: number;
  ctverec: string;
  zkod: string;
  stav: string;
  stavid?: number;
  ucinnostdlezakona?: string;
  platnostod: string;
  platnostdo?: string;
  vymera: number;
  vymeraopv: number;
  kultura: string;
  kulturaid?: number;
  kulturanazev: string;
  kulturaod?: string;
  geometriedpb?: string;
  uzivatel: UzivatelType;
  zemparcely?: ZemParcelyType[];
  zakladni?: ZakladniType[];
  prekryvkatuze?: PrekryvKatuzeType[];
  seznamevp?: SeznamEvpType[];
  udajens?: UdajeNsType[];
  opatrenins?: OpatreniNsType[];
  aplpasmo?: AplPasmoType[];
  vynoshladina?: VynosHladinaType[];
  udajeeroze?: UdajeErozeType[];
  opatrenieroze?: OpatreniErozeType[];
  opatrenimeo?: OpatreniMeoType[];
  lfa?: LfaType[];
  opv?: OpvType[];
  opvz?: OpvzType[];
  bpej?: BpejType[];
  efas?: EfasType[];
  mzp?: MzpType[];
  enviro?: EnviroType[];
  aekoudaje?: AekoUdajeType[];
  gmo?: GmoType[];
  azzp?: AzzpType[];
  eroze2G?: Eroze2GType[];
  eroze3G?: Eroze3GType[];
  eroznipozemek?: EroznipozemekType[];
  honitba?: HonitbaType[];
  upob?: UpobType[];
  mnozitelskeporosty?: MnozPorostyType[];
  neprodplochy?: NeprodPlochyType[];
  seznamotp?: SeznamOtpType[];
}

export interface EagriDpbPair {
  subsidyDpb: DpbType;
  detail?: DpbType;
}

export interface EfasType {
  efaskod: string;
  vymefas: number;
  vymefasprep: number;
  platnostod: string;
  platnostdo?: string;
}

export interface EnviroType {
  kodlouky: string;
  terminsec?: string;
  zpusobpastvy?: string;
  vymprekryv: number;
  kvalita: string;
  platnostod: string;
  platnostdo?: string;
}

export interface Eroze2GType {
  vyslednaeroze: VyslednaErozeType;
  seocelkem: number;
  seomeocelkem: number;
  maxsouvseo: number;
  maxsouvseomeo: number;
  osevod: string;
  osevdo: string;
  ptopatreni?: PtopatreniType[];
}

export interface Eroze3GType {
  vyslednaeroze: VyslednaEroze24Type;
  seocelkem: number;
  seomeovrcelkem: number;
  seomeovrmeonrcelkem: number;
  maxsouvseo: number;
  maxsouvseomeovr: number;
  maxsouvseomeovrmeonr: number;
  osevod: string;
  osevdo: string;
  ptopatreni?: PtopatreniType[];
}

export interface EroznipozemekType {
  id?: number;
  typ: TypEroznihoPozemkuType;
  datumvytvoreni: string;
  vytvorilkdo: string;
  poznamka?: string;
  geoinfo?: GeoinfoType[];
  prislusdpb?: PrisluzdpbType;
  vyslednaeroze?: VyslednaErozeType;
  seocelkem?: number;
  seomeocelkem?: number;
  maxsouvseo?: number;
  maxsouvseomeo?: number;
  osevod?: string;
  osevdo?: string;
  ptopatreni?: PtopatreniType[];
}

export interface GeoinfoType {
  kod: string;
  hodnota: number;
  platnostod: string;
  platnostdo?: string;
}

export interface GmoType {
  plodinaid?: number;
  plodinanazev: string;
  vymera: number;
}

export interface HistorieType {
  parcelaid?: number;
  parcelavymy: number;
  prekryv: number;
  vlastnizakre?: boolean;
  platnostod: string;
  platnostdo?: string;
}

export interface HonitbaType {
  kod: string;
  nazev: string;
  vymprekryv: number;
  prislusnostorp: string;
  platnostod: string;
  platnostdo?: string;
}

export type KodOpatreniType = typeof KodOpatreniType[keyof typeof KodOpatreniType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KodOpatreniType = {
  P_1: 'P_1',
  P_2: 'P_2',
  P_3: 'P_3',
  Z_0: 'Z_0',
  Z_1: 'Z_1',
  Z_2: 'Z_2',
  Z_3: 'Z_3',
  S_0: 'S_0',
  S_1: 'S_1',
  S_2: 'S_2',
  S_3: 'S_3',
  V_0: 'V_0',
  V_1: 'V_1',
  V_2: 'V_2',
  V_3: 'V_3',
  V_4: 'V_4',
  K: 'K',
  R: 'R',
  LOS: 'LOS',
  ST: 'ST',
  PK: 'PK',
} as const;

export interface LfaType {
  lfakod: string;
  vymprekryv: number;
  vymprekryv4DM?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface MnozPorostyType {
  rok: number;
  ciszadosti?: number;
  datpodani: string;
  zadatel: string;
  zadatelico: string;
  druhkod?: number;
  druhnazev: string;
  odrudakod?: number;
  odrudanazev: string;
  kategorie: string;
  generace: string;
  vymerazadost: number;
  hodnoceni?: string;
  kvalitavazby: string;
  zrusenazadost: string;
  cisrozhodnuti?: string;
  prehlidka?: PrehlidkaType[];
}

export interface MzpType {
  mzpkod: string;
  vymprekryv: number;
  vymprekryv4DM?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface NeprodPlochyType {
  id?: number;
  typnp: string;
  zkodnp: string;
  ctverecnp: string;
  vymnp: number;
  platnostod: string;
  platnostdo?: string;
}

export interface OdpocPlochyType {
  kodop?: number;
  sirka?: number;
  vymera: number;
  platnostod: string;
  platnostdo?: string;
}

export interface OpatreniErozeType {
  erozekateg?: number;
  vymprekryv: number;
  osevod: string;
  osevdo: string;
  cfaktorod?: string;
  cfaktordo?: string;
}

export interface OpatreniMeoType {
  kodopatreni: KodOpatreniType;
  osevod: string;
  osevdo: string;
}

export interface OpatreniNsType {
  kodtyp: string;
  hodnota: string;
  platnostod: string;
  platnostdo?: string;
}

export interface OpvType {
  kodzakres: string;
  geometrie: string;
}

export interface OpvzType {
  kategorieopvz?: number;
  vymprekryv: number;
  nazev?: string;
  typ?: string;
  overeno?: boolean;
  urlrozhodnuti?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface ParcelaVerzeType {
  idparcelaverze?: number;
  geometrie?: string;
  multipolygon?: boolean;
  vymera: number;
  parcelaverzeod: string;
  parcelaverzedo?: string;
  zakladni?: ZakladniType[];
  opatrenins?: OpatreniNsType[];
  aplpasmo?: AplPasmoType[];
  eroze2G?: Eroze2GType[];
  eroze3G?: Eroze3GType[];
  neprodplochy?: NeprodPlochyType[];
}

export interface PlodinaType {
  pestovaniid?: number;
  kodplodiny?: number;
  meziplodina?: boolean;
  gps?: boolean;
  platnostod: string;
  platnostdo?: string;
}

export interface PlodinyRozsireneType {
  pestovaniid?: number;
  kodplodiny?: number;
  kodproduktu?: number;
  kodusp?: number;
  kodpot?: number;
  pot?: string;
  poznamka?: string;
  meziplodina?: boolean;
  platnostod: string;
  platnostdo?: string;
}

export interface PrehlidkaType {
  poradi: number;
  datprovedeni: string;
  vysledek: string;
  stav: number;
}

export interface PrekryvKatuzeType {
  kunazev: string;
  kukod?: number;
  vymprekryv: number;
  dlecentroid?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface PrisluzdpbType {
  fbid?: number;
  ctverec: string;
  zkod: string;
  vymeradpb: number;
  platnostod: string;
  platnostdo?: string;
}

export interface PtopatreniType {
  kod: string;
}

export interface SeznamEvpType {
  evpid?: number;
  ctverec: string;
  zkod: string;
  vymera: number;
  vymeraprekryv: number;
  geometrieevp: string;
  druhnazev: string;
  druhid?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface SeznamOtpType {
  obnovatpid?: number;
  datumzahajeniotp: string;
  datumsouvislyotp?: string;
  stav: number;
}

export type TypEroznihoPozemkuType = typeof TypEroznihoPozemkuType[keyof typeof TypEroznihoPozemkuType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypEroznihoPozemkuType = {
  EEP: 'EEP',
  VEP: 'VEP',
} as const;

export interface UdajeErozeType {
  kod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface UdajeNsType {
  kod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface UpobType {
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface UzivatelType {
  iduzivatele?: number;
  jmeno?: string;
  prijmeni?: string;
  obchodnijmeno?: string;
  ic?: string;
  pravniforma?: number;
}

export interface VynosHladinaType {
  vynoshladinakod?: number;
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export type VyslednaEroze24Type = typeof VyslednaEroze24Type[keyof typeof VyslednaEroze24Type];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VyslednaEroze24Type = {
  SEO: 'SEO',
  MEO_VR: 'MEO_VR',
  MEO_NR: 'MEO_NR',
  NEO: 'NEO',
} as const;

export type VyslednaErozeType = typeof VyslednaErozeType[keyof typeof VyslednaErozeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VyslednaErozeType = {
  SEO: 'SEO',
  MEO: 'MEO',
  NEO: 'NEO',
} as const;

export interface ZakladniType {
  kod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface ZemParcelyType {
  idparcela?: number;
  nazev: string;
  poradi?: number;
  parcelaod: string;
  parcelado?: string;
  idparcelapredek?: number;
  plodina: PlodinaType[];
  plodinyrozsirene: PlodinyRozsireneType[];
  historie?: HistorieType[];
  odpocplochy?: OdpocPlochyType[];
  parcelaverze?: ParcelaVerzeType[];
}

export interface FarmUpdateChange {
  changeDate?: string;
  type: FarmUpdateChangeType;
  blockNumber: string;
}

export type FarmUpdateChangeRequestStatus = typeof FarmUpdateChangeRequestStatus[keyof typeof FarmUpdateChangeRequestStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmUpdateChangeRequestStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  AVAILABLE: 'AVAILABLE',
} as const;

export type FarmUpdateChangeType = typeof FarmUpdateChangeType[keyof typeof FarmUpdateChangeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmUpdateChangeType = {
  NEW_PARCEL: 'NEW_PARCEL',
  NEW_BLOCK: 'NEW_BLOCK',
  REPLACED_PARCEL: 'REPLACED_PARCEL',
  REPLACED_BLOCK: 'REPLACED_BLOCK',
  NEW_BLOCK_RESTRICTION_CODES: 'NEW_BLOCK_RESTRICTION_CODES',
  REMOVED_BLOCK_RESTRICTION_CODES: 'REMOVED_BLOCK_RESTRICTION_CODES',
  CHANGED_PARCEL_NAME: 'CHANGED_PARCEL_NAME',
  CHANGED_PARCEL_CROPS: 'CHANGED_PARCEL_CROPS',
  NEW_PARCEL_RESTRICTION_CODES: 'NEW_PARCEL_RESTRICTION_CODES',
  REMOVED_PARCEL_RESTRICTION_CODES: 'REMOVED_PARCEL_RESTRICTION_CODES',
  RETIRED_BLOCK: 'RETIRED_BLOCK',
} as const;

export interface FarmUpdateChangesResponse {
  status: FarmUpdateChangeRequestStatus;
  validityDate: string;
  changes?: FarmUpdateChange[];
}

export interface CountryTo {
  code: string;
  name: string;
  fullSupport: boolean;
}

export interface CropSeedSuggestionTo {
  id: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  name: string;
  cropId: string;
  cropExternalId?: number;
  varietyName?: string;
}

export interface PrimaryCatalogueTo {
  type: CatalogueType;
  canImport: boolean;
}

export interface PlantProtectionDetailRegistrationApplicationTo {
  id: string;
  registrationExternalId?: string;
  registrationHolder?: string;
  registrationNumber?: string;
  evidenceNumber?: string;
  validUntil?: string;
  maxDose?: number;
  minDose?: number;
  unit?: string;
  maxDoseWater?: number;
  minDoseWater?: number;
  unitWater?: string;
  minBbch?: number;
  maxBbch?: number;
  allowedApplications?: number;
  minInterval?: number;
  maxInterval?: number;
  protectionPeriod?: number;
  isAerialApplication?: boolean;
  isSeedTreatment?: boolean;
  crop?: CropTo;
  cropGroup?: CropGroupTo;
  organism?: OrganismTo;
  doseComment?: string;
  doseText?: string;
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  notes?: string;
  legalStart?: string;
  legalEnd?: string;
  marketEnd?: string;
  useEnd?: string;
}

export interface PlantProtectionApplicationTo {
  id: string;
  validUntil?: string;
  maxDose?: number;
  minDose?: number;
  unit?: string;
  maxDoseWater?: number;
  minDoseWater?: number;
  unitWater?: string;
  minBbch?: number;
  maxBbch?: number;
  allowedApplications?: number;
  minInterval?: number;
  maxInterval?: number;
  protectionPeriod?: number;
  crop?: CropTo;
  cropGroup?: CropGroupTo;
  organism?: OrganismTo;
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
}

export interface PlantProtectionSuggestionTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  validUntil?: string;
  isFavorite: boolean;
}

export interface PlantProtectionOverviewTo {
  id: string;
  name: string;
  externalId?: string;
  catalogue: CatalogueTo;
  validUntil?: string;
  activeSubstances?: string[];
  organisms?: string[];
  crops?: string[];
  isFavorite: boolean;
}

export interface EagriFertilizerPropertiesTo {
  nitrogenCategory: EagriFertilizerNitrogenCategoryTo;
  isValid: boolean;
  validFrom?: string;
  validTo?: string;
  evidenceNumber?: string;
}

export interface FertilizerTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  producerTradeName?: string;
  isOrganic: boolean;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  s: number;
  eagriProperties?: EagriFertilizerPropertiesTo;
}

export interface FertilizerMineralIntakeResponse {
  nitrogenIntake: number;
  p2o5Intake: number;
  k2oIntake: number;
  accountableNitrogenIntake: number;
}

export interface FertilizerSuggestionTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  producerTradeName?: string;
  preferredUnitType: UnitType;
  validTo?: string;
  hasPhosphorus: boolean;
  hasPotassium: boolean;
  hasNitrogen: boolean;
}

export type EnumEntriesEagriFertilizerNitrogenCategory = EagriFertilizerNitrogenCategory[];

export interface CropDetailTo {
  id: string;
  name: string;
  externalId?: string;
  catalogueType: CatalogueType;
  group?: CropGroupTo;
  validFrom?: string;
  validTo?: string;
  color: ColorTo;
  textColor: ColorTo;
  isNoCrop: boolean;
  products: CropProductUseTypeTo[];
}

export interface CropProductUseTypeTo {
  productId: string;
  productName?: string;
  isMainProduct?: boolean;
  cropUseTypeId?: string;
  cropUseTypeName?: string;
  dryMatter?: number;
  nutrientConsumption: NutrientConsumptionTo[];
  secondaryProductRatio?: number;
}

/**
 * Status of Landscape Element synchronization
 */
export interface LandscapeSyncStatusTo {
  lastSuccessful?: SyncInfoTo;
  lastAttempt?: SyncAttemptTo;
}

/**
 * Status of the sync
 */
export type SyncAttemptToStatus = typeof SyncAttemptToStatus[keyof typeof SyncAttemptToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncAttemptToStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

/**
 * Information about a sync attempt
 */
export interface SyncAttemptTo {
  /** When the sync was started */
  startedAt: string;
  /** When the sync finished (null if still in progress) */
  finishedAt?: string;
  /** Status of the sync */
  status: SyncAttemptToStatus;
  /** Total number of landscape elements fetched (0 if failed or in progress) */
  totalFetched: number;
  /** Error message if the sync failed */
  errorMessage?: string;
  /** Type of sync */
  syncType: string;
}

/**
 * Information about a successful sync
 */
export interface SyncInfoTo {
  /** When the sync was completed */
  finishedAt: string;
  /** Total number of landscape elements fetched from source */
  totalFetched: number;
  /** Type of sync */
  syncType: string;
}

export interface EagriServiceSyncStatusTo {
  service: string;
  lastRun: string;
  lastData: string;
  lastSuccess: string;
}

export interface ActionOverviewTo {
  id: string;
  date: string;
  isDraft: boolean;
  actionType: ActionTypeTo;
  crop?: CropTo;
  parcels: ActionParcelMinimalTo[];
  expenses: ActionExpenseOverviewTo[];
  source: ActionSource;
  seedApplicationType: SeedApplicationType;
  seedApplicationNitrogen?: number;
  isStrawDecay?: boolean;
  /** Time in ISO-8601 format */
  time?: string;
}

export interface ActionParcelMinimalTo {
  id: string;
  actionParcelId: string;
  name?: string;
  blockNumber?: string;
  region?: string;
  landUse: LandUse;
  landUseLocalised?: string;
  parcelArea: number;
  actionArea: number;
  restrictedArea: number;
  seedApplicationId?: string;
  isNitrateVulnerable: boolean;
  status: ParcelStatus;
  validFrom: string;
  validTo?: string;
}

export interface ActionDetailTo {
  id: string;
  /** Time of the action in ISO-8601 format */
  time?: string;
  source: ActionSource;
  date: string;
  note?: string;
  parcels: ActionParcelDetailTo[];
  actionType: ActionType;
  isDraft: boolean;
  isEagriFromCoreParcels: boolean;
}

export type ActionEPHDetailToAllOf = {
  targetCrop?: CropTo;
  isStrawDecay?: boolean;
  fertilizationTarget?: FertilizerTarget;
  fertilizers?: ActionExpenseFertilizerDetailTo[];
  plantProtections?: ActionExpensePlantProtectionDetailTo[];
};

export type ActionEPHDetailTo = ActionDetailTo & ActionEPHDetailToAllOf & Required<Pick<ActionDetailTo & ActionEPHDetailToAllOf, 'fertilizers' | 'plantProtections'>>;

export interface ActionExpenseFertilizerDetailTo {
  fertilization: AverageFertilizationTo;
  materialId: string;
  material: FertilizerTo;
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
}

export type ActionExpensePlantProtectionDetailToMaterial = InternalFertilizerTo | InternalMaterialToBase;

export interface ActionExpensePlantProtectionDetailTo {
  targetOrganisms: OrganismTo[];
  parcelPlantProtectionEffectiveness: ParcelPlantProtectionEffectivenessTo[];
  material: ActionExpensePlantProtectionDetailToMaterial;
  materialId: string;
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
}

export interface ActionExpenseSeedDetailTo {
  material: CropSeedTo;
  materialId: string;
  actionMaterial: SeedMat;
  actionExpense?: ActionExpenseTo;
}

export type ActionOtherDetailTo = ActionDetailTo;

export interface ActionParcelDetailTo {
  id: string;
  parcel: ParcelTo;
  restrictions: SubtractionResponse[];
  actionArea: number;
  restrictedArea: number;
}

export type ActionRevenueDetailToAllOf = {
  revenues?: RevenueTo[];
};

export type ActionRevenueDetailTo = ActionDetailTo & ActionRevenueDetailToAllOf & Required<Pick<ActionDetailTo & ActionRevenueDetailToAllOf, 'revenues'>>;

export type ActionSowingDetailToAllOf = {
  seedExpense?: ActionExpenseSeedDetailTo;
  seedApplicationType?: SeedApplicationType;
  cropUse?: CropUseTypeTo;
  cropProduct?: CropProductTo;
};

export type ActionSowingDetailTo = ActionDetailTo & ActionSowingDetailToAllOf & Required<Pick<ActionDetailTo & ActionSowingDetailToAllOf, 'seedApplicationType'>>;

export interface AverageFertilizationTo {
  nitrogen: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  sulfur: number;
}

export type FertilizerTarget = typeof FertilizerTarget[keyof typeof FertilizerTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FertilizerTarget = {
  CATCH_CROP: 'CATCH_CROP',
  MAIN_CROP: 'MAIN_CROP',
  STRAW: 'STRAW',
} as const;

export interface RevenueTo {
  actionId: string;
  amount: number;
  amountPerHa: number;
  isMainProduct: boolean;
  cropProduct?: CropProductTo;
}

export interface FlatActionPlantProtectionByMaterialV2To {
  plantProtectionId: string;
  actions: FlatActionPlantProtectionV2To[];
}

export interface FlatActionPlantProtectionV2To {
  actionId: string;
  date: string;
  materialId: string;
  materialName: string;
  dose: number;
  unit: string;
}

export interface TargetSeedApplicationDetailV2To {
  parcelId: string;
  seedApplicationV2: SeedApplicationV2To;
  accountableNitrogen: number;
  actionsByPlantProtection: FlatActionPlantProtectionByMaterialV2To[];
}

export interface TargetSeedApplicationV2ResponseTo {
  seedApplications: TargetSeedApplicationDetailV2To[];
}

export interface FlatActionPlantProtectionByMaterialTo {
  plantProtectionId: string;
  actions: FlatActionPlantProtectionTo[];
}

export interface FlatActionPlantProtectionTo {
  actionId: string;
  parcelId: string;
  actionType: ActionType;
  date: string;
  plantProtection: PlantProtectionMinimalTo;
}

export interface PlantProtectionMinimalTo {
  id: string;
  name: string;
  activeSubstances: string[];
}

export interface TargetSeedApplicationActionsResponseTo {
  seedApplications: TargetSeedApplicationDetailTo[];
}

export interface TargetSeedApplicationDetailTo {
  parcelId: string;
  seedApplication: SeedApplicationTo;
  accountableNitrogen: number;
  actionsByPlantProtection: FlatActionPlantProtectionByMaterialTo[];
}

export interface CropGrowthStageTo {
  code: string;
  name: string;
}

export type ActionTypeGroupTo = typeof ActionTypeGroupTo[keyof typeof ActionTypeGroupTo];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionTypeGroupTo = {
  OTHER: 'OTHER',
} as const;

/**
 * Available farm settings keys for admin configuration
 */
export type FarmSettingsKey = typeof FarmSettingsKey[keyof typeof FarmSettingsKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FarmSettingsKey = {
  EAGRI_SETTINGS_ENABLED: 'EAGRI_SETTINGS_ENABLED',
  SHP_SETTINGS_ENABLED: 'SHP_SETTINGS_ENABLED',
  SEED_APPLICATIONS_V2_ENABLED: 'SEED_APPLICATIONS_V2_ENABLED',
} as const;

type UpdateCentersParamsTSMorphBase = {
farmIds: string;
}

export type UpdateCentersParams = Omit<UpdateCentersParamsTSMorphBase, "farmIds">;;

type UpdateSeedApplicationV2ParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSeedApplicationV2Params = Omit<UpdateSeedApplicationV2ParamsTSMorphBase, "farmIds">;;

type DeleteSeedApplicationV2ParamsTSMorphBase = {
farmIds: string;
}

export type DeleteSeedApplicationV2Params = Omit<DeleteSeedApplicationV2ParamsTSMorphBase, "farmIds">;;

type UpdateSeedApplicationV2GroupParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSeedApplicationV2GroupParams = Omit<UpdateSeedApplicationV2GroupParamsTSMorphBase, "farmIds">;;

type DisbandGroupParamsTSMorphBase = {
farmIds: string;
}

export type DisbandGroupParams = Omit<DisbandGroupParamsTSMorphBase, "farmIds">;;

type GetDetailedParcelWithSowingPlanParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
language: LocalLanguage;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by their sown status.<ul><li>If <b>true</b>, filters only sown parcels</li><li>If <b>false</b>, filters only unsown parcel</li><li>If <b>null</b>, no sowning filter is applied</li></ul>
 */
sown?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetDetailedParcelWithSowingPlanParams = Omit<GetDetailedParcelWithSowingPlanParamsTSMorphBase, "farmIds">;;

type PutCropsToParcelAndSeasonParamsTSMorphBase = {
farmIds: string;
}

export type PutCropsToParcelAndSeasonParams = Omit<PutCropsToParcelAndSeasonParamsTSMorphBase, "farmIds">;;

type GetParcelSowingPlanParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
language?: string;
}

export type GetParcelSowingPlanParams = Omit<GetParcelSowingPlanParamsTSMorphBase, "farmIds">;;

type PutCropToParcelAndSeasonParamsTSMorphBase = {
farmIds: string;
}

export type PutCropToParcelAndSeasonParams = Omit<PutCropToParcelAndSeasonParamsTSMorphBase, "farmIds">;;

type UpdateFarmFromShapefileParamsTSMorphBase = {
farmIds: string;
/**
 * 
            Similarity threshold for shapefile validation.
            If new parcels have higher or equal jaccard_index than this threshold, the new parcel won't be created and old won't be retired.
            If you want to always retire all parcels use threshold 1.0.
            Value from 1.0 to 0.0 where 1.0 is most similar and 0.0 is not similar at all.
            Default is 0.98
            
 */
'similarity-threshold'?: number;
/**
 * 
            If false doesn't retire parcels that do not have replacement in the shapefile.
            Can be used for partial update - shapefile can contain one parcel that needs to be updated and the rest will stay the same.
            Default is true
            
 */
'retire-parcels-without-replacement'?: boolean;
}

export type UpdateFarmFromShapefileParams = Omit<UpdateFarmFromShapefileParamsTSMorphBase, "farmIds">;;

export type UpdateFarmFromShapefileBody = {
  shapefile: Blob;
};

export type GetEagriAuthParams = {
language?: string;
};

export type UpdateFarmParams = {
language?: string;
srid?: number;
'update-mode'?: EagriFullFarmUpdateMode;
'sync-catalogues'?: boolean;
'validity-date'?: string;
'skip-parcel-fill-validation'?: boolean;
};

type PutPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type PutPlantProtectionParams = Omit<PutPlantProtectionParamsTSMorphBase, "farmIds">;;

type PatchPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type PatchPlantProtectionParams = Omit<PatchPlantProtectionParamsTSMorphBase, "farmIds">;;

type PutPlantProtectionRegistrationApplicationParamsTSMorphBase = {
farmIds: string;
}

export type PutPlantProtectionRegistrationApplicationParams = Omit<PutPlantProtectionRegistrationApplicationParamsTSMorphBase, "farmIds">;;

type DeletePlantProtectionRegistrationApplicationParamsTSMorphBase = {
farmIds: string;
}

export type DeletePlantProtectionRegistrationApplicationParams = Omit<DeletePlantProtectionRegistrationApplicationParamsTSMorphBase, "farmIds">;;

type GetFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetFertilizerParams = Omit<GetFertilizerParamsTSMorphBase, "farmIds">;;

type PutFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PutFertilizerParams = Omit<PutFertilizerParamsTSMorphBase, "farmIds">;;

type HideFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type HideFertilizerParams = Omit<HideFertilizerParamsTSMorphBase, "farmIds">;;

type UpdateCropProductsParamsTSMorphBase = {
farmIds: string;
}

export type UpdateCropProductsParams = Omit<UpdateCropProductsParamsTSMorphBase, "farmIds">;;

type PutCropProductParamsTSMorphBase = {
farmIds: string;
}

export type PutCropProductParams = Omit<PutCropProductParamsTSMorphBase, "farmIds">;;

type PutCropUseTypeParamsTSMorphBase = {
farmIds: string;
}

export type PutCropUseTypeParams = Omit<PutCropUseTypeParamsTSMorphBase, "farmIds">;;

export type UpdateSkeagisFarmParams = {
farms: string;
};

export type OverwriteParcelGeometriesParams = {
farms: string;
'block-numbers': string[];
validity: string;
};

export type ResaveActionStoreTransactionsParams = {
'farm-id': string;
'action-id': string;
};

type UpdateSkeagisStateParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSkeagisStateParams = Omit<UpdateSkeagisStateParamsTSMorphBase, "farmIds">;;

type CreateNewSkeagisIntegrationParamsTSMorphBase = {
farmIds: string;
}

export type CreateNewSkeagisIntegrationParams = Omit<CreateNewSkeagisIntegrationParamsTSMorphBase, "farmIds">;;

type UpdateSowingActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSowingActionParams = Omit<UpdateSowingActionParamsTSMorphBase, "farmIds">;;

type UpdateMowingActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateMowingActionParams = Omit<UpdateMowingActionParamsTSMorphBase, "farmIds">;;

type UpdateHarvestActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateHarvestActionParams = Omit<UpdateHarvestActionParamsTSMorphBase, "farmIds">;;

type UpdateEPHActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateEPHActionParams = Omit<UpdateEPHActionParamsTSMorphBase, "farmIds">;;

type UpdateSowingAction1ParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSowingAction1Params = Omit<UpdateSowingAction1ParamsTSMorphBase, "farmIds">;;

type CreateSowingActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateSowingActionParams = Omit<CreateSowingActionParamsTSMorphBase, "farmIds">;;

type UpdateOtherActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateOtherActionParams = Omit<UpdateOtherActionParamsTSMorphBase, "farmIds">;;

type CreateOtherActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateOtherActionParams = Omit<CreateOtherActionParamsTSMorphBase, "farmIds">;;

type UpdateMowingAction1ParamsTSMorphBase = {
farmIds: string;
}

export type UpdateMowingAction1Params = Omit<UpdateMowingAction1ParamsTSMorphBase, "farmIds">;;

type CreateMowingActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateMowingActionParams = Omit<CreateMowingActionParamsTSMorphBase, "farmIds">;;

type UpdateHarvestAction1ParamsTSMorphBase = {
farmIds: string;
}

export type UpdateHarvestAction1Params = Omit<UpdateHarvestAction1ParamsTSMorphBase, "farmIds">;;

type CreateHarvestActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateHarvestActionParams = Omit<CreateHarvestActionParamsTSMorphBase, "farmIds">;;

type UpdateEPHAction1ParamsTSMorphBase = {
farmIds: string;
}

export type UpdateEPHAction1Params = Omit<UpdateEPHAction1ParamsTSMorphBase, "farmIds">;;

type CreateEPHActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateEPHActionParams = Omit<CreateEPHActionParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionsInternalParamsTSMorphBase = {
farmIds: string;
}

export type GetPlantProtectionsInternalParams = Omit<GetPlantProtectionsInternalParamsTSMorphBase, "farmIds">;;

export type GetPlantProtectionsInternal200Item = InternalFertilizerTo | InternalMaterialToBase;

type GetParcelIntersectionsParamsTSMorphBase = {
farmIds: string;
language?: string;
status?: ParcelStatus;
'at-date'?: string;
}

export type GetParcelIntersectionsParams = Omit<GetParcelIntersectionsParamsTSMorphBase, "farmIds">;;

export type GetParcelIntersections1Params = {
'country-code': string;
'at-date'?: string;
};

type GetActionInfoParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
}

export type GetActionInfoParams = Omit<GetActionInfoParamsTSMorphBase, "farmIds">;;

type CreateDraftActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateDraftActionParams = Omit<CreateDraftActionParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationV2sParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from'?: string;
'date-to'?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetSeedApplicationV2sParams = Omit<GetSeedApplicationV2sParamsTSMorphBase, "farmIds">;;

export type GetSeedApplicationV2s200Item = SeedApplicationV2GroupToV2 | SeedApplicationV2To;

type CreateSeedApplicationV2ParamsTSMorphBase = {
farmIds: string;
}

export type CreateSeedApplicationV2Params = Omit<CreateSeedApplicationV2ParamsTSMorphBase, "farmIds">;;

type CreateSeedApplicationV2GroupParamsTSMorphBase = {
farmIds: string;
}

export type CreateSeedApplicationV2GroupParams = Omit<CreateSeedApplicationV2GroupParamsTSMorphBase, "farmIds">;;

type GetPorUseReportBodyV2ParamsTSMorphBase = {
farmIds: string;
toDate: string;
}

export type GetPorUseReportBodyV2Params = Omit<GetPorUseReportBodyV2ParamsTSMorphBase, "farmIds">;;

type SendFertilizerUseReportToEagriV2ParamsTSMorphBase = {
farmIds: string;
}

export type SendFertilizerUseReportToEagriV2Params = Omit<SendFertilizerUseReportToEagriV2ParamsTSMorphBase, "farmIds">;;

export type SendFertilizerUseReportToEagriV2403 = MissingDataV2 | InvalidDateRange | EagriReportResponse;

type GetFertilizerUseReportBodyV2ParamsTSMorphBase = {
farmIds: string;
}

export type GetFertilizerUseReportBodyV2Params = Omit<GetFertilizerUseReportBodyV2ParamsTSMorphBase, "farmIds">;;

type GetSeasonsParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
}

export type GetSeasonsParams = Omit<GetSeasonsParamsTSMorphBase, "farmIds">;;

type CreateMissingSeasonsParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
}

export type CreateMissingSeasonsParams = Omit<CreateMissingSeasonsParamsTSMorphBase, "farmIds">;;

type SendPorUserReportToEagriParamsTSMorphBase = {
farmIds: string;
toDate: string;
fromDate?: string;
}

export type SendPorUserReportToEagriParams = Omit<SendPorUserReportToEagriParamsTSMorphBase, "farmIds">;;

export type SendPorUserReportToEagri403 = ValidationError | ReportIsAlreadyRunning | EagriReportError | PlantProtectionPairingResultTo;

type GetEagriPorUseReportBodyParamsTSMorphBase = {
farmIds: string;
toDate: string;
}

export type GetEagriPorUseReportBodyParams = Omit<GetEagriPorUseReportBodyParamsTSMorphBase, "farmIds">;;

type SendFertilizerUserReportToEagriParamsTSMorphBase = {
farmIds: string;
}

export type SendFertilizerUserReportToEagriParams = Omit<SendFertilizerUserReportToEagriParamsTSMorphBase, "farmIds">;;

export type SendFertilizerUserReportToEagri403 = MissingData | InvalidDateRange | EagriReportResponse;

type GetFertilizerUserReportBodyParamsTSMorphBase = {
farmIds: string;
}

export type GetFertilizerUserReportBodyParams = Omit<GetFertilizerUserReportBodyParamsTSMorphBase, "farmIds">;;

export type RegisterWithShapeFileParams = {
farmName: string;
countryCode: string;
language?: string;
};

export type RegisterWithShapeFileBody = {
  lpisFile: Blob;
};

export type ValidateShapefileParams = {
countryCode: string;
};

export type ValidateShapefileBody = {
  lpisFile: Blob;
};

export type RegisterEmptyFarmParams = {
farmName: string;
countryCode: string;
language?: string;
};

export type RegisterWithEagriParams = {
farmName: string;
language?: string;
srid?: number;
importMode?: EagriImportMode;
};

type GetParcelsSubtractionParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelsSubtractionParams = Omit<GetParcelsSubtractionParamsTSMorphBase, "farmIds">;;

type GetZonesParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetZonesParams = Omit<GetZonesParamsTSMorphBase, "farmIds">;;

type CreateZoneParamsTSMorphBase = {
farmIds: string;
}

export type CreateZoneParams = Omit<CreateZoneParamsTSMorphBase, "farmIds">;;

type PostParcelVegetationStripParamsTSMorphBase = {
farmIds: string;
}

export type PostParcelVegetationStripParams = Omit<PostParcelVegetationStripParamsTSMorphBase, "farmIds">;;

type RecountSubtractionsForActionParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type RecountSubtractionsForActionParams = Omit<RecountSubtractionsForActionParamsTSMorphBase, "farmIds">;;

type GetParcelSubtractionGeometryParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelSubtractionGeometryParams = Omit<GetParcelSubtractionGeometryParamsTSMorphBase, "farmIds">;;

type GetParcelAreaAfterSubtractionParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelAreaAfterSubtractionParams = Omit<GetParcelAreaAfterSubtractionParamsTSMorphBase, "farmIds">;;

type CreateParamsTSMorphBase = {
'dry-mode'?: boolean;
farmIds: string;
}

export type CreateParams = Omit<CreateParamsTSMorphBase, "farmIds">;;

type GetAvailableUpdatesParamsTSMorphBase = {
farmIds: string;
}

export type GetAvailableUpdatesParams = Omit<GetAvailableUpdatesParamsTSMorphBase, "farmIds">;;

type RequestAvailableUpdatesParamsTSMorphBase = {
farmIds: string;
}

export type RequestAvailableUpdatesParams = Omit<RequestAvailableUpdatesParamsTSMorphBase, "farmIds">;;

type GetSeedsParamsTSMorphBase = {
farmIds: string;
/**
 * Catalog localization language
 */
language?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
/**
 * Filter by crop name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden seeds
 */
'include-hidden'?: boolean;
/**
 * Filter by crop external id
 */
'external-ids'?: string[];
/**
 * Seed validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
}

export type GetSeedsParams = Omit<GetSeedsParamsTSMorphBase, "farmIds">;;

type PostSeedParamsTSMorphBase = {
farmIds: string;
}

export type PostSeedParams = Omit<PostSeedParamsTSMorphBase, "farmIds">;;

type PostPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type PostPlantProtectionParams = Omit<PostPlantProtectionParamsTSMorphBase, "farmIds">;;

type CopyPlantProtectionParamsTSMorphBase = {
farmIds: string;
'registration-ids': string[];
}

export type CopyPlantProtectionParams = Omit<CopyPlantProtectionParamsTSMorphBase, "farmIds">;;

type PostPlantProtectionRegistrationApplicationParamsTSMorphBase = {
farmIds: string;
}

export type PostPlantProtectionRegistrationApplicationParams = Omit<PostPlantProtectionRegistrationApplicationParamsTSMorphBase, "farmIds">;;

type ImportFertilizersFromCSVParamsTSMorphBase = {
farmIds: string;
}

export type ImportFertilizersFromCSVParams = Omit<ImportFertilizersFromCSVParamsTSMorphBase, "farmIds">;;

export type ImportFertilizersFromCSVBody = {
  file: Blob;
};

type GetOrganismsParamsTSMorphBase = {
farmIds: string;
search?: string;
'is-used'?: boolean;
'valid-only'?: boolean;
}

export type GetOrganismsParams = Omit<GetOrganismsParamsTSMorphBase, "farmIds">;;

type CreateOrganismsParamsTSMorphBase = {
farmIds: string;
}

export type CreateOrganismsParams = Omit<CreateOrganismsParamsTSMorphBase, "farmIds">;;

type GetActiveSubstancesParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetActiveSubstancesParams = Omit<GetActiveSubstancesParamsTSMorphBase, "farmIds">;;

type PostActiveSubstanceParamsTSMorphBase = {
farmIds: string;
}

export type PostActiveSubstanceParams = Omit<PostActiveSubstanceParamsTSMorphBase, "farmIds">;;

type GetFertilizersParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by fertilizer name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden fertilizers
 */
'include-hidden'?: boolean;
/**
 * Filter by fertilizer external id
 */
'external-ids'?: string[];
/**
 * Filter by fertilizer organic flag
 */
organic?: boolean;
/**
 * Filter by eAgri fertilizer nitrogen category type
 */
'eagri-nitrogen-category'?: EagriFertilizerNitrogenCategory[];
/**
 * Fertilizer validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetFertilizersParams = Omit<GetFertilizersParamsTSMorphBase, "farmIds">;;

type PostFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostFertilizerParams = Omit<PostFertilizerParamsTSMorphBase, "farmIds">;;

type ImportFertilizersFromCSV1ParamsTSMorphBase = {
farmIds: string;
}

export type ImportFertilizersFromCSV1Params = Omit<ImportFertilizersFromCSV1ParamsTSMorphBase, "farmIds">;;

export type ImportFertilizersFromCSV1Body = {
  file: Blob;
};

type GetCropsParamsTSMorphBase = {
farmIds: string;
language?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
/**
 * Filter by crop name
 */
search?: string;
/**
 * Filter by crop external id
 */
'external-ids'?: string[];
/**
 * Filter by crop validity on date
 */
'valid-on'?: string;
/**
 * Include no crop
 */
'include-no-crop'?: boolean;
}

export type GetCropsParams = Omit<GetCropsParamsTSMorphBase, "farmIds">;;

type PostCropParamsTSMorphBase = {
farmIds: string;
}

export type PostCropParams = Omit<PostCropParamsTSMorphBase, "farmIds">;;

type GetCropProductsParamsTSMorphBase = {
farmIds: string;
'crop-id'?: string;
}

export type GetCropProductsParams = Omit<GetCropProductsParamsTSMorphBase, "farmIds">;;

type PostCropProductParamsTSMorphBase = {
farmIds: string;
}

export type PostCropProductParams = Omit<PostCropProductParamsTSMorphBase, "farmIds">;;

type ImportCropsFromCSVParamsTSMorphBase = {
farmIds: string;
}

export type ImportCropsFromCSVParams = Omit<ImportCropsFromCSVParamsTSMorphBase, "farmIds">;;

export type ImportCropsFromCSVBody = {
  file: Blob;
};

type GetCropUseTypesParamsTSMorphBase = {
farmIds: string;
'crop-id'?: string;
'valid-on'?: string;
}

export type GetCropUseTypesParams = Omit<GetCropUseTypesParamsTSMorphBase, "farmIds">;;

type PostCropUseTypeParamsTSMorphBase = {
farmIds: string;
}

export type PostCropUseTypeParams = Omit<PostCropUseTypeParamsTSMorphBase, "farmIds">;;

export type ImportSurfaceWaterProtectionZonesParams = {
'source-srid': number;
};

export type ImportSurfaceWaterProtectionZonesBody = {
  file: Blob;
};

export type ImportGroundWaterProtectionZonesParams = {
'source-srid': number;
};

export type ImportGroundWaterProtectionZonesBody = {
  file: Blob;
};

type ReimportSeedApplicationsParamsTSMorphBase = {
farmIds: string;
}

export type ReimportSeedApplicationsParams = Omit<ReimportSeedApplicationsParamsTSMorphBase, "farmIds">;;

export type UpdateNitrateVulnerableParams = {
batch?: number;
'batch-size'?: number;
};

export type MoveParcelValiditiesToNewestSowingParams = {
farms: string;
parcels?: string[];
};

export type MoveActionsAfterUpdateParams = {
farms: string[];
};

export type UpdateEagriFarmParams = {
updateMode?: EagriFullFarmUpdateMode;
};

export type AddSowingPlanToCurrentSeasonParams = {
farmIds?: string;
};

type SplitActionParamsTSMorphBase = {
farmIds: string;
}

export type SplitActionParams = Omit<SplitActionParamsTSMorphBase, "farmIds">;;

type CreateSowingAction1ParamsTSMorphBase = {
farmIds: string;
}

export type CreateSowingAction1Params = Omit<CreateSowingAction1ParamsTSMorphBase, "farmIds">;;

type CreateMowingAction1ParamsTSMorphBase = {
farmIds: string;
}

export type CreateMowingAction1Params = Omit<CreateMowingAction1ParamsTSMorphBase, "farmIds">;;

type CreateHarvestAction1ParamsTSMorphBase = {
farmIds: string;
}

export type CreateHarvestAction1Params = Omit<CreateHarvestAction1ParamsTSMorphBase, "farmIds">;;

type CreateEPHAction1ParamsTSMorphBase = {
farmIds: string;
}

export type CreateEPHAction1Params = Omit<CreateEPHAction1ParamsTSMorphBase, "farmIds">;;

type ValidateEPHActionParamsTSMorphBase = {
farmIds: string;
}

export type ValidateEPHActionParams = Omit<ValidateEPHActionParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationFertilizationParamsTSMorphBase = {
farmIds: string;
}

export type GetSeedApplicationFertilizationParams = Omit<GetSeedApplicationFertilizationParamsTSMorphBase, "farmIds">;;

type SplitAction1ParamsTSMorphBase = {
farmIds: string;
}

export type SplitAction1Params = Omit<SplitAction1ParamsTSMorphBase, "farmIds">;;

type ValidateEPHAction1ParamsTSMorphBase = {
farmIds: string;
}

export type ValidateEPHAction1Params = Omit<ValidateEPHAction1ParamsTSMorphBase, "farmIds">;;

type GetParcelParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelParams = Omit<GetParcelParamsTSMorphBase, "farmIds">;;

type PatchParcelParamsTSMorphBase = {
farmIds: string;
}

export type PatchParcelParams = Omit<PatchParcelParamsTSMorphBase, "farmIds">;;

type DeleteZoneParamsTSMorphBase = {
farmIds: string;
}

export type DeleteZoneParams = Omit<DeleteZoneParamsTSMorphBase, "farmIds">;;

type UpdateZoneParamsTSMorphBase = {
farmIds: string;
}

export type UpdateZoneParams = Omit<UpdateZoneParamsTSMorphBase, "farmIds">;;

type GetSeedParamsTSMorphBase = {
farmIds: string;
}

export type GetSeedParams = Omit<GetSeedParamsTSMorphBase, "farmIds">;;

type PatchSeedParamsTSMorphBase = {
farmIds: string;
}

export type PatchSeedParams = Omit<PatchSeedParamsTSMorphBase, "farmIds">;;

type PatchCropParamsTSMorphBase = {
farmIds: string;
}

export type PatchCropParams = Omit<PatchCropParamsTSMorphBase, "farmIds">;;

type GetParcelByArealNameParamsTSMorphBase = {
farmIds: string;
'zone-name': string;
'parcel-status'?: ParcelStatus;
language: LocalLanguage;
}

export type GetParcelByArealNameParams = Omit<GetParcelByArealNameParamsTSMorphBase, "farmIds">;;

export type GetDebugPageParams = {
farmIds?: string;
parcelId?: string;
};

type GetVisualizationContentParamsTSMorphBase = {
farmIds: string;
parcelId: string;
}

export type GetVisualizationContentParams = Omit<GetVisualizationContentParamsTSMorphBase, "farmIds">;;

type GetCropsInternalParamsTSMorphBase = {
farmIds: string;
ids?: string[];
name?: string;
language?: string;
}

export type GetCropsInternalParams = Omit<GetCropsInternalParamsTSMorphBase, "farmIds">;;

export type GetCropsInternal200Item = InternalFertilizerTo | InternalMaterialToBase;

type GetParcelSowingPlan1ParamsTSMorphBase = {
farmIds: string;
language?: string;
startYear: number;
}

export type GetParcelSowingPlan1Params = Omit<GetParcelSowingPlan1ParamsTSMorphBase, "farmIds">;;

type GetParcelsParamsTSMorphBase = {
farmIds: string;
language?: string;
ids?: string[];
'valid-from'?: string;
'valid-to'?: string;
search?: string;
'crop-ids'?: string[];
status?: ParcelStatus;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetParcelsParams = Omit<GetParcelsParamsTSMorphBase, "farmIds">;;

type GetParcelDetailParamsTSMorphBase = {
farmIds: string;
language?: string;
'at-date'?: string;
}

export type GetParcelDetailParams = Omit<GetParcelDetailParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
}

export type GetSeedApplicationsParams = Omit<GetSeedApplicationsParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsByParcelIdsParamsTSMorphBase = {
farmIds: string;
parcelIds?: string[];
language: LocalLanguage;
}

export type GetSeedApplicationsByParcelIdsParams = Omit<GetSeedApplicationsByParcelIdsParamsTSMorphBase, "farmIds">;;

type GetFertilizersInternalParamsTSMorphBase = {
farmIds: string;
ids?: string[];
name?: string;
}

export type GetFertilizersInternalParams = Omit<GetFertilizersInternalParamsTSMorphBase, "farmIds">;;

type GetFertilizerMineralIntakeParamsTSMorphBase = {
farmIds: string;
'unit-id': string;
dose: number;
}

export type GetFertilizerMineralIntakeParams = Omit<GetFertilizerMineralIntakeParamsTSMorphBase, "farmIds">;;

type GetFarmDetail1ParamsTSMorphBase = {
farmIds: string;
}

export type GetFarmDetail1Params = Omit<GetFarmDetail1ParamsTSMorphBase, "farmIds">;;

export type SearchFarmsParams = {
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

type GetCropsInternal1ParamsTSMorphBase = {
farmIds: string;
'external-id'?: string[];
}

export type GetCropsInternal1Params = Omit<GetCropsInternal1ParamsTSMorphBase, "farmIds">;;

type GetCropCatalogueTypeParamsTSMorphBase = {
farmIds: string;
}

export type GetCropCatalogueTypeParams = Omit<GetCropCatalogueTypeParamsTSMorphBase, "farmIds">;;

type GetConnectableSeedApplicationsParamsTSMorphBase = {
farmIds: string;
'seed-application-id'?: string;
'group-id'?: string;
}

export type GetConnectableSeedApplicationsParams = Omit<GetConnectableSeedApplicationsParamsTSMorphBase, "farmIds">;;

export type GetConnectableSeedApplications200Item = ConnectableSeedApplicationV2GroupTo | ConnectableSeedApplicationV2To;

export type GetConnectableSeedApplications400Item = ConnectableSeedApplicationV2GroupTo | ConnectableSeedApplicationV2To;

export type GetConnectableSeedApplications404Item = ConnectableSeedApplicationV2GroupTo | ConnectableSeedApplicationV2To;

type GetSeedApplicationsV2AtDateParamsTSMorphBase = {
farmIds: string;
'parcel-ids': string[];
date: string;
'action-type': ActionType;
}

export type GetSeedApplicationsV2AtDateParams = Omit<GetSeedApplicationsV2AtDateParamsTSMorphBase, "farmIds">;;

type CheckFertilizerUseReportParamsTSMorphBase = {
farmIds: string;
guid: string;
}

export type CheckFertilizerUseReportParams = Omit<CheckFertilizerUseReportParamsTSMorphBase, "farmIds">;;

type GetSowingPlanStatisticsParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetSowingPlanStatisticsParams = Omit<GetSowingPlanStatisticsParamsTSMorphBase, "farmIds">;;

type GetSeasonsExcelParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
language?: LocalLanguage;
'parcel-ids'?: string[];
}

export type GetSeasonsExcelParams = Omit<GetSeasonsExcelParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsGeometriesAtDateParamsTSMorphBase = {
farmIds: string;
'parcel-id': string;
locale: LocalLanguage;
}

export type GetSeedApplicationsGeometriesAtDateParams = Omit<GetSeedApplicationsGeometriesAtDateParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsAtDateParamsTSMorphBase = {
farmIds: string;
/**
 * Action id to determine which seed app to return when there are multiple seed apps, for example when harvest and sowing at the same time, when user opens sowing seed app started with sowing should be shown when harvest seed app with harvest
 */
'action-id'?: string;
'parcel-ids': string[];
date: string;
locale: LocalLanguage;
}

export type GetSeedApplicationsAtDateParams = Omit<GetSeedApplicationsAtDateParamsTSMorphBase, "farmIds">;;

type GetSeededAreasV2ReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetSeededAreasV2ReportParams = Omit<GetSeededAreasV2ReportParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsV2ReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetSeedApplicationsV2ReportParams = Omit<GetSeedApplicationsV2ReportParamsTSMorphBase, "farmIds">;;

type GetRevenuesV2ReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetRevenuesV2ReportParams = Omit<GetRevenuesV2ReportParamsTSMorphBase, "farmIds">;;

type GetNitrateBalanceV2ReportParamsTSMorphBase = {
farmIds: string;
year: number;
language: LocalLanguage;
}

export type GetNitrateBalanceV2ReportParams = Omit<GetNitrateBalanceV2ReportParamsTSMorphBase, "farmIds">;;

type GetSeededAreasParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetSeededAreasParams = Omit<GetSeededAreasParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetSeedApplicationsReportParams = Omit<GetSeedApplicationsReportParamsTSMorphBase, "farmIds">;;

type GetRevenuesReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetRevenuesReportParams = Omit<GetRevenuesReportParamsTSMorphBase, "farmIds">;;

type GetRestrictionsSowingReportParamsTSMorphBase = {
farmIds: string;
date: string;
'failed-only'?: boolean;
'parcel-ids'?: string[];
seasons?: string;
codes?: string[];
language?: string;
}

export type GetRestrictionsSowingReportParams = Omit<GetRestrictionsSowingReportParamsTSMorphBase, "farmIds">;;

type GetPorUsageReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetPorUsageReportParams = Omit<GetPorUsageReportParamsTSMorphBase, "farmIds">;;

type GetPorConsumptionByPPReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetPorConsumptionByPPReportParams = Omit<GetPorConsumptionByPPReportParamsTSMorphBase, "farmIds">;;

type GetPorConsumptionByCropReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetPorConsumptionByCropReportParams = Omit<GetPorConsumptionByCropReportParamsTSMorphBase, "farmIds">;;

type GetParcels1ParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
}

export type GetParcels1Params = Omit<GetParcels1ParamsTSMorphBase, "farmIds">;;

type GetParcels2ParamsTSMorphBase = {
farmIds: string;
year: number;
language: LocalLanguage;
}

export type GetParcels2Params = Omit<GetParcels2ParamsTSMorphBase, "farmIds">;;

type GetReportsParamsTSMorphBase = {
farmIds: string;
type: ReportType;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetReportsParams = Omit<GetReportsParamsTSMorphBase, "farmIds">;;

type GetFertilizerUsageReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerUsageReportParams = Omit<GetFertilizerUsageReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerOrganicReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerOrganicReportParams = Omit<GetFertilizerOrganicReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerConsumptionReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerConsumptionReportParams = Omit<GetFertilizerConsumptionReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerConsumptionByCropReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerConsumptionByCropReportParams = Omit<GetFertilizerConsumptionByCropReportParamsTSMorphBase, "farmIds">;;

type GetFarmNitrogenReportParamsTSMorphBase = {
farmIds: string;
'date-from': string;
'file-type': FileType;
language?: string;
}

export type GetFarmNitrogenReportParams = Omit<GetFarmNitrogenReportParamsTSMorphBase, "farmIds">;;

type GetCvsReportParamsTSMorphBase = {
farmIds: string;
}

export type GetCvsReportParams = Omit<GetCvsReportParamsTSMorphBase, "farmIds">;;

type GetEagriPorUseErrorsParamsTSMorphBase = {
farmIds: string;
guid: string;
}

export type GetEagriPorUseErrorsParams = Omit<GetEagriPorUseErrorsParamsTSMorphBase, "farmIds">;;

type CheckFertilizerUserReportParamsTSMorphBase = {
farmIds: string;
guid: string;
}

export type CheckFertilizerUserReportParams = Omit<CheckFertilizerUserReportParamsTSMorphBase, "farmIds">;;

type GetActionsReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetActionsReportParams = Omit<GetActionsReportParamsTSMorphBase, "farmIds">;;

type GetParcels3ParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by their sown status.<ul><li>If <b>true</b>, filters only sown parcels</li><li>If <b>false</b>, filters only unsown parcel</li><li>If <b>null</b>, no sowning filter is applied</li></ul>
 */
sown?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetParcels3Params = Omit<GetParcels3ParamsTSMorphBase, "farmIds">;;

type GetParcelSubtractionHistoryParamsTSMorphBase = {
farmIds: string;
otherParcels: string[];
'valid-date'?: string;
}

export type GetParcelSubtractionHistoryParams = Omit<GetParcelSubtractionHistoryParamsTSMorphBase, "farmIds">;;

type DeleteParcelSubtractionParamsTSMorphBase = {
farmIds: string;
type: RestrictionType;
value: number;
}

export type DeleteParcelSubtractionParams = Omit<DeleteParcelSubtractionParamsTSMorphBase, "farmIds">;;

type GetSeedApplications1ParamsTSMorphBase = {
farmIds: string;
'exclude-no-crop'?: boolean;
language?: string;
}

export type GetSeedApplications1Params = Omit<GetSeedApplications1ParamsTSMorphBase, "farmIds">;;

type GetLastNoCropSeedApplicationWithPlannedCropParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetLastNoCropSeedApplicationWithPlannedCropParams = Omit<GetLastNoCropSeedApplicationWithPlannedCropParamsTSMorphBase, "farmIds">;;

type GetParcelPredecessorsParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelPredecessorsParams = Omit<GetParcelPredecessorsParamsTSMorphBase, "farmIds">;;

type GetParcelFollowingParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelFollowingParams = Omit<GetParcelFollowingParamsTSMorphBase, "farmIds">;;

type GetExchangeCandidatesParamsTSMorphBase = {
farmIds: string;
language?: string;
'at-date'?: string;
}

export type GetExchangeCandidatesParams = Omit<GetExchangeCandidatesParamsTSMorphBase, "farmIds">;;

type GetParcelRestrictionsParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelRestrictionsParams = Omit<GetParcelRestrictionsParamsTSMorphBase, "farmIds">;;

type GetWaterParcelDistanceParamsTSMorphBase = {
farmIds: string;
'parcel-ids': string[];
}

export type GetWaterParcelDistanceParams = Omit<GetWaterParcelDistanceParamsTSMorphBase, "farmIds">;;

type GetParcelsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by their sown status.<ul><li>If <b>true</b>, filters only sown parcels</li><li>If <b>false</b>, filters only unsown parcel</li><li>If <b>null</b>, no sowning filter is applied</li></ul>
 */
sown?: boolean;
page?: number;
'per-page'?: number;
'sort-col'?: ParcelV2SortColumn;
'sort-dir'?: SortDirection;
}

export type GetParcelsV2Params = Omit<GetParcelsV2ParamsTSMorphBase, "farmIds">;;

type GetParcelDetailV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelDetailV2Params = Omit<GetParcelDetailV2ParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetSeedApplicationsV2Params = Omit<GetSeedApplicationsV2ParamsTSMorphBase, "farmIds">;;

export type GetSeedApplicationsV2200Item = ParcelSeedApplicationGroupToV2 | ParcelSeedApplicationToV2;

export type GetSeedApplicationsV2404Item = ParcelSeedApplicationGroupToV2 | ParcelSeedApplicationToV2;

type GetActionsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
'seedApplication-ids'?: string[];
'action-types'?: ActionType[];
'date-from'?: string;
'date-to'?: string;
'material-type'?: MaterialType;
'material-ids'?: string[];
sources?: ActionSource[];
'is-draft'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsV2Params = Omit<GetActionsV2ParamsTSMorphBase, "farmIds">;;

type GetParcelStatisticsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelStatisticsV2Params = Omit<GetParcelStatisticsV2ParamsTSMorphBase, "farmIds">;;

type GetParcelMapDataV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelMapDataV2Params = Omit<GetParcelMapDataV2ParamsTSMorphBase, "farmIds">;;

type GetParcelSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by their sown status.<ul><li>If <b>true</b>, filters only sown parcels</li><li>If <b>false</b>, filters only unsown parcel</li><li>If <b>null</b>, no sowning filter is applied</li></ul>
 */
sown?: boolean;
}

export type GetParcelSuggestionsParams = Omit<GetParcelSuggestionsParamsTSMorphBase, "farmIds">;;

type GetParcelStatisticsParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelStatisticsParams = Omit<GetParcelStatisticsParamsTSMorphBase, "farmIds">;;

type GetParcelsForMapParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelsForMapParams = Omit<GetParcelsForMapParamsTSMorphBase, "farmIds">;;

type GetParcelsForMapBySeasonParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelsForMapBySeasonParams = Omit<GetParcelsForMapBySeasonParamsTSMorphBase, "farmIds">;;

export type GetLandUseParams = {
language?: string;
};

type GetParcelCurrentSeedApplicationColorsParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelCurrentSeedApplicationColorsParams = Omit<GetParcelCurrentSeedApplicationColorsParamsTSMorphBase, "farmIds">;;

type GetCentersParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetCentersParams = Omit<GetCentersParamsTSMorphBase, "farmIds">;;

type GetActionsAndSeedAppsAtDetailParamsTSMorphBase = {
farmIds: string;
'parcel-id': string;
language: LocalLanguage;
'date-from'?: string;
'date-to'?: string;
'material-ids'?: string[];
'is-draft'?: boolean;
sources?: ActionSource[];
'target-crop-ids'?: string[];
'action-types'?: ActionType[];
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsAndSeedAppsAtDetailParams = Omit<GetActionsAndSeedAppsAtDetailParamsTSMorphBase, "farmIds">;;

type GetFarmUpdatesParamsTSMorphBase = {
farmIds: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetFarmUpdatesParams = Omit<GetFarmUpdatesParamsTSMorphBase, "farmIds">;;

type GetFullLpisDetailParamsTSMorphBase = {
farmIds: string;
validFrom?: string;
}

export type GetFullLpisDetailParams = Omit<GetFullLpisDetailParamsTSMorphBase, "farmIds">;;

export type SearchCountriesParams = {
search?: string;
language?: string;
};

type GetCataloguesParamsTSMorphBase = {
farmIds: string;
}

export type GetCataloguesParams = Omit<GetCataloguesParamsTSMorphBase, "farmIds">;;

type GetSeedSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Catalog localization language
 */
language?: string;
/**
 * Filter by crop name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden seeds
 */
'include-hidden'?: boolean;
/**
 * Filter by crop external id
 */
'external-ids'?: string[];
/**
 * Seed validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
}

export type GetSeedSuggestionsParams = Omit<GetSeedSuggestionsParamsTSMorphBase, "farmIds">;;

type GetCropsCatalogSourceParamsTSMorphBase = {
farmIds: string;
}

export type GetCropsCatalogSourceParams = Omit<GetCropsCatalogSourceParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionDetailParamsTSMorphBase = {
farmIds: string;
}

export type GetPlantProtectionDetailParams = Omit<GetPlantProtectionDetailParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionDetailApplicationsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
}

export type GetPlantProtectionDetailApplicationsParams = Omit<GetPlantProtectionDetailApplicationsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionApplicationsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
cropGrowthStage?: CropGrowthStage;
}

export type GetPlantProtectionApplicationsParams = Omit<GetPlantProtectionApplicationsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Set of crop ids
 */
'crop-id'?: string[];
/**
 * Returns all plant protections that are usable after given date
 */
'usable-until'?: string;
/**
 * Filter by plant protection name
 */
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetPlantProtectionSuggestionsParams = Omit<GetPlantProtectionSuggestionsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionsParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by plant protection product name
 */
search?: string;
/**
 * Set of catalogue ids
 */
catalogue?: string[];
/**
 * Include hidden plant protection products
 */
'include-hidden'?: boolean;
/**
 * Plant protection usability end
 */
'usable-until'?: string;
/**
 * If true, returns only favorite plant protection products
 */
'favorite-only'?: boolean;
'crop-id'?: string[];
'organism-id'?: string[];
'active-substance-id'?: string[];
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetPlantProtectionsParams = Omit<GetPlantProtectionsParamsTSMorphBase, "farmIds">;;

type GetBioFunctionParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetBioFunctionParams = Omit<GetBioFunctionParamsTSMorphBase, "farmIds">;;

type GetFertilizerMineralIntake1ParamsTSMorphBase = {
farmIds: string;
unitId: string;
dose: number;
}

export type GetFertilizerMineralIntake1Params = Omit<GetFertilizerMineralIntake1ParamsTSMorphBase, "farmIds">;;

type GetFertilizerSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Filter by fertilizer name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden fertilizers
 */
'include-hidden'?: boolean;
/**
 * Filter by fertilizer external id
 */
'external-ids'?: string[];
/**
 * Filter by fertilizer organic flag
 */
organic?: boolean;
/**
 * Filter by eAgri fertilizer nitrogen category type
 */
'eagri-nitrogen-category'?: EagriFertilizerNitrogenCategory[];
/**
 * Fertilizer validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
}

export type GetFertilizerSuggestionsParams = Omit<GetFertilizerSuggestionsParamsTSMorphBase, "farmIds">;;

export type GetFertilizerRegistratinTypeParams = {
language?: LocalLanguage;
};

export type GetFertilizerNitrogenCategoryParams = {
language?: LocalLanguage;
};

type GetCropParamsTSMorphBase = {
farmIds: string;
}

export type GetCropParams = Omit<GetCropParamsTSMorphBase, "farmIds">;;

type ExportCropsToCSVParamsTSMorphBase = {
farmIds: string;
}

export type ExportCropsToCSVParams = Omit<ExportCropsToCSVParamsTSMorphBase, "farmIds">;;

export type GetAllFarmsParams = {
name?: string;
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

export type GetFullLpisDetail1Params = {
validFrom?: string;
};

type GetActionsParamsTSMorphBase = {
farmIds: string;
language?: string;
search?: string;
parcelIds?: string[];
parcels?: string[];
from?: string;
'date-to'?: string;
cropId?: string;
'target-crop-ids'?: string[];
materialType?: MaterialType;
seedApplicationIds?: string[];
type?: ActionType[];
materialIds?: string[];
sources?: ActionSource[];
'is-draft'?: boolean;
'with-fertilizer-detail'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsParams = Omit<GetActionsParamsTSMorphBase, "farmIds">;;

type DeleteActionsParamsTSMorphBase = {
actionIds: string[];
farmIds: string;
}

export type DeleteActionsParams = Omit<DeleteActionsParamsTSMorphBase, "farmIds">;;

type GetActionParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetActionParams = Omit<GetActionParamsTSMorphBase, "farmIds">;;

export type GetAction200 = ActionEPHDetailTo | ActionOtherDetailTo | ActionRevenueDetailTo | ActionSowingDetailTo;

type DeleteActionParamsTSMorphBase = {
farmIds: string;
}

export type DeleteActionParams = Omit<DeleteActionParamsTSMorphBase, "farmIds">;;

type GetActionV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetActionV2Params = Omit<GetActionV2ParamsTSMorphBase, "farmIds">;;

export type GetActionV2200 = ActionEPHDetailTo | ActionOtherDetailTo | ActionRevenueDetailTo | ActionSowingDetailTo;

type GetTargetSeedApplicationParamsTSMorphBase = {
farmIds: string;
'target-crop-id': string;
'action-date': string;
'parcel-Ids': string[];
'except-action-id'?: string;
language: LocalLanguage;
}

export type GetTargetSeedApplicationParams = Omit<GetTargetSeedApplicationParamsTSMorphBase, "farmIds">;;

type GetActionsOverviewV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
search?: string;
'parcel-Ids'?: string[];
'date-from'?: string;
'date-to'?: string;
'target-crop-ids'?: string[];
'material-type'?: MaterialType;
'action-types'?: ActionType[];
'material-ids'?: string[];
'action-sources'?: ActionSource[];
'is-draft'?: boolean;
'has-parcel-outside-validity'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsOverviewV2Params = Omit<GetActionsOverviewV2ParamsTSMorphBase, "farmIds">;;

type GetUsedSeedsParamsTSMorphBase = {
farmIds: string;
search?: string;
language: LocalLanguage;
}

export type GetUsedSeedsParams = Omit<GetUsedSeedsParamsTSMorphBase, "farmIds">;;

type GetUsedPlantProtectionsParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetUsedPlantProtectionsParams = Omit<GetUsedPlantProtectionsParamsTSMorphBase, "farmIds">;;

type GetUsedFertilizersParamsTSMorphBase = {
farmIds: string;
'include-hidden'?: boolean;
search?: string;
}

export type GetUsedFertilizersParams = Omit<GetUsedFertilizersParamsTSMorphBase, "farmIds">;;

type TargetSeedApplicationApplicationsParamsTSMorphBase = {
farmIds: string;
'target-crop-id': string;
'action-date': string;
'parcel-ids': string[];
'except-action-id'?: string;
language: LocalLanguage;
}

export type TargetSeedApplicationApplicationsParams = Omit<TargetSeedApplicationApplicationsParamsTSMorphBase, "farmIds">;;

export type GetCropGrowthStagesParams = {
language: LocalLanguage;
};

export type GetActionTypesParams = {
language?: string;
group?: ActionTypeGroupTo;
};

type RemoveFromGroupParamsTSMorphBase = {
farmIds: string;
}

export type RemoveFromGroupParams = Omit<RemoveFromGroupParamsTSMorphBase, "farmIds">;;

type ResetSeasonParamsTSMorphBase = {
farmIds: string;
}

export type ResetSeasonParams = Omit<ResetSeasonParamsTSMorphBase, "farmIds">;;

type EvictParcelChainCacheEventParamsTSMorphBase = {
farmIds: string;
}

export type EvictParcelChainCacheEventParams = Omit<EvictParcelChainCacheEventParamsTSMorphBase, "farmIds">;;

/**
 * @summary Updates centers (batch)
 */
export const updateCenters = <TData = AxiosResponse<InternalCenterTo[]>>(
    internalCenterCreateTo: InternalCenterCreateTo[],
    params: UpdateCentersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/centers`,
      internalCenterCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing seed parcel lifecycle. Only provided fields will be updated.
 * @summary Update seed parcel lifecycle
 */
export const updateSeedApplicationV2 = <TData = AxiosResponse<SeedApplicationV2To>>(
    id: string,
    seedApplicationV2UpdateTo: SeedApplicationV2UpdateTo,
    params: UpdateSeedApplicationV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/${id}`,
      seedApplicationV2UpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Deletes an existing seed parcel lifecycle.
 * @summary Delete seed parcel lifecycle
 */
export const deleteSeedApplicationV2 = <TData = AxiosResponse<null>>(
    id: string,
    params: DeleteSeedApplicationV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Updates a seed application group. The request defines the desired state of the group:

- **Members in request** = kept in group (or added if new), with optional attribute updates
- **Members in request with deleted=true** = permanently deleted
- **Existing members NOT in request** = automatically removed from group (kept as standalone)

Supports:
- Updating common fields (seedId, cropUseTypeId, isCatchCrop, mainHarvestableProduct) for all members
- Updating individual fields (dates, area) per member
- Use groupId field for orphan cleanup when moving member from another group

Returns null if the group was disbanded (less than 2 members remain after update).
 * @summary Update seed application group
 */
export const updateSeedApplicationV2Group = <TData = AxiosResponse<SeedApplicationV2GroupToV2>>(
    groupId: string,
    seedApplicationV2GroupUpdateTo: SeedApplicationV2GroupUpdateTo,
    params: UpdateSeedApplicationV2GroupParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/groups/${groupId}`,
      seedApplicationV2GroupUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Sets group_id to NULL for ALL seed applications that share the specified groupId. This effectively dissolves the group, leaving all members as individual seed applications.
 * @summary Disband an entire group
 */
export const disbandGroup = <TData = AxiosResponse<null>>(
    groupId: string,
    params: DisbandGroupParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/groups/${groupId}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getDetailedParcelWithSowingPlan = <TData = AxiosResponse<ParcelWithSowingPlansTo[]>>(
    params: GetDetailedParcelWithSowingPlanParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const putCropsToParcelAndSeason = <TData = AxiosResponse<null>>(
    bulkSowingPlanParcelCropBody: BulkSowingPlanParcelCropBody,
    params: PutCropsToParcelAndSeasonParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/parcels`,
      bulkSowingPlanParcelCropBody,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getParcelSowingPlan = <TData = AxiosResponse<SowingPlanSeasonCropTo[]>>(
    parcelId: string,
    params: GetParcelSowingPlanParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/parcels/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const putCropToParcelAndSeason = <TData = AxiosResponse<null>>(
    parcelId: string,
    sowingPlanParcelCropBody: SowingPlanParcelCropBody,
    params: PutCropToParcelAndSeasonParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/parcels/${parcelId}`,
      sowingPlanParcelCropBody,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * 
            Updates parcels from shapefile with parcel historization.

            It is advised to use /dry and check how the parcels will be retired beforehand as it is not rollback-able.
            Does not work with CZ farms or farms with active integration.
            Can be used for partial update - shapefile can contain one parcel that needs to be updated and the rest will stay the same.
            
 * @summary Updates parcels from shapefile with parcel historization.
 */
export const updateFarmFromShapefile = <TData = AxiosResponse<unknown>>(
    updateFarmFromShapefileBody: UpdateFarmFromShapefileBody,
    params: UpdateFarmFromShapefileParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/shapefile`,
      updateFarmFromShapefileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
            Validates eAgri credentials for the farm. 
            If validation is successful, returns farm name from eAgri, otherwise returns error message and status. 
            In any case, returns farm szrid and login, if they are stored. Secret (WS key) is never returned in the response.
        
 * @summary Returns farm eAgri credentials
 */
export const getEagriAuth = <TData = AxiosResponse<EagriAuthDataValidationResponseTo>>(
    farmId: string,
    params?: GetEagriAuthParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/settings/${farmId}/eagri-auth`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
            Validates eAgri credentials for the farm and stores them if validation is successful.
        
 * @summary Validas and stores farm eAgri credentials
 */
export const putEagriAuth = <TData = AxiosResponse<EagriAuthDataValidationResponseTo>>(
    farmId: string,
    eagriAuthDataValidationRequestTo: EagriAuthDataValidationRequestTo, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/settings/${farmId}/eagri-auth`,
      eagriAuthDataValidationRequestTo,options
    );
  }

/**
 * 
            Updates a farm using eAGRI service. Farms created using SHP or empty foreign farms are not allowed to use this endpoint.
            At most one concurrent update per farm is permitted.
            
            Farm update also automatically synchronizes eAGRI catalogues. If you wish to turn off this behaviour,
            set request parameter sync-catalogues to false.
            
            Note that update logic itself, i.e. logic beyond concurrency and eligibility checks, is asynchronous.
            If you wish to see current update status, use /api/farms/updated.
            
 * @summary Updates a farm using eAGRI webservices.
 */
export const updateFarm = <TData = AxiosResponse<null>>(
    farmId: string,
    params?: UpdateFarmParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/eagri/${farmId}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Updates plant protection product in PRIVATE catalogue.
 * @summary Update plant protection
 */
export const putPlantProtection = <TData = AxiosResponse<PlantProtectionDetailTo>>(
    plantProtectionId: string,
    plantProtectionCreateUpdateTo: PlantProtectionCreateUpdateTo,
    params: PutPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}`,
      plantProtectionCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates plant protection product in PRIVATE catalogue.
 * @summary Update plant protection
 */
export const patchPlantProtection = <TData = AxiosResponse<null>>(
    plantProtectionId: string,
    plantProtectionPatchTo: PlantProtectionPatchTo,
    params: PatchPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}`,
      plantProtectionPatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Update plant protection application
 */
export const putPlantProtectionRegistrationApplication = <TData = AxiosResponse<null>>(
    plantProtectionId: string,
    applicationId: string,
    plantProtectionApplicationCreateTo: PlantProtectionApplicationCreateTo,
    params: PutPlantProtectionRegistrationApplicationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/${applicationId}`,
      plantProtectionApplicationCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Delete plant protection application
 */
export const deletePlantProtectionRegistrationApplication = <TData = AxiosResponse<null>>(
    plantProtectionId: string,
    applicationId: string,
    params: DeletePlantProtectionRegistrationApplicationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/${applicationId}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Returns fertilizer detail.
 * @summary Fertilizer detail
 */
export const getFertilizer = <TData = AxiosResponse<FertilizerDetailTo>>(
    fertilizerId: string,
    params: GetFertilizerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Update fertilizer
 */
export const putFertilizer = <TData = AxiosResponse<FertilizerDetailTo>>(
    fertilizerId: string,
    fertilizerCreateTo: FertilizerCreateTo,
    params: PutFertilizerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}`,
      fertilizerCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Hidden fertilizers are not deleted, and can be un-hidden by PUT request.
 * @summary Hides fertilizer
 */
export const hideFertilizer = <TData = AxiosResponse<FertilizerDetailTo>>(
    fertilizerId: string,
    fertilizerPatchTo: FertilizerPatchTo,
    params: HideFertilizerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}`,
      fertilizerPatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateCropProducts = <TData = AxiosResponse<null>>(
    cropId: string,
    cropProductUseTypeUpdateTo: CropProductUseTypeUpdateTo[],
    params: UpdateCropProductsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/${cropId}/products`,
      cropProductUseTypeUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const putCropProduct = <TData = AxiosResponse<CropProductTo>>(
    id: string,
    cropProductUpdateTo: CropProductUpdateTo,
    params: PutCropProductParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/products/${id}`,
      cropProductUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const putCropUseType = <TData = AxiosResponse<CropUseTypeTo>>(
    id: string,
    cropUseTypeUpdateTo: CropUseTypeUpdateTo,
    params: PutCropUseTypeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use/${id}`,
      cropUseTypeUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateSkeagisFarm = <TData = AxiosResponse<SkeagisFarmUpdateResult>>(
    params: UpdateSkeagisFarmParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/update-skeagis-farm`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const overwriteParcelGeometries = <TData = AxiosResponse<ParcelGeometryOverwriteResult>>(
    params: OverwriteParcelGeometriesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/overwrite-parcel-geometries`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns detail of a farm user is authorized.
 * @summary Returns farm detail
 */
export const getFarmDetail = <TData = AxiosResponse<AdminFarmTo>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}`,options
    );
  }

/**
 * @summary Update farm
 */
export const putFarm = <TData = AxiosResponse<AdminFarmTo>>(
    farmId: string,
    adminFarmUpdateTo: AdminFarmUpdateTo, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}`,
      adminFarmUpdateTo,options
    );
  }

export const updateFarmCurrentParcels = <TData = AxiosResponse<null>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/eagri/current-parcels`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateAllFarmsCurrentParcels = <TData = AxiosResponse<null>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/eagri/current-parcels`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const resaveActionStoreTransactions = <TData = AxiosResponse<null>>(
    params: ResaveActionStoreTransactionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/actions/resave-stores`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateSkeagisState = <TData = AxiosResponse<FarmIntegrationResponse>>(
    farmSkeagisUpdateRequest: FarmSkeagisUpdateRequest,
    params: UpdateSkeagisStateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farm/integrations/skeagis`,
      farmSkeagisUpdateRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createNewSkeagisIntegration = <TData = AxiosResponse<FarmIntegrationResponse>>(
    farmSkeagisCreateRequest: FarmSkeagisCreateRequest,
    params: CreateNewSkeagisIntegrationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farm/integrations/skeagis`,
      farmSkeagisCreateRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing sowing action using seed_application_v2. Automatically updates seed application V2 records based on date and parcel.
 * @summary Update sowing action (V2)
 */
export const updateSowingAction = <TData = AxiosResponse<ActionIdTo>>(
    actionId: string,
    actionSowingCreateV2To: ActionSowingCreateV2To,
    params: UpdateSowingActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/sowing/${actionId}`,
      actionSowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing mowing action using seed_application_v2. Works with existing seed application V2 records based on date and parcel.
 * @summary Update mowing action (V2)
 */
export const updateMowingAction = <TData = AxiosResponse<ActionIdTo>>(
    actionId: string,
    actionMowingCreateV2To: ActionMowingCreateV2To,
    params: UpdateMowingActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/mowing/${actionId}`,
      actionMowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing harvest action using seed_application_v2. Automatically manages seed application V2 records based on date and parcel.
 * @summary Update harvest action (V2)
 */
export const updateHarvestAction = <TData = AxiosResponse<ActionIdTo>>(
    actionId: string,
    actionHarvestCreateV2To: ActionHarvestCreateV2To,
    params: UpdateHarvestActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/harvest/${actionId}`,
      actionHarvestCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing EPH action using seed_application_v2. Accepts targetCropId for form compatibility, but target crop is determined by date and parcel.
 * @summary Update EPH action (V2)
 */
export const updateEPHAction = <TData = AxiosResponse<ActionIdTo>>(
    actionId: string,
    actionEPHCreateV2To: ActionEPHCreateV2To,
    params: UpdateEPHActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/eph/${actionId}`,
      actionEPHCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateSowingAction1 = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionSowingCreateTo: ActionSowingCreateTo,
    params: UpdateSowingAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/sowing`,
      actionSowingCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createSowingAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionSowingCreateTo: ActionSowingCreateTo,
    params: CreateSowingActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/sowing`,
      actionSowingCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateOtherAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionOtherCreateTo: ActionOtherCreateTo,
    params: UpdateOtherActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/other`,
      actionOtherCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createOtherAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionOtherCreateTo: ActionOtherCreateTo,
    params: CreateOtherActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/other`,
      actionOtherCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateMowingAction1 = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionMowingCreateTo: ActionMowingCreateTo,
    params: UpdateMowingAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/mowing`,
      actionMowingCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createMowingAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionMowingCreateTo: ActionMowingCreateTo,
    params: CreateMowingActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/mowing`,
      actionMowingCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateHarvestAction1 = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionHarvestCreateTo: ActionHarvestCreateTo,
    params: UpdateHarvestAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/harvest`,
      actionHarvestCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createHarvestAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionHarvestCreateTo: ActionHarvestCreateTo,
    params: CreateHarvestActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/harvest`,
      actionHarvestCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateEPHAction1 = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionEPHCreateTo: ActionEPHCreateTo,
    params: UpdateEPHAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/eph`,
      actionEPHCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createEPHAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    actionEPHCreateTo: ActionEPHCreateTo,
    params: CreateEPHActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/eph`,
      actionEPHCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionsInternal = <TData = AxiosResponse<GetPlantProtectionsInternal200Item[]>>(
    getInternalPlantProtectionMaterialBody: GetInternalPlantProtectionMaterialBody,
    params: GetPlantProtectionsInternalParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/plant-protections`,
      getInternalPlantProtectionMaterialBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of parcels intersecting with the given geometry. The parcel's crop corresponds to the at-date parameter, which defaults to today's date.
 * @summary Returns list of parcels
 */
export const getParcelIntersections = <TData = AxiosResponse<InternalParcelTo[]>>(
    geoJsonMultiPoint: GeoJsonMultiPoint,
    params: GetParcelIntersectionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/intersecting`,
      geoJsonMultiPoint,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of parcels intersecting with the given geometry in a country. The parcel's crop corresponds to the at-date parameter, which defaults to today's date.
 * @summary Returns list of parcels intersected by country
 */
export const getParcelIntersections1 = <TData = AxiosResponse<InternalIntersectionParcelTo[]>>(
    geoJsonMultiPoint: GeoJsonMultiPoint,
    params: GetParcelIntersections1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/intersecting/international`,
      geoJsonMultiPoint,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionInfo = <TData = AxiosResponse<InternalActionInfo[]>>(
    internalActionInfoRequestBodyTo: InternalActionInfoRequestBodyTo,
    params: GetActionInfoParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/actions/notes`,
      internalActionInfoRequestBodyTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createDraftAction = <TData = AxiosResponse<InternalActionIdResponse>>(
    internalTelematicsActionCreate: InternalTelematicsActionCreate,
    params: CreateDraftActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/actions/draft`,
      internalTelematicsActionCreate,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a paginated list of seed parcel lifecycles filtered by query parameters. Results may include individual lifecycles or grouped lifecycles (when multiple lifecycles share a group_id, e.g., after parcel splits). Both types implement SeedApplicationResultTo interface.
 * @summary Get seed parcel lifecycles
 */
export const getSeedApplicationV2s = <TData = AxiosResponse<GetSeedApplicationV2s200Item[]>>(
    params: GetSeedApplicationV2sParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new seed parcel lifecycle representing a crop growing on a parcel.
 * @summary Create seed parcel lifecycle
 */
export const createSeedApplicationV2 = <TData = AxiosResponse<SeedApplicationV2To>>(
    seedApplicationV2CreateTo: SeedApplicationV2CreateTo,
    params: CreateSeedApplicationV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications`,
      seedApplicationV2CreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new group from existing seed applications. This is used when a user wants to create a group from a standalone seed application by connecting it with other seed applications. All specified members will be assigned a newly generated group_id. A group must have at least 2 members.
 * @summary Create seed application group
 */
export const createSeedApplicationV2Group = <TData = AxiosResponse<SeedApplicationV2GroupToV2>>(
    seedApplicationV2GroupCreateTo: SeedApplicationV2GroupCreateTo,
    params: CreateSeedApplicationV2GroupParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/groups`,
      seedApplicationV2GroupCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
            Uses seed_application_v2 table instead of action-based seed applications.

            IMPORTANT: Only this dry endpoint is available for V2 testing.
            The actual send endpoint is NOT implemented because POR report has no test mode -
            sending would go directly to production eAgri system.

            Date range logic:
            - From: July 1 of previous year (calculated automatically)
            - To: provided toDate parameter (should be last day of month)
        
 * @summary V2: Returns POR use report data using seed_application_v2. For testing purposes.
 */
export const getPorUseReportBodyV2 = <TData = AxiosResponse<PorUseBody>>(
    params: GetPorUseReportBodyV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/por-usage/dry`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Uses seed_application_v2 table for crop lifecycle data.
 * @summary V2: Sends fertilizer use report to eagri using seed_application_v2.
 */
export const sendFertilizerUseReportToEagriV2 = <TData = AxiosResponse<EagriReportResponse>>(
    eagriReportBody: EagriReportBody,
    params: SendFertilizerUseReportToEagriV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/fertilizer-usage`,
      eagriReportBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Uses seed_application_v2 table instead of action-based seed applications.
 * @summary V2: Returns fertilizer use report data using seed_application_v2. For testing purposes.
 */
export const getFertilizerUseReportBodyV2 = <TData = AxiosResponse<FertiliserUseBody>>(
    eagriReportBody: EagriReportBody,
    params: GetFertilizerUseReportBodyV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/fertilizer-usage/dry`,
      eagriReportBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeasons = <TData = AxiosResponse<SowingPlanSeasonTo[]>>(
    params: GetSeasonsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/seasons`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createMissingSeasons = <TData = AxiosResponse<SowingPlanSeasonTo[]>>(
    params: CreateMissingSeasonsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/seasons`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Sends por use report to eagri, for given date range.
 */
export const sendPorUserReportToEagri = <TData = AxiosResponse<PlantProtectionPairingResultTo>>(
    params: SendPorUserReportToEagriParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/por-usage`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary This is for testing, dont use it on FE. Returns body that would be sent to eagri.
 */
export const getEagriPorUseReportBody = <TData = AxiosResponse<PorUseBody>>(
    params: GetEagriPorUseReportBodyParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/por-usage/dry`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * You can use `stopBeforeSending` queryParam to test the report without sending it to eagri.
 * @summary Sends fertilizer use report to eagri, for given date range.
 */
export const sendFertilizerUserReportToEagri = <TData = AxiosResponse<EagriReportResponse>>(
    eagriReportBody: EagriReportBody,
    params: SendFertilizerUserReportToEagriParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/fertilizer-usage`,
      eagriReportBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary This is for testing, dont use it on FE. Returns fertilizer use report data that would be sent to eagri.
 */
export const getFertilizerUserReportBody = <TData = AxiosResponse<FertiliserUseBody>>(
    eagriReportBody: EagriReportBody,
    params: GetFertilizerUserReportBodyParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/fertilizer-usage/dry`,
      eagriReportBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Creates customer, new schema and imports shapefile
 */
export const registerWithShapeFile = <TData = AxiosResponse<unknown>>(
    registerWithShapeFileBody: RegisterWithShapeFileBody,
    params: RegisterWithShapeFileParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/shapefile`,
      registerWithShapeFileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Validates if shapefile contains all files
 */
export const validateShapefile = <TData = AxiosResponse<unknown>>(
    validateShapefileBody: ValidateShapefileBody,
    params: ValidateShapefileParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/shapefile/validate`,
      validateShapefileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary 
            Submits and awaits an empty farm creation. This involves the following steps:
            - create a new customer
            - create an empty farm (i.e. farm without external data layers)
        "
 */
export const registerEmptyFarm = <TData = AxiosResponse<unknown>>(
    params: RegisterEmptyFarmParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/empty`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary 
            Asynchronously submits a farm creation task and imports farm data from eAGRI. This involves the following steps:
            - create a customer
            - create an empty farm
            - request farm DPB data from the eAGRI portal and parse them into blocks + parcels
            - persist parsed data into database
        "
 */
export const registerWithEagri = <TData = AxiosResponse<unknown>>(
    params: RegisterWithEagriParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/eagri`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelsSubtraction = <TData = AxiosResponse<SubtractionTo>>(
    parcelId: string,
    restrictionTo: RestrictionTo,
    params: GetParcelsSubtractionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/subtractions`,
      restrictionTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns all zones
 */
export const getZones = <TData = AxiosResponse<ZoneDetailTo[]>>(
    params: GetZonesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Creates new zone
 */
export const createZone = <TData = AxiosResponse<ZoneDetailTo>>(
    zoneCreateTo: ZoneCreateTo,
    params: CreateZoneParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones`,
      zoneCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postParcelVegetationStrip = <TData = AxiosResponse<ParcelVegetationStripResponse[]>>(
    parcelVegetationStripRequest: ParcelVegetationStripRequest[],
    params: PostParcelVegetationStripParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/vegetation-strips`,
      parcelVegetationStripRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const recountSubtractionsForAction = <TData = AxiosResponse<ParcelSubtractionResponse[]>>(
    recountSubtractionRequest: RecountSubtractionRequest,
    params: RecountSubtractionsForActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions`,
      recountSubtractionRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelSubtractionGeometry = <TData = AxiosResponse<ParcelGeometryResponse>>(
    parcelRestrictionTo: ParcelRestrictionTo,
    params: GetParcelSubtractionGeometryParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions/geometry`,
      parcelRestrictionTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelAreaAfterSubtraction = <TData = AxiosResponse<ParcelAreaTo[]>>(
    parcelRestrictionRequestBody: ParcelRestrictionRequestBody,
    params: GetParcelAreaAfterSubtractionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions/area`,
      parcelRestrictionRequestBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const migrate = <TData = AxiosResponse<null>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/migration/add-geometry`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Creates a custom parcel created by user in our application.
 * @summary Create parcel
 */
export const create = <TData = AxiosResponse<CustomParcelCreateResult>>(
    customParcelCreateRequest: CustomParcelCreateRequest,
    params: CreateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/manual/parcel`,
      customParcelCreateRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get available updates. Available updates have a certain TTL and will therefore be deleted after a certain period of time.
 */
export const getAvailableUpdates = <TData = AxiosResponse<FarmUpdateChangesResponse>>(
    params: GetAvailableUpdatesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/eagri/available-updates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Requests available farm update search. The search itself is done asynchronously; to retrieve search results, use the corresponding GET method. Please note there is a timeout period for which we try to download eAGRI data; if there are no data available after this period, this most likely means that eAGRI services are not available at the moment.
 */
export const requestAvailableUpdates = <TData = AxiosResponse<null>>(
    params: RequestAvailableUpdatesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/eagri/available-updates`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Attempts to store eAGRI authentication credentials. Data are associated with the current user.
 */
export const storeAuthData = <TData = AxiosResponse<EagriAuthValidationResultTo>>(
    eagriAuthDataValidationRequestTo: EagriAuthDataValidationRequestTo, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/eagri-auth`,
      eagriAuthDataValidationRequestTo,options
    );
  }

/**
 * Returns farm seed catalogue.
 * @summary List seeds
 */
export const getSeeds = <TData = AxiosResponse<CropSeedTo[]>>(
    params: GetSeedsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
            <p>Adds seed to farm catalogue.</p>
            <ul>
                <li>If seed with same variety name already exists, will just return the existing seed</li>
                <li>If seed exist but is hidden, will un-hide it</li>
            </ul>
        
 * @summary Add seed
 */
export const postSeed = <TData = AxiosResponse<CropSeedTo>>(
    cropSeedCreateTo: CropSeedCreateTo,
    params: PostSeedParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds`,
      cropSeedCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates plant protection product in PRIVATE catalogue.
 * @summary Create plant protection
 */
export const postPlantProtection = <TData = AxiosResponse<PlantProtectionDetailTo>>(
    plantProtectionCreateUpdateTo: PlantProtectionCreateUpdateTo,
    params: PostPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections`,
      plantProtectionCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Copies plant protection with applications to private catalogue. Copy doesn't copy registrations only their applications by registration id
 * @summary Copy plant protection
 */
export const copyPlantProtection = <TData = AxiosResponse<PlantProtectionDetailTo>>(
    plantProtectionId: string,
    params: CopyPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/copy`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Create plant protection application
 */
export const postPlantProtectionRegistrationApplication = <TData = AxiosResponse<null>>(
    plantProtectionId: string,
    plantProtectionApplicationCreateTo: PlantProtectionApplicationCreateTo,
    params: PostPlantProtectionRegistrationApplicationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications`,
      plantProtectionApplicationCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Only available for global farms. Possible csv headers, only name is required: name,externalId,isEco,bioFunction,activeSubstances,notes,isFavorite,usableUntil
 * @summary Import plant protections from CSV
 */
export const importFertilizersFromCSV = <TData = AxiosResponse<null>>(
    importFertilizersFromCSVBody: ImportFertilizersFromCSVBody,
    params: ImportFertilizersFromCSVParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/import`,
      importFertilizersFromCSVBody,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getOrganisms = <TData = AxiosResponse<OrganismTo[]>>(
    params: GetOrganismsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/organisms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createOrganisms = <TData = AxiosResponse<OrganismTo>>(
    createOrganismRequestTo: CreateOrganismRequestTo,
    params: CreateOrganismsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/organisms`,
      createOrganismRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActiveSubstances = <TData = AxiosResponse<ActiveSubstanceTo[]>>(
    params: GetActiveSubstancesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/active-substances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postActiveSubstance = <TData = AxiosResponse<ActiveSubstanceTo>>(
    activeSubstanceCreateTo: ActiveSubstanceCreateTo,
    params: PostActiveSubstanceParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/active-substances`,
      activeSubstanceCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns farm fertilizer catalogue.
 * @summary List fertilizers
 */
export const getFertilizers = <TData = AxiosResponse<FertilizerTo[]>>(
    params: GetFertilizersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Adds fertilizer to farm catalogue.
 * @summary Add fertilizer
 */
export const postFertilizer = <TData = AxiosResponse<FertilizerDetailTo>>(
    fertilizerCreateTo: FertilizerCreateTo,
    params: PostFertilizerParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers`,
      fertilizerCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Only available for global farms. Possible csv headers, only name is required: name, description, isOrganic, n, p2o5, k2o, cao, mgo, na2o, s, chlorides, combustibleContent, zn, cu, fe, b, mn, mo, se, phFrom, phTo, electricConductivity, catalogueId, commonUnitType, weightToVolumeCoefficient
 * @summary Import fertilizers from CSV
 */
export const importFertilizersFromCSV1 = <TData = AxiosResponse<null>>(
    importFertilizersFromCSV1Body: ImportFertilizersFromCSV1Body,
    params: ImportFertilizersFromCSV1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/import`,
      importFertilizersFromCSV1Body,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Returns available crop catalogue.
 * @summary List crops
 */
export const getCrops = <TData = AxiosResponse<CropTo[]>>(
    params: GetCropsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postCrop = <TData = AxiosResponse<CropTo>>(
    cropCreateTo: CropCreateTo,
    params: PostCropParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops`,
      cropCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get all crop products
 */
export const getCropProducts = <TData = AxiosResponse<CropProductTo[]>>(
    params: GetCropProductsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/products`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postCropProduct = <TData = AxiosResponse<CropProductTo>>(
    cropProductCreateTo: CropProductCreateTo,
    params: PostCropProductParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/products`,
      cropProductCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Only available for global farms. Possible csv headers, only name is required: name, color, text_color
 * @summary Import crops from CSV
 */
export const importCropsFromCSV = <TData = AxiosResponse<null>>(
    importCropsFromCSVBody: ImportCropsFromCSVBody,
    params: ImportCropsFromCSVParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/import`,
      importCropsFromCSVBody,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Get crop use types
 */
export const getCropUseTypes = <TData = AxiosResponse<CropUseTypeTo[]>>(
    params: GetCropUseTypesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postCropUseType = <TData = AxiosResponse<CropUseTypeTo>>(
    cropUseTypeCreateTo: CropUseTypeCreateTo,
    params: PostCropUseTypeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use`,
      cropUseTypeCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Expected file in .zip. Will return forbidden if file has more than one shapefile.As srid in .prj file might be wrong, specify srid of provided shp file explicitly
 * @summary Creates a new version of surface water protection zones geo layer
 */
export const importSurfaceWaterProtectionZones = <TData = AxiosResponse<null>>(
    importSurfaceWaterProtectionZonesBody: ImportSurfaceWaterProtectionZonesBody,
    params: ImportSurfaceWaterProtectionZonesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/surface`,
      importSurfaceWaterProtectionZonesBody,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Expected file in .zip. Will return forbidden if file has more than one shapefile. As srid in .prj file might be wrong, specify srid of provided shp file explicitly
 * @summary Creates a new version of ground water protection zones geo layer
 */
export const importGroundWaterProtectionZones = <TData = AxiosResponse<null>>(
    importGroundWaterProtectionZonesBody: ImportGroundWaterProtectionZonesBody,
    params: ImportGroundWaterProtectionZonesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/ground`,
      importGroundWaterProtectionZonesBody,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * 
            Deletes all seed_application_v2 records for the farm and rebuilds them
            from seed_application v1 with proper crop_product_id and crop_use_type_id UUIDs.

            This uses GetSeedApplicationIntervalUseCase to calculate intervals which already
            has all the UUID resolution logic. After reimport, it also regroups the seed
            applications (megaosevy).
        
 * @summary Reimport seed applications v2 for a farm
 */
export const reimportSeedApplications = <TData = AxiosResponse<SeedApplicationV2ReimportResult>>(
    params: ReimportSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/seed-applications/v2/regroup`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const syncCounties = <TData = AxiosResponse<null>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/sync-counties`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Updates nitrate vulnerable zones for on parcels on all CZ farms. Warning: it may take a 1 hour or more time to finish! It is preferable to run the update on farm by farm basis.
 * @summary Updates nitrate vulnerable flags
 */
export const updateNitrateVulnerable = <TData = AxiosResponse<AdminFarmManagementTo[]>>(
    params?: UpdateNitrateVulnerableParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/nitrate-vulnerable-zones`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of nitrate vulnerable status for all parcels on farm without updating the database.
 * @summary Returns nitrate vulnerable status
 */
export const getNitrateVulnerableOnFarm = <TData = AxiosResponse<AdminNitrateVulnerableZoneTo[]>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/nitrate-vulnerable-zones/${farmId}`,options
    );
  }

/**
 * Updates nitrate vulnerable status for all parcels on farm.
 * @summary Updates nitrate vulnerable flags
 */
export const postNitrateVulnerableOnFarm = <TData = AxiosResponse<AdminNitrateVulnerableZoneTo[]>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/nitrate-vulnerable-zones/${farmId}`,undefined,options
    );
  }

/**
 * @summary Migrate crop product and use type IDs to UUIDs
 */
export const migrateCropUseTypeToUuid = <TData = AxiosResponse<null>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/migrate-crop-product-and-use`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * 
            The motivation behind having this endpoint is that after LPIS update, a lot of parcels
            appear unsown because sowings applicable to such parcels are attached to retired parcels;
            in reality, there might be no harvest on the retired parcel.
        
 * @summary Moves parcel validity according to the sowing of its predecessors and moves actions accordingly.
 */
export const moveParcelValiditiesToNewestSowing = <TData = AxiosResponse<AdminParcelValidityMoveResult>>(
    params: MoveParcelValiditiesToNewestSowingParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/move-parcel-valid-from`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
            Action moving is done automatically as a part of update; this endpoint serves
            as a helper service for historical data which for some reason weren't moved.
        
 * @summary Moves actions after update.
 */
export const moveActionsAfterUpdate = <TData = AxiosResponse<AdminActionMoveResult>>(
    params: MoveActionsAfterUpdateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/move-actions`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new eAGRI farm using data from an eAGRI test user account.
 */
export const createTestEagriFarm = <TData = AxiosResponse<null>>(
    adminEagriTestFarmCreateRequest: AdminEagriTestFarmCreateRequest, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/create-test-farm`,
      adminEagriTestFarmCreateRequest,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Trigger manual landscape element synchronization
 */
export const triggerSync = <TData = AxiosResponse<SyncStats>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/landscape/sync`,undefined,options
    );
  }

/**
 * @deprecated
 */
export const refreshFarmCache = <TData = AxiosResponse<null>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/geoserver/farm/${farmId}/refresh-farm-cache`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Returns preview of LPIS block information for current versions of farm LPIS blocks from eAgri.
 * @summary Returns LPIS preview
 */
export const getLpisBlocks = <TData = AxiosResponse<unknown>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/lpis`,options
    );
  }

/**
 * Synchronizes current versions of LPIS blocks with eAgri. It does not update LPIS block if they were retired.
 * @summary Updates LPIS info
 */
export const updateEagriFarm = <TData = AxiosResponse<unknown>>(
    farmId: string,
    params?: UpdateEagriFarmParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/lpis`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const addSowingPlanToCurrentSeason = <TData = AxiosResponse<null>>(
    params?: AddSowingPlanToCurrentSeasonParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/add-current-crop-to-current-season`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Synchronizes eAgri catalogue
 */
export const postSync = <TData = AxiosResponse<null>>(
    catalogueType: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/catalogues/eagri/sync/${catalogueType}`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Splits an action into two separate actions using seed_application_v2. The original action keeps the remaining parcels, and a new action is created with the selected parcels. Material amounts are proportionally recalculated based on parcel areas.
 * @summary Split action (V2)
 */
export const splitAction = <TData = AxiosResponse<SplitActionResponse>>(
    splitActionRequest: SplitActionRequest,
    params: SplitActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/split`,
      splitActionRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new sowing action using seed_application_v2. Automatically creates seed application V2 records based on date and parcel.
 * @summary Create sowing action (V2)
 */
export const createSowingAction1 = <TData = AxiosResponse<ActionIdTo>>(
    actionSowingCreateV2To: ActionSowingCreateV2To,
    params: CreateSowingAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/sowing`,
      actionSowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new mowing action using seed_application_v2. Works with existing seed application V2 records based on date and parcel.
 * @summary Create mowing action (V2)
 */
export const createMowingAction1 = <TData = AxiosResponse<ActionIdTo>>(
    actionMowingCreateV2To: ActionMowingCreateV2To,
    params: CreateMowingAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/mowing`,
      actionMowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new harvest action using seed_application_v2. Automatically closes seed application V2 records based on date and parcel.
 * @summary Create harvest action (V2)
 */
export const createHarvestAction1 = <TData = AxiosResponse<ActionIdTo>>(
    actionHarvestCreateV2To: ActionHarvestCreateV2To,
    params: CreateHarvestAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/harvest`,
      actionHarvestCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new EPH (fertilization/plant protection) action using seed_application_v2. Accepts targetCropId for form compatibility, but target crop is determined by date and parcel.
 * @summary Create EPH action (V2)
 */
export const createEPHAction1 = <TData = AxiosResponse<ActionIdTo>>(
    actionEPHCreateV2To: ActionEPHCreateV2To,
    params: CreateEPHAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/eph`,
      actionEPHCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Validates legislative restrictions for EPH action using seed applications. Checks fertilization limits, restrictions and other legislative requirements.
 * @summary Validate EPH action restrictions (V2)
 */
export const validateEPHAction = <TData = AxiosResponse<ValidationResponseTo>>(
    actionEPHCreateV2To: ActionEPHCreateV2To,
    params: ValidateEPHActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/eph/restrictions`,
      actionEPHCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationFertilization = <TData = AxiosResponse<ParcelAccountableNitrogenTo[]>>(
    targetSeedApplicationFertilizationRequestTo: TargetSeedApplicationFertilizationRequestTo,
    params: GetSeedApplicationFertilizationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/target-seed-application/accountable-nitrogen`,
      targetSeedApplicationFertilizationRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const splitAction1 = <TData = AxiosResponse<SplitActionResponse>>(
    splitActionRequest: SplitActionRequest,
    params: SplitAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/split`,
      splitActionRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const validateEPHAction1 = <TData = AxiosResponse<ValidationResponseTo>>(
    actionEPHCreateTo: ActionEPHCreateTo,
    params: ValidateEPHAction1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/eph/restrictions`,
      actionEPHCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel detail.
 * @summary Parcel detail
 */
export const getParcel = <TData = AxiosResponse<ParcelDetailTo>>(
    parcelId: string,
    params: GetParcelParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates parcel name or/and user yield grade.
 * @summary Update parcel
 */
export const patchParcel = <TData = AxiosResponse<null>>(
    parcelId: string,
    parcelUpdateTo: ParcelUpdateTo,
    params: PatchParcelParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}`,
      parcelUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Deletes existing zone
 */
export const deleteZone = <TData = AxiosResponse<null>>(
    zoneId: string,
    params: DeleteZoneParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones/${zoneId}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * @summary Updates existing zone
 */
export const updateZone = <TData = AxiosResponse<ZoneDetailTo>>(
    zoneId: string,
    zoneCreateTo: ZoneCreateTo,
    params: UpdateZoneParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones/${zoneId}`,
      zoneCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get seed by id
 */
export const getSeed = <TData = AxiosResponse<CropSeedTo>>(
    seedId: string,
    params: GetSeedParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/${seedId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates seed variety name or sets/unsets seed hidden status.
 * @summary Update seed
 */
export const patchSeed = <TData = AxiosResponse<CropSeedTo>>(
    seedId: string,
    cropSeedPatchTo: CropSeedPatchTo,
    params: PatchSeedParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/${seedId}`,
      cropSeedPatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const patchCrop = <TData = AxiosResponse<CropTo>>(
    id: string,
    cropUpdateTo: CropUpdateTo,
    params: PatchCropParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/${id}`,
      cropUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get public parcels by farm, zone and status, lang is used for language of current crop
 * @summary Get public parcels
 */
export const getParcelByArealName = <TData = AxiosResponse<PublicParcelTo[]>>(
    params: GetParcelByArealNameParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/public-api/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getLandingPage = <TData = AxiosResponse<string>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web`,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * Returns an HTML page with form and visualization.
 * @summary Seed Applications History
 */
export const getDebugPage = <TData = AxiosResponse<string>>(
    params?: GetDebugPageParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/seed-applications-v2`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns just the visualization HTML content for AJAX loading.
 * @summary Parcel timeline content (AJAX)
 */
export const getVisualizationContent = <TData = AxiosResponse<string>>(
    params: GetVisualizationContentParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/seed-applications-v2/content`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCropsInternal = <TData = AxiosResponse<GetCropsInternal200Item[]>>(
    params: GetCropsInternalParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/seeds`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelSowingPlan1 = <TData = AxiosResponse<InternalSeasonTo[]>>(
    parcelId: string,
    params: GetParcelSowingPlan1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/seasons/parcels/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcels valid in specified date range. By default, parcels valid on today's date are returned.
 * @summary Returns list of parcels
 */
export const getParcels = <TData = AxiosResponse<InternalParcelTo[]>>(
    params: GetParcelsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the details of a parcel by its id. The parcel's crop corresponds to the at-date parameter, which defaults to today's date.
 * @summary Returns parcel detail
 */
export const getParcelDetail = <TData = AxiosResponse<InternalParcelTo>>(
    parcelId: string,
    params: GetParcelDetailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplications = <TData = AxiosResponse<InternalSeedApplicationTo[]>>(
    parcelId: string,
    params: GetSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/${parcelId}/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsByParcelIds = <TData = AxiosResponse<InternalSeedApplicationByParcelTo[]>>(
    params: GetSeedApplicationsByParcelIdsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/current-seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizersInternal = <TData = AxiosResponse<InternalFertilizerTo[]>>(
    params: GetFertilizersInternalParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/fertilizers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerMineralIntake = <TData = AxiosResponse<InternalFertilizerMineralIntakeResponse>>(
    fertilizerId: string,
    params: GetFertilizerMineralIntakeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/fertilizers/${fertilizerId}/dose`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns farm detail.
 */
export const getFarmDetail1 = <TData = AxiosResponse<InternalFarmResponse>>(
    params: GetFarmDetail1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/farms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Search farms by farmId or name.
 */
export const searchFarms = <TData = AxiosResponse<InternalFarmResponse[]>>(
    params?: SearchFarmsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/farms/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCropsInternal1 = <TData = AxiosResponse<InternalCropTo[]>>(
    params: GetCropsInternal1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCropInternal = <TData = AxiosResponse<InternalCropTo>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/crops/${id}`,options
    );
  }

/**
 * @summary Returns farm catalogue types
 */
export const getCropCatalogueType = <TData = AxiosResponse<CatalogueType>>(
    params: GetCropCatalogueTypeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/catalogues/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of seed applications (individual or grouped) with parcel details that can be connected to the specified seed application or group. Either seed-application-id or group-id must be provided.

Candidates must meet the following criteria:
- Have the same crop (seedId) and catch crop flag
- Be on parcels related to boundary parcels of the target group via event link (split/merge) and geometric intersection
- Be first or last on their parcel
- Not already in the same group
- Must have a crop (seedId cannot be NULL)

Response includes parcel details: name, number, area, and validity period.
 * @summary Get connectable seed applications
 */
export const getConnectableSeedApplications = <TData = AxiosResponse<GetConnectableSeedApplications200Item[]>>(
    params: GetConnectableSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/connectable`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns seed application V2 that was present at parcels at given date. Returns one seed application per parcel. Returns nothing for parcels without a crop at the given time. Uses date-based seed applications V2.
 * @summary Get seed applications at date (V2)
 */
export const getSeedApplicationsV2AtDate = <TData = AxiosResponse<SeedApplicationV2To[]>>(
    params: GetSeedApplicationsV2AtDateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/at-date`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary V2: Fetches report errors from eagri given guid
 */
export const checkFertilizerUseReport = <TData = AxiosResponse<TResponse>>(
    params: CheckFertilizerUseReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/fertilizer-usage/errors`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSowingPlanStatistics = <TData = AxiosResponse<SowingPlanSeasonStatisticsTo>>(
    seasonId: string,
    params: GetSowingPlanStatisticsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/seasons/${seasonId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeasonsExcel = <TData = AxiosResponse<Blob>>(
    params: GetSeasonsExcelParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/seasons/excel`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsGeometriesAtDate = <TData = AxiosResponse<SeedApplicationIntervalsByGeometryTo[]>>(
    params: GetSeedApplicationsGeometriesAtDateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/seed-applications/geometry`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsAtDate = <TData = AxiosResponse<SeedApplicationTo[]>>(
    params: GetSeedApplicationsAtDateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/seed-applications/at-date`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeededAreasV2Report = <TData = AxiosResponse<string>>(
    params: GetSeededAreasV2ReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/seeded-areas`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsV2Report = <TData = AxiosResponse<string>>(
    params: GetSeedApplicationsV2ReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/seed-applications`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getRevenuesV2Report = <TData = AxiosResponse<string>>(
    params: GetRevenuesV2ReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/revenues`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the nitrate balance report using V2 seed applications as a downloadable Excel file.
 * @summary Get the Nitrate Balance Report V2
 */
export const getNitrateBalanceV2Report = <TData = AxiosResponse<Blob>>(
    params: GetNitrateBalanceV2ReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/nitrate-balance`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeededAreas = <TData = AxiosResponse<string>>(
    params: GetSeededAreasParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/seeded-areas`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsReport = <TData = AxiosResponse<string>>(
    params: GetSeedApplicationsReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/seed-applications`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getRevenuesReport = <TData = AxiosResponse<string>>(
    params: GetRevenuesReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/revenues`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
            Returns crop rotation restriction violations base on parcel LPIS codes. 
            The validation includes validation of seed applications on historic parcels and validation of sowing plans
            on current parcels where seed applications are not yet available.
        
 * @summary Validates crop rotation restrictions
 */
export const getRestrictionsSowingReport = <TData = AxiosResponse<ValidationResponseTo>>(
    params: GetRestrictionsSowingReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/restrictions/sowing`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPorUsageReport = <TData = AxiosResponse<string>>(
    params: GetPorUsageReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-usage`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPorConsumptionByPPReport = <TData = AxiosResponse<string>>(
    params: GetPorConsumptionByPPReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-consumption`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPorConsumptionByCropReport = <TData = AxiosResponse<string>>(
    params: GetPorConsumptionByCropReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-consumption-crop`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcels1 = <TData = AxiosResponse<Blob>>(
    params: GetParcels1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/parcels`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the nitrate balance report as a downloadable Excel file.
 * @summary Get the Nitrate Balance Report
 */
export const getParcels2 = <TData = AxiosResponse<Blob>>(
    params: GetParcels2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/nitrate-balance`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getReports = <TData = AxiosResponse<ReportHistoryTo[]>>(
    params: GetReportsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerUsageReport = <TData = AxiosResponse<string>>(
    params: GetFertilizerUsageReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-usage`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerOrganicReport = <TData = AxiosResponse<string>>(
    params: GetFertilizerOrganicReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-organic`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerConsumptionReport = <TData = AxiosResponse<string>>(
    params: GetFertilizerConsumptionReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-consumption`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerConsumptionByCropReport = <TData = AxiosResponse<string>>(
    params: GetFertilizerConsumptionByCropReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-consumption-crop`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFarmNitrogenReport = <TData = AxiosResponse<string>>(
    params: GetFarmNitrogenReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/farm-nitrogen`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCvsReport = <TData = AxiosResponse<HttpServletResponse>>(
    params: GetCvsReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/sowing-plan`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Fetches pdf errors report from eagri for given guid.
 */
export const getEagriPorUseErrors = <TData = AxiosResponse<string>>(
    params: GetEagriPorUseErrorsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/por-usage/errors`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Fetches report errors from eagri given guid
 */
export const checkFertilizerUserReport = <TData = AxiosResponse<TResponse>>(
    params: CheckFertilizerUserReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/fertilizer-usage/errors`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionsReport = <TData = AxiosResponse<string>>(
    params: GetActionsReportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/actions`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels by filter criteria. By default, only OPEN parcels are returned. 
            <h3>Filters</h3>
            <p>
                All filters are optional. If value is not provided is null or empty, filter will not be applied. 
                Filters can be combined at will. 
                Use as query parameters.
            </p>
        
 * @summary Returns all parcels
 */
export const getParcels3 = <TData = AxiosResponse<ParcelTo[]>>(
    params: GetParcels3Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary List parcel subtractions
 */
export const getParcelSubtractionHistory = <TData = AxiosResponse<SubtractionResponse[]>>(
    parcelId: string,
    params: GetParcelSubtractionHistoryParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/subtractions-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Delete restriction from parcels history
 */
export const deleteParcelSubtraction = <TData = AxiosResponse<null>>(
    parcelId: string,
    params: DeleteParcelSubtractionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/subtractions-history`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Returns seed applications list with fertilization and revenues for each seed application.
 * @summary Parcel seeding history
 */
export const getSeedApplications1 = <TData = AxiosResponse<ParcelSeedApplicationTo[]>>(
    parcelId: string,
    params: GetSeedApplications1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the latest seed application if it is NO_CROP, enriched with the nearest planned sowing plan entry. If the latest is not NO_CROP or there is no seed application, returns 404 http response.
 * @summary Last NO_CROP seed application with planned crop
 */
export const getLastNoCropSeedApplicationWithPlannedCrop = <TData = AxiosResponse<ParcelSeedApplicationWithPlanTo>>(
    parcelId: string,
    params: GetLastNoCropSeedApplicationWithPlannedCropParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/seed-applications/last-no-crop-with-planned`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel predecessors.
 * @summary Parcel history
 */
export const getParcelPredecessors = <TData = AxiosResponse<ParcelPredecessorTo[]>>(
    parcelId: string,
    params: GetParcelPredecessorsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/predecessors`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels that were created when this parcel was retired (successors).
 * @summary Parcel following parcels
 */
export const getParcelFollowing = <TData = AxiosResponse<ParcelPredecessorTo[]>>(
    parcelId: string,
    params: GetParcelFollowingParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/following`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcels that were active on the given date and geometrically intersect with the source parcel. Used for activity transfer functionality. Returns full parcel data with seed applications as of the specified date.
 * @summary Parcel exchange candidates
 */
export const getExchangeCandidates = <TData = AxiosResponse<ParcelToV2[]>>(
    parcelId: string,
    params: GetExchangeCandidatesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/exchange-candidates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcel restriction and available subsidies from eAgri.
 * @summary Parcel eAgri info
 */
export const getParcelRestrictions = <TData = AxiosResponse<ParcelEagriInfoTo>>(
    parcelId: string,
    params: GetParcelRestrictionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/eagri`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Closest distance from landwaterboundary
 */
export const getWaterParcelDistance = <TData = AxiosResponse<ParcelWaterDistanceTo[]>>(
    params: GetWaterParcelDistanceParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/water-distance`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels with V2 seed applications. Uses seed_application_v2 table with UUID-based lifecycles. Seed applications can be individual or grouped (when parcel was split and lifecycle continued). Supports pagination with X-Total-Count header.
 * @summary Returns all parcels (V2)
 */
export const getParcelsV2 = <TData = AxiosResponse<ParcelToV2[]>>(
    params: GetParcelsV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel detail with SeedApplicationV2To instead of SeedApplicationTo.
 * @summary Parcel detail (V2)
 */
export const getParcelDetailV2 = <TData = AxiosResponse<ParcelDetailV2To>>(
    parcelId: string,
    params: GetParcelDetailV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns seed applications list with fertilization and revenues. Uses V2 implementation with date-based seed_application_v2 lifecycles instead of action-based boundaries. Results can be either individual parcels or groups (when parcel was split and lifecycle continued). Each result includes a 'resultType' discriminator: 'individual' or 'group'. Individual results contain seedApplication + fertilization + revenue for one parcel. Group results contain aggregated data (total fertilization, total revenue) plus a list of individual parcel data.
 * @summary Parcel seeding history (V2)
 */
export const getSeedApplicationsV2 = <TData = AxiosResponse<GetSeedApplicationsV2200Item[]>>(
    parcelId: string,
    params: GetSeedApplicationsV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/${parcelId}/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns action overviews for a specific parcel filtered by V2 seed application IDs (UUIDs). Actions are filtered at database level to only include actions that contain this parcel. All parcels for matching actions are returned (not filtered to just the requested parcel). Uses optimized single-query approach with MULTISET for nested data.
 * @summary Get actions for parcel (V2)
 */
export const getActionsV2 = <TData = AxiosResponse<ActionOverviewV2To[]>>(
    parcelId: string,
    params: GetActionsV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/${parcelId}/actions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns statistics about parcels grouped by current crop using seed_application_v2. Shows count and total area for each crop based on active lifecycles (date_end IS NULL). Includes overall parcel statistics.
 * @summary Returns farm statistics with crop distribution (V2)
 */
export const getParcelStatisticsV2 = <TData = AxiosResponse<FarmStatisticsTo>>(
    params: GetParcelStatisticsV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/statistics`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns minimal parcel data for map display with V2 seed application colors and crop info.
 * @summary Parcel map data (V2)
 */
export const getParcelMapDataV2 = <TData = AxiosResponse<ParcelMapToV2[]>>(
    params: GetParcelMapDataV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/map`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels suggested by filter criteria. By default, only OPEN parcels are returned. 
            <h3>Filters</h3>
            <p>
                All filters are optional. If value is not provided is null or empty, filter will not be applied. 
                Filters can be combined at will. 
                Use as query parameters.
            </p>
        
 * @summary Returns simplified parcel list
 */
export const getParcelSuggestions = <TData = AxiosResponse<ParcelSuggestionTo[]>>(
    params: GetParcelSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * The statistics include number of parcels and their total are, sown crops statistics and fertilization statistics.
 * @summary Farm statistics
 */
export const getParcelStatistics = <TData = AxiosResponse<FarmStatisticsTo>>(
    params: GetParcelStatisticsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/statistics`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns minimal parcel data optimized for map display (no filtering, no paging).
 * @summary Parcels for map display
 */
export const getParcelsForMap = <TData = AxiosResponse<ParcelMapTo[]>>(
    params: GetParcelsForMapParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/map`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns minimal parcel data optimized for map display with planned crops for the specified season (no filtering, no paging).
 * @summary Parcels for map display by season
 */
export const getParcelsForMapBySeason = <TData = AxiosResponse<ParcelMapTo[]>>(
    seasonId: string,
    params: GetParcelsForMapBySeasonParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/map/seasons/${seasonId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns available land use.
 * @summary Get land use
 */
export const getLandUse = <TData = AxiosResponse<LandUseResponse[]>>(
    params?: GetLandUseParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/land-use`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelCurrentSeedApplicationColors = <TData = AxiosResponse<SeedApplicationTo[]>>(
    params: GetParcelCurrentSeedApplicationColorsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/current-seed-application`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns all centers
 */
export const getCenters = <TData = AxiosResponse<CenterTo[]>>(
    params: GetCentersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/centers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionsAndSeedAppsAtDetail = <TData = AxiosResponse<ActionGeomOverviewTo[]>>(
    params: GetActionsAndSeedAppsAtDetailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/actions/geometry-overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of farms  current user is authorized to.
 * @summary Returns current user farms
 */
export const getUserFarms = <TData = AxiosResponse<FarmTo[]>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms`,options
    );
  }

/**
 * Returns detail of a farm user is authorized.
 * @summary Returns farm detail
 */
export const getFarmDetail2 = <TData = AxiosResponse<FarmTo>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/${farmId}`,options
    );
  }

export const getFarmUpdates = <TData = AxiosResponse<FarmUpdateFlatResponse[]>>(
    params: GetFarmUpdatesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/updated`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns farm settings
 */
export const getFarmSettings = <TData = AxiosResponse<FarmSettingsTo>>(
    farmId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/settings/${farmId}`,options
    );
  }

/**
 * 
             Returns preview of all data available at LPIS.
             
             NOTE:
             It is also possible to download eagri data of test accounts (preferably from localhost).
             To do so, set eAgri.url property in agroevidence to https://eagritest.cz/ssl/nosso-app/EPO/WS/v2Online/vOKOsrv.ashx?SERVICEID=
                 and then call /auth/eagri-auth endpoint with credentials of the test account.
             Once credentials are stored in agr.lpis_auth_data, register a new farm (or manually assign LPIS auth to an existing farm if you know what you're doing).
             
 * @summary Returns detailed LPIS preview.
 */
export const getFullLpisDetail = <TData = AxiosResponse<EagriDpbPair[]>>(
    params: GetFullLpisDetailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/lpis-full`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a farm name from eAGRI if user has already provided auth data (i.e. POST /eagri-auth went OK).
 */
export const eagriFarmName = <TData = AxiosResponse<EagriAuthValidationResultTo>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/eagri-auth/name`,options
    );
  }

export const searchCountries = <TData = AxiosResponse<CountryTo[]>>(
    params?: SearchCountriesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/countries/supported`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary List farm catalogues
 */
export const getCatalogues = <TData = AxiosResponse<CatalogueTo[]>>(
    params: GetCataloguesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns seed suggestion sorted by favorites on top
 * @summary Get seed suggestions
 */
export const getSeedSuggestions = <TData = AxiosResponse<CropSeedSuggestionTo[]>>(
    params: GetSeedSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns farm primary catalogue type
 */
export const getCropsCatalogSource = <TData = AxiosResponse<PrimaryCatalogueTo>>(
    params: GetCropsCatalogSourceParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/primary`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionDetail = <TData = AxiosResponse<PlantProtectionDetailTo>>(
    plantProtectionId: string,
    params: GetPlantProtectionDetailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionDetailApplications = <TData = AxiosResponse<PlantProtectionDetailRegistrationApplicationTo[]>>(
    plantProtectionId: string,
    params: GetPlantProtectionDetailApplicationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail/applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionApplications = <TData = AxiosResponse<PlantProtectionApplicationTo[]>>(
    plantProtectionId: string,
    params: GetPlantProtectionApplicationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary List plant protection suggestions
 */
export const getPlantProtectionSuggestions = <TData = AxiosResponse<PlantProtectionSuggestionTo[]>>(
    params: GetPlantProtectionSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns farm plant protection products catalogue
 * @summary List plant protection products
 */
export const getPlantProtections = <TData = AxiosResponse<PlantProtectionOverviewTo[]>>(
    params: GetPlantProtectionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getBioFunction = <TData = AxiosResponse<string[]>>(
    params: GetBioFunctionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/bio-function`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerMineralIntake1 = <TData = AxiosResponse<FertilizerMineralIntakeResponse>>(
    fertilizerId: string,
    params: GetFertilizerMineralIntake1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}/dose`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns fertilizers suggestions sorted by favorites on top
 * @summary Get fertilizer suggestions
 */
export const getFertilizerSuggestions = <TData = AxiosResponse<FertilizerSuggestionTo[]>>(
    params: GetFertilizerSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getEagriFertilizerNitrogenCategoryType = <TData = AxiosResponse<EnumEntriesEagriFertilizerNitrogenCategory>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/eagri-nitrogen-category`,options
    );
  }

/**
 * @summary Režim registrace hnojiva
 */
export const getFertilizerRegistratinType = <TData = AxiosResponse<EagriFertilizerRegistrationTypeTo[]>>(
    params?: GetFertilizerRegistratinTypeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/eagri/fertilizer-registration-type`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Číselník kategorie hnojiva z pohledu obsahu dusíku
 */
export const getFertilizerNitrogenCategory = <TData = AxiosResponse<EagriFertilizerNitrogenCategoryTo[]>>(
    params?: GetFertilizerNitrogenCategoryParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/eagri/fertilizer-nitrogen-categories`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Číselník druhů hnojiva
 */
export const getFertilizerTypes = <TData = AxiosResponse<EagriFertilizerKindTo[]>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/eagri/fertilizer-kind`,options
    );
  }

export const getCrop = <TData = AxiosResponse<CropDetailTo>>(
    cropId: string,
    params: GetCropParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/${cropId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Not available for EAGRI or PPA_SK farms. Possible csv headers, only name is required: name
 * @summary Export crops catalogue as CSV
 */
export const exportCropsToCSV = <TData = AxiosResponse<Blob>>(
    params: ExportCropsToCSVParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/export`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns information about the last successful sync and the most recent sync attempt. Use this to check when data was last updated and if there were any recent failures.
 * @summary Get landscape synchronization status
 */
export const getSyncStatus = <TData = AxiosResponse<LandscapeSyncStatusTo>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/landscape/sync/status`,options
    );
  }

export const getAllFarms = <TData = AxiosResponse<AdminFarmTo[]>>(
    params?: GetAllFarmsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * 
             Returns preview of all data available at LPIS.
             
             NOTE:
             It is also possible to download eagri data of test accounts (preferably from localhost).
             To do so, set eAgri.url property in agroevidence to https://eagritest.cz/ssl/nosso-app/EPO/WS/v2Online/vOKOsrv.ashx?SERVICEID=
                 and then call /auth/eagri-auth endpoint with credentials of the test account.
             Once credentials are stored in agr.lpis_auth_data, register a new farm (or manually assign LPIS auth to an existing farm if you know what you're doing).
             
 * @summary Returns detailed LPIS preview.
 */
export const getFullLpisDetail1 = <TData = AxiosResponse<EagriDpbPair[]>>(
    farmId: string,
    params?: GetFullLpisDetail1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/lpis-full`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns eAgri services sync status
 */
export const getSyncStatus1 = <TData = AxiosResponse<EagriServiceSyncStatusTo[]>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/catalogues/eagri/sync`,options
    );
  }

/**
 * Returns all evidence actions for given farm.
 * @summary Returns all actions
 */
export const getActions = <TData = AxiosResponse<ActionOverviewTo[]>>(
    params: GetActionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const deleteActions = <TData = AxiosResponse<null>>(
    params: DeleteActionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getAction = <TData = AxiosResponse<GetAction200>>(
    actionId: string,
    params: GetActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/${actionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const deleteAction = <TData = AxiosResponse<null>>(
    actionId: string,
    params: DeleteActionParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/${actionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Returns action detail using seed_application_v2 (date-based). For sowing actions, retrieves cropUseType and seedApplicationType from V2 seed applications.
 * @summary Get action detail (V2)
 */
export const getActionV2 = <TData = AxiosResponse<GetActionV2200>>(
    actionId: string,
    params: GetActionV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/${actionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns V2 seed applications for given parcels at a specific date with target crop. Used in EPH (fertilization) forms to determine which seed application to target.
 * @summary Get target seed application V2 for EPH action
 */
export const getTargetSeedApplication = <TData = AxiosResponse<TargetSeedApplicationV2ResponseTo>>(
    params: GetTargetSeedApplicationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/target-seed-application`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns action overviews filtered by V2 seed application IDs (UUIDs). Uses optimized single-query approach with MULTISET for nested data.
 * @summary Get action overviews (V2)
 */
export const getActionsOverviewV2 = <TData = AxiosResponse<ActionOverviewV2To[]>>(
    params: GetActionsOverviewV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsedSeeds = <TData = AxiosResponse<CropSeedSuggestionTo[]>>(
    params: GetUsedSeedsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/used-materials/seeds`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsedPlantProtections = <TData = AxiosResponse<PlantProtectionSuggestionTo[]>>(
    params: GetUsedPlantProtectionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/used-materials/plant-protections`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsedFertilizers = <TData = AxiosResponse<FertilizerSuggestionTo[]>>(
    params: GetUsedFertilizersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/used-materials/fertilizers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const targetSeedApplicationApplications = <TData = AxiosResponse<TargetSeedApplicationActionsResponseTo>>(
    params: TargetSeedApplicationApplicationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/target-seed-application`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of CropGrowthStage enum values.
 * @summary List available crop stage variants
 */
export const getCropGrowthStages = <TData = AxiosResponse<CropGrowthStageTo[]>>(
    params: GetCropGrowthStagesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/crop-growth-stages`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionTypes = <TData = AxiosResponse<ActionTypeTo[]>>(
    params?: GetActionTypesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/action-types`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Sets the seed application's group_id to NULL, removing it from its current group. If only 1 member remains in the group after removal, that member's group_id is also automatically set to NULL (groups must have 2+ members).
 * @summary Remove seed application from its group
 */
export const removeFromGroup = <TData = AxiosResponse<null>>(
    id: string,
    params: RemoveFromGroupParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/${id}/group`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const resetSeason = <TData = AxiosResponse<null>>(
    seasonId: string,
    params: ResetSeasonParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/seasons/${seasonId}/reset`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const evictParcelChainCacheEvent = <TData = AxiosResponse<null>>(
    params: EvictParcelChainCacheEventParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/cache/parcel-chain`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export type UpdateCentersResult = AxiosResponse<InternalCenterTo[]>
export type UpdateSeedApplicationV2Result = AxiosResponse<SeedApplicationV2To>
export type DeleteSeedApplicationV2Result = AxiosResponse<null>
export type UpdateSeedApplicationV2GroupResult = AxiosResponse<SeedApplicationV2GroupToV2>
export type DisbandGroupResult = AxiosResponse<null>
export type GetDetailedParcelWithSowingPlanResult = AxiosResponse<ParcelWithSowingPlansTo[]>
export type PutCropsToParcelAndSeasonResult = AxiosResponse<null>
export type GetParcelSowingPlanResult = AxiosResponse<SowingPlanSeasonCropTo[]>
export type PutCropToParcelAndSeasonResult = AxiosResponse<null>
export type UpdateFarmFromShapefileResult = AxiosResponse<unknown>
export type GetEagriAuthResult = AxiosResponse<EagriAuthDataValidationResponseTo>
export type PutEagriAuthResult = AxiosResponse<EagriAuthDataValidationResponseTo>
export type UpdateFarmResult = AxiosResponse<null>
export type PutPlantProtectionResult = AxiosResponse<PlantProtectionDetailTo>
export type PatchPlantProtectionResult = AxiosResponse<null>
export type PutPlantProtectionRegistrationApplicationResult = AxiosResponse<null>
export type DeletePlantProtectionRegistrationApplicationResult = AxiosResponse<null>
export type GetFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type PutFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type HideFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type UpdateCropProductsResult = AxiosResponse<null>
export type PutCropProductResult = AxiosResponse<CropProductTo>
export type PutCropUseTypeResult = AxiosResponse<CropUseTypeTo>
export type UpdateSkeagisFarmResult = AxiosResponse<SkeagisFarmUpdateResult>
export type OverwriteParcelGeometriesResult = AxiosResponse<ParcelGeometryOverwriteResult>
export type GetFarmDetailResult = AxiosResponse<AdminFarmTo>
export type PutFarmResult = AxiosResponse<AdminFarmTo>
export type UpdateFarmCurrentParcelsResult = AxiosResponse<null>
export type UpdateAllFarmsCurrentParcelsResult = AxiosResponse<null>
export type ResaveActionStoreTransactionsResult = AxiosResponse<null>
export type UpdateSkeagisStateResult = AxiosResponse<FarmIntegrationResponse>
export type CreateNewSkeagisIntegrationResult = AxiosResponse<FarmIntegrationResponse>
export type UpdateSowingActionResult = AxiosResponse<ActionIdTo>
export type UpdateMowingActionResult = AxiosResponse<ActionIdTo>
export type UpdateHarvestActionResult = AxiosResponse<ActionIdTo>
export type UpdateEPHActionResult = AxiosResponse<ActionIdTo>
export type UpdateSowingAction1Result = AxiosResponse<InternalActionIdResponse>
export type CreateSowingActionResult = AxiosResponse<InternalActionIdResponse>
export type UpdateOtherActionResult = AxiosResponse<InternalActionIdResponse>
export type CreateOtherActionResult = AxiosResponse<InternalActionIdResponse>
export type UpdateMowingAction1Result = AxiosResponse<InternalActionIdResponse>
export type CreateMowingActionResult = AxiosResponse<InternalActionIdResponse>
export type UpdateHarvestAction1Result = AxiosResponse<InternalActionIdResponse>
export type CreateHarvestActionResult = AxiosResponse<InternalActionIdResponse>
export type UpdateEPHAction1Result = AxiosResponse<InternalActionIdResponse>
export type CreateEPHActionResult = AxiosResponse<InternalActionIdResponse>
export type GetPlantProtectionsInternalResult = AxiosResponse<GetPlantProtectionsInternal200Item[]>
export type GetParcelIntersectionsResult = AxiosResponse<InternalParcelTo[]>
export type GetParcelIntersections1Result = AxiosResponse<InternalIntersectionParcelTo[]>
export type GetActionInfoResult = AxiosResponse<InternalActionInfo[]>
export type CreateDraftActionResult = AxiosResponse<InternalActionIdResponse>
export type GetSeedApplicationV2sResult = AxiosResponse<GetSeedApplicationV2s200Item[]>
export type CreateSeedApplicationV2Result = AxiosResponse<SeedApplicationV2To>
export type CreateSeedApplicationV2GroupResult = AxiosResponse<SeedApplicationV2GroupToV2>
export type GetPorUseReportBodyV2Result = AxiosResponse<PorUseBody>
export type SendFertilizerUseReportToEagriV2Result = AxiosResponse<EagriReportResponse>
export type GetFertilizerUseReportBodyV2Result = AxiosResponse<FertiliserUseBody>
export type GetSeasonsResult = AxiosResponse<SowingPlanSeasonTo[]>
export type CreateMissingSeasonsResult = AxiosResponse<SowingPlanSeasonTo[]>
export type SendPorUserReportToEagriResult = AxiosResponse<PlantProtectionPairingResultTo>
export type GetEagriPorUseReportBodyResult = AxiosResponse<PorUseBody>
export type SendFertilizerUserReportToEagriResult = AxiosResponse<EagriReportResponse>
export type GetFertilizerUserReportBodyResult = AxiosResponse<FertiliserUseBody>
export type RegisterWithShapeFileResult = AxiosResponse<unknown>
export type ValidateShapefileResult = AxiosResponse<unknown>
export type RegisterEmptyFarmResult = AxiosResponse<unknown>
export type RegisterWithEagriResult = AxiosResponse<unknown>
export type GetParcelsSubtractionResult = AxiosResponse<SubtractionTo>
export type GetZonesResult = AxiosResponse<ZoneDetailTo[]>
export type CreateZoneResult = AxiosResponse<ZoneDetailTo>
export type PostParcelVegetationStripResult = AxiosResponse<ParcelVegetationStripResponse[]>
export type RecountSubtractionsForActionResult = AxiosResponse<ParcelSubtractionResponse[]>
export type GetParcelSubtractionGeometryResult = AxiosResponse<ParcelGeometryResponse>
export type GetParcelAreaAfterSubtractionResult = AxiosResponse<ParcelAreaTo[]>
export type MigrateResult = AxiosResponse<null>
export type CreateResult = AxiosResponse<CustomParcelCreateResult>
export type GetAvailableUpdatesResult = AxiosResponse<FarmUpdateChangesResponse>
export type RequestAvailableUpdatesResult = AxiosResponse<null>
export type StoreAuthDataResult = AxiosResponse<EagriAuthValidationResultTo>
export type GetSeedsResult = AxiosResponse<CropSeedTo[]>
export type PostSeedResult = AxiosResponse<CropSeedTo>
export type PostPlantProtectionResult = AxiosResponse<PlantProtectionDetailTo>
export type CopyPlantProtectionResult = AxiosResponse<PlantProtectionDetailTo>
export type PostPlantProtectionRegistrationApplicationResult = AxiosResponse<null>
export type ImportFertilizersFromCSVResult = AxiosResponse<null>
export type GetOrganismsResult = AxiosResponse<OrganismTo[]>
export type CreateOrganismsResult = AxiosResponse<OrganismTo>
export type GetActiveSubstancesResult = AxiosResponse<ActiveSubstanceTo[]>
export type PostActiveSubstanceResult = AxiosResponse<ActiveSubstanceTo>
export type GetFertilizersResult = AxiosResponse<FertilizerTo[]>
export type PostFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type ImportFertilizersFromCSV1Result = AxiosResponse<null>
export type GetCropsResult = AxiosResponse<CropTo[]>
export type PostCropResult = AxiosResponse<CropTo>
export type GetCropProductsResult = AxiosResponse<CropProductTo[]>
export type PostCropProductResult = AxiosResponse<CropProductTo>
export type ImportCropsFromCSVResult = AxiosResponse<null>
export type GetCropUseTypesResult = AxiosResponse<CropUseTypeTo[]>
export type PostCropUseTypeResult = AxiosResponse<CropUseTypeTo>
export type ImportSurfaceWaterProtectionZonesResult = AxiosResponse<null>
export type ImportGroundWaterProtectionZonesResult = AxiosResponse<null>
export type ReimportSeedApplicationsResult = AxiosResponse<SeedApplicationV2ReimportResult>
export type SyncCountiesResult = AxiosResponse<null>
export type UpdateNitrateVulnerableResult = AxiosResponse<AdminFarmManagementTo[]>
export type GetNitrateVulnerableOnFarmResult = AxiosResponse<AdminNitrateVulnerableZoneTo[]>
export type PostNitrateVulnerableOnFarmResult = AxiosResponse<AdminNitrateVulnerableZoneTo[]>
export type MigrateCropUseTypeToUuidResult = AxiosResponse<null>
export type MoveParcelValiditiesToNewestSowingResult = AxiosResponse<AdminParcelValidityMoveResult>
export type MoveActionsAfterUpdateResult = AxiosResponse<AdminActionMoveResult>
export type CreateTestEagriFarmResult = AxiosResponse<null>
export type TriggerSyncResult = AxiosResponse<SyncStats>
export type RefreshFarmCacheResult = AxiosResponse<null>
export type GetLpisBlocksResult = AxiosResponse<unknown>
export type UpdateEagriFarmResult = AxiosResponse<unknown>
export type AddSowingPlanToCurrentSeasonResult = AxiosResponse<null>
export type PostSyncResult = AxiosResponse<null>
export type SplitActionResult = AxiosResponse<SplitActionResponse>
export type CreateSowingAction1Result = AxiosResponse<ActionIdTo>
export type CreateMowingAction1Result = AxiosResponse<ActionIdTo>
export type CreateHarvestAction1Result = AxiosResponse<ActionIdTo>
export type CreateEPHAction1Result = AxiosResponse<ActionIdTo>
export type ValidateEPHActionResult = AxiosResponse<ValidationResponseTo>
export type GetSeedApplicationFertilizationResult = AxiosResponse<ParcelAccountableNitrogenTo[]>
export type SplitAction1Result = AxiosResponse<SplitActionResponse>
export type ValidateEPHAction1Result = AxiosResponse<ValidationResponseTo>
export type GetParcelResult = AxiosResponse<ParcelDetailTo>
export type PatchParcelResult = AxiosResponse<null>
export type DeleteZoneResult = AxiosResponse<null>
export type UpdateZoneResult = AxiosResponse<ZoneDetailTo>
export type GetSeedResult = AxiosResponse<CropSeedTo>
export type PatchSeedResult = AxiosResponse<CropSeedTo>
export type PatchCropResult = AxiosResponse<CropTo>
export type GetParcelByArealNameResult = AxiosResponse<PublicParcelTo[]>
export type GetLandingPageResult = AxiosResponse<string>
export type GetDebugPageResult = AxiosResponse<string>
export type GetVisualizationContentResult = AxiosResponse<string>
export type GetCropsInternalResult = AxiosResponse<GetCropsInternal200Item[]>
export type GetParcelSowingPlan1Result = AxiosResponse<InternalSeasonTo[]>
export type GetParcelsResult = AxiosResponse<InternalParcelTo[]>
export type GetParcelDetailResult = AxiosResponse<InternalParcelTo>
export type GetSeedApplicationsResult = AxiosResponse<InternalSeedApplicationTo[]>
export type GetSeedApplicationsByParcelIdsResult = AxiosResponse<InternalSeedApplicationByParcelTo[]>
export type GetFertilizersInternalResult = AxiosResponse<InternalFertilizerTo[]>
export type GetFertilizerMineralIntakeResult = AxiosResponse<InternalFertilizerMineralIntakeResponse>
export type GetFarmDetail1Result = AxiosResponse<InternalFarmResponse>
export type SearchFarmsResult = AxiosResponse<InternalFarmResponse[]>
export type GetCropsInternal1Result = AxiosResponse<InternalCropTo[]>
export type GetCropInternalResult = AxiosResponse<InternalCropTo>
export type GetCropCatalogueTypeResult = AxiosResponse<CatalogueType>
export type GetConnectableSeedApplicationsResult = AxiosResponse<GetConnectableSeedApplications200Item[]>
export type GetSeedApplicationsV2AtDateResult = AxiosResponse<SeedApplicationV2To[]>
export type CheckFertilizerUseReportResult = AxiosResponse<TResponse>
export type GetSowingPlanStatisticsResult = AxiosResponse<SowingPlanSeasonStatisticsTo>
export type GetSeasonsExcelResult = AxiosResponse<Blob>
export type GetSeedApplicationsGeometriesAtDateResult = AxiosResponse<SeedApplicationIntervalsByGeometryTo[]>
export type GetSeedApplicationsAtDateResult = AxiosResponse<SeedApplicationTo[]>
export type GetSeededAreasV2ReportResult = AxiosResponse<string>
export type GetSeedApplicationsV2ReportResult = AxiosResponse<string>
export type GetRevenuesV2ReportResult = AxiosResponse<string>
export type GetNitrateBalanceV2ReportResult = AxiosResponse<Blob>
export type GetSeededAreasResult = AxiosResponse<string>
export type GetSeedApplicationsReportResult = AxiosResponse<string>
export type GetRevenuesReportResult = AxiosResponse<string>
export type GetRestrictionsSowingReportResult = AxiosResponse<ValidationResponseTo>
export type GetPorUsageReportResult = AxiosResponse<string>
export type GetPorConsumptionByPPReportResult = AxiosResponse<string>
export type GetPorConsumptionByCropReportResult = AxiosResponse<string>
export type GetParcels1Result = AxiosResponse<Blob>
export type GetParcels2Result = AxiosResponse<Blob>
export type GetReportsResult = AxiosResponse<ReportHistoryTo[]>
export type GetFertilizerUsageReportResult = AxiosResponse<string>
export type GetFertilizerOrganicReportResult = AxiosResponse<string>
export type GetFertilizerConsumptionReportResult = AxiosResponse<string>
export type GetFertilizerConsumptionByCropReportResult = AxiosResponse<string>
export type GetFarmNitrogenReportResult = AxiosResponse<string>
export type GetCvsReportResult = AxiosResponse<HttpServletResponse>
export type GetEagriPorUseErrorsResult = AxiosResponse<string>
export type CheckFertilizerUserReportResult = AxiosResponse<TResponse>
export type GetActionsReportResult = AxiosResponse<string>
export type GetParcels3Result = AxiosResponse<ParcelTo[]>
export type GetParcelSubtractionHistoryResult = AxiosResponse<SubtractionResponse[]>
export type DeleteParcelSubtractionResult = AxiosResponse<null>
export type GetSeedApplications1Result = AxiosResponse<ParcelSeedApplicationTo[]>
export type GetLastNoCropSeedApplicationWithPlannedCropResult = AxiosResponse<ParcelSeedApplicationWithPlanTo>
export type GetParcelPredecessorsResult = AxiosResponse<ParcelPredecessorTo[]>
export type GetParcelFollowingResult = AxiosResponse<ParcelPredecessorTo[]>
export type GetExchangeCandidatesResult = AxiosResponse<ParcelToV2[]>
export type GetParcelRestrictionsResult = AxiosResponse<ParcelEagriInfoTo>
export type GetWaterParcelDistanceResult = AxiosResponse<ParcelWaterDistanceTo[]>
export type GetParcelsV2Result = AxiosResponse<ParcelToV2[]>
export type GetParcelDetailV2Result = AxiosResponse<ParcelDetailV2To>
export type GetSeedApplicationsV2Result = AxiosResponse<GetSeedApplicationsV2200Item[]>
export type GetActionsV2Result = AxiosResponse<ActionOverviewV2To[]>
export type GetParcelStatisticsV2Result = AxiosResponse<FarmStatisticsTo>
export type GetParcelMapDataV2Result = AxiosResponse<ParcelMapToV2[]>
export type GetParcelSuggestionsResult = AxiosResponse<ParcelSuggestionTo[]>
export type GetParcelStatisticsResult = AxiosResponse<FarmStatisticsTo>
export type GetParcelsForMapResult = AxiosResponse<ParcelMapTo[]>
export type GetParcelsForMapBySeasonResult = AxiosResponse<ParcelMapTo[]>
export type GetLandUseResult = AxiosResponse<LandUseResponse[]>
export type GetParcelCurrentSeedApplicationColorsResult = AxiosResponse<SeedApplicationTo[]>
export type GetCentersResult = AxiosResponse<CenterTo[]>
export type GetActionsAndSeedAppsAtDetailResult = AxiosResponse<ActionGeomOverviewTo[]>
export type GetUserFarmsResult = AxiosResponse<FarmTo[]>
export type GetFarmDetail2Result = AxiosResponse<FarmTo>
export type GetFarmUpdatesResult = AxiosResponse<FarmUpdateFlatResponse[]>
export type GetFarmSettingsResult = AxiosResponse<FarmSettingsTo>
export type GetFullLpisDetailResult = AxiosResponse<EagriDpbPair[]>
export type EagriFarmNameResult = AxiosResponse<EagriAuthValidationResultTo>
export type SearchCountriesResult = AxiosResponse<CountryTo[]>
export type GetCataloguesResult = AxiosResponse<CatalogueTo[]>
export type GetSeedSuggestionsResult = AxiosResponse<CropSeedSuggestionTo[]>
export type GetCropsCatalogSourceResult = AxiosResponse<PrimaryCatalogueTo>
export type GetPlantProtectionDetailResult = AxiosResponse<PlantProtectionDetailTo>
export type GetPlantProtectionDetailApplicationsResult = AxiosResponse<PlantProtectionDetailRegistrationApplicationTo[]>
export type GetPlantProtectionApplicationsResult = AxiosResponse<PlantProtectionApplicationTo[]>
export type GetPlantProtectionSuggestionsResult = AxiosResponse<PlantProtectionSuggestionTo[]>
export type GetPlantProtectionsResult = AxiosResponse<PlantProtectionOverviewTo[]>
export type GetBioFunctionResult = AxiosResponse<string[]>
export type GetFertilizerMineralIntake1Result = AxiosResponse<FertilizerMineralIntakeResponse>
export type GetFertilizerSuggestionsResult = AxiosResponse<FertilizerSuggestionTo[]>
export type GetEagriFertilizerNitrogenCategoryTypeResult = AxiosResponse<EnumEntriesEagriFertilizerNitrogenCategory>
export type GetFertilizerRegistratinTypeResult = AxiosResponse<EagriFertilizerRegistrationTypeTo[]>
export type GetFertilizerNitrogenCategoryResult = AxiosResponse<EagriFertilizerNitrogenCategoryTo[]>
export type GetFertilizerTypesResult = AxiosResponse<EagriFertilizerKindTo[]>
export type GetCropResult = AxiosResponse<CropDetailTo>
export type ExportCropsToCSVResult = AxiosResponse<Blob>
export type GetSyncStatusResult = AxiosResponse<LandscapeSyncStatusTo>
export type GetAllFarmsResult = AxiosResponse<AdminFarmTo[]>
export type GetFullLpisDetail1Result = AxiosResponse<EagriDpbPair[]>
export type GetSyncStatus1Result = AxiosResponse<EagriServiceSyncStatusTo[]>
export type GetActionsResult = AxiosResponse<ActionOverviewTo[]>
export type DeleteActionsResult = AxiosResponse<null>
export type GetActionResult = AxiosResponse<GetAction200>
export type DeleteActionResult = AxiosResponse<null>
export type GetActionV2Result = AxiosResponse<GetActionV2200>
export type GetTargetSeedApplicationResult = AxiosResponse<TargetSeedApplicationV2ResponseTo>
export type GetActionsOverviewV2Result = AxiosResponse<ActionOverviewV2To[]>
export type GetUsedSeedsResult = AxiosResponse<CropSeedSuggestionTo[]>
export type GetUsedPlantProtectionsResult = AxiosResponse<PlantProtectionSuggestionTo[]>
export type GetUsedFertilizersResult = AxiosResponse<FertilizerSuggestionTo[]>
export type TargetSeedApplicationApplicationsResult = AxiosResponse<TargetSeedApplicationActionsResponseTo>
export type GetCropGrowthStagesResult = AxiosResponse<CropGrowthStageTo[]>
export type GetActionTypesResult = AxiosResponse<ActionTypeTo[]>
export type RemoveFromGroupResult = AxiosResponse<null>
export type ResetSeasonResult = AxiosResponse<null>
export type EvictParcelChainCacheEventResult = AxiosResponse<null>
